import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** The `HTML` scalar type represents Hypertext Markup Language, a standardized system for tagging text files to achieve font, color, graphic, and hyperlink effects on World Wide Web pages. */
  HTML: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: { input: any; output: any; }
};

export type ActivateProfilePayload = {
  __typename?: 'ActivateProfilePayload';
  isSuccessful: Scalars['Boolean']['output'];
  profile?: Maybe<Profile>;
};

export type ActivateUserPayload = {
  __typename?: 'ActivateUserPayload';
  isSuccessful: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type ActiveProfileFeatureInput = {
  id: CustomFeatures;
};

export type ActiveProfileInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  features?: InputMaybe<Array<InputMaybe<ActiveProfileFeatureInput>>>;
  id: Scalars['ID']['input'];
  locations: Array<ActiveProfileLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<ProfileSettingsInput>;
};

export type ActiveProfileLocationInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type AddDevicesToChannelInput = {
  channelId: Scalars['String']['input'];
  deviceIds: Array<Scalars['String']['input']>;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddPlaylistsToChannelsInput = {
  channelIds: Array<Scalars['String']['input']>;
  playlistIds: Array<Scalars['String']['input']>;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type Asset = {
  __typename?: 'Asset';
  actualEndTime?: Maybe<Scalars['String']['output']>;
  actualStartTime?: Maybe<Scalars['String']['output']>;
  content: Array<AssetItem>;
  createdAt: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<User>;
  profile?: Maybe<Profile>;
  sequence?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AssetItem = BrowserAsset | HtmlAsset | IFrameAsset | ImageAsset | VideoAsset | WidgetAsset;

export type AssetItemInput = {
  campaignEnd?: InputMaybe<Scalars['String']['input']>;
  campaignStart?: InputMaybe<Scalars['String']['input']>;
  clearData?: InputMaybe<Scalars['Boolean']['input']>;
  contentId?: InputMaybe<Scalars['ID']['input']>;
  days?: InputMaybe<ScheduleDaysInput>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  headlessMode?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  htmlContent?: InputMaybe<Scalars['HTML']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  interactiveLayoutSource?: InputMaybe<Scalars['String']['input']>;
  interactiveRegions?: InputMaybe<Array<InputMaybe<Scalars['JSONObject']['input']>>>;
  name: Scalars['String']['input'];
  publicId?: InputMaybe<Scalars['ID']['input']>;
  resizeCropMethod?: InputMaybe<ResizeCropMethodInput>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  simultaneous?: InputMaybe<Scalars['Boolean']['input']>;
  transitionEffect?: InputMaybe<TransitionEffectInput>;
  type: AssetType;
  uri?: InputMaybe<Scalars['String']['input']>;
  useNativeBrowser?: InputMaybe<Scalars['Boolean']['input']>;
  whiteListDomains?: InputMaybe<Scalars['String']['input']>;
  widgetConfig?: InputMaybe<Scalars['JSONObject']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum AssetType {
  Browser = 'BROWSER',
  Html = 'HTML',
  Iframe = 'IFRAME',
  Image = 'IMAGE',
  Video = 'VIDEO',
  Widget = 'WIDGET'
}

export type Auth0Profile = {
  __typename?: 'Auth0Profile';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_verified?: Maybe<Scalars['Boolean']['output']>;
  family_name?: Maybe<Scalars['String']['output']>;
  given_name?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  multifactor?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  permissions: Array<Permission>;
  picture?: Maybe<Scalars['String']['output']>;
  roles: Array<Role>;
  sub?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id: Scalars['ID']['output'];
  user_metadata?: Maybe<UserMeta>;
};

export type BaseMutationPayload = {
  __typename?: 'BaseMutationPayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type BatteryStatus = {
  __typename?: 'BatteryStatus';
  chargeType?: Maybe<Scalars['String']['output']>;
  isCharging?: Maybe<Scalars['Boolean']['output']>;
  lastChargingTime?: Maybe<Scalars['DateTime']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Brightness = {
  __typename?: 'Brightness';
  brightness1?: Maybe<Scalars['Int']['output']>;
  brightness2?: Maybe<Scalars['Int']['output']>;
  timeFrom1?: Maybe<Scalars['String']['output']>;
  timeFrom2?: Maybe<Scalars['String']['output']>;
};

export type BrowserAsset = {
  __typename?: 'BrowserAsset';
  campaignEnd?: Maybe<Scalars['String']['output']>;
  campaignStart?: Maybe<Scalars['String']['output']>;
  clearData?: Maybe<Scalars['Boolean']['output']>;
  contentId?: Maybe<Scalars['ID']['output']>;
  days?: Maybe<ScheduleDays>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  headlessMode?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  sequence?: Maybe<Scalars['Int']['output']>;
  simultaneous?: Maybe<Scalars['Boolean']['output']>;
  type: AssetType;
  uri?: Maybe<Scalars['String']['output']>;
  useNativeBrowser?: Maybe<Scalars['Boolean']['output']>;
  whiteListDomains?: Maybe<Scalars['String']['output']>;
};

export type BulkActionDevicePayload = {
  __typename?: 'BulkActionDevicePayload';
  devices: Array<Device>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type BulkActionPlaylistInput = {
  channelGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  channelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BulkActionPlaylistUpdateResultPayload = {
  __typename?: 'BulkActionPlaylistUpdateResultPayload';
  isSuccessful: Scalars['Boolean']['output'];
  playlistId: Scalars['String']['output'];
};

export type BulkActionPlaylistsPayload = {
  __typename?: 'BulkActionPlaylistsPayload';
  updateResults: Array<BulkActionPlaylistUpdateResultPayload>;
};

export type BulkNotificationStatusInput = {
  contentTypes: Array<NotificationContentType>;
  ids: Array<Scalars['ID']['input']>;
  isRead: Scalars['Boolean']['input'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type ChangePasswordInput = {
  email: Scalars['String']['input'];
};

export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  isSuccessful: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type ChangeUserMfaInput = {
  enable: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type ChangeUserMfaPayload = {
  __typename?: 'ChangeUserMFAPayload';
  auth0Profile?: Maybe<Auth0Profile>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type Channel = {
  __typename?: 'Channel';
  channelGroups: Array<ChannelGroup>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  devices: Array<Device>;
  eventEnd?: Maybe<Scalars['String']['output']>;
  eventRepeat?: Maybe<Scalars['JSONObject']['output']>;
  eventStart?: Maybe<Scalars['String']['output']>;
  externalContentGenUrl?: Maybe<Scalars['String']['output']>;
  externalContentLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layout?: Maybe<Layout>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  playlistRegions?: Maybe<Array<ChannelPlaylist>>;
  playlists: Array<Playlist>;
  profile?: Maybe<Profile>;
  region?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  type: ChannelType;
  updatedAt: Scalars['DateTime']['output'];
  users: Array<User>;
};


export type ChannelChannelGroupsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ChannelDevicesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ChannelPlaylistsArgs = {
  groupById?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyParentPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus>>;
};

export enum ChannelBulkAction {
  AddScreen = 'ADD_SCREEN',
  AppletReload = 'APPLET_RELOAD',
  AppletUpdateVersion = 'APPLET_UPDATE_VERSION',
  ClearDeviceCache = 'CLEAR_DEVICE_CACHE',
  DeleteChannel = 'DELETE_CHANNEL',
  DisplayOff = 'DISPLAY_OFF',
  DisplayOn = 'DISPLAY_ON',
  Reboot = 'REBOOT',
  RepublishChannel = 'REPUBLISH_CHANNEL',
  ResetPosition = 'RESET_POSITION'
}

export type ChannelDetailNotificationContent = {
  __typename?: 'ChannelDetailNotificationContent';
  coordinates?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `__typename` instead. */
  type: NotificationContentType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChannelGroup = {
  __typename?: 'ChannelGroup';
  channels: Array<Channel>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  playlists: Array<Playlist>;
  profile?: Maybe<Profile>;
  updatedAt: Scalars['DateTime']['output'];
};


export type ChannelGroupChannelsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ChannelGroupPlaylistsArgs = {
  groupById?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyParentPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus>>;
};

export type ChannelPlaylist = {
  __typename?: 'ChannelPlaylist';
  channelId: Scalars['ID']['output'];
  playlistId: Scalars['ID']['output'];
  region?: Maybe<Scalars['String']['output']>;
};

export type ChannelRegionInput = {
  id: Scalars['ID']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelRegionState = {
  __typename?: 'ChannelRegionState';
  id: Scalars['ID']['output'];
  region?: Maybe<Scalars['String']['output']>;
};

export enum ChannelType {
  Channel = 'CHANNEL',
  Event = 'EVENT'
}

export type CloudinaryFile = {
  __typename?: 'CloudinaryFile';
  publicId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CloudinaryFileInput = {
  publicId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CloudinarySignableForm = {
  folder: Scalars['String']['input'];
  invalidate?: InputMaybe<Scalars['Boolean']['input']>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  public_id?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  timestamp: Scalars['Int']['input'];
  upload_preset: Scalars['String']['input'];
};

export type CloudinarySignature = {
  __typename?: 'CloudinarySignature';
  signature?: Maybe<Scalars['String']['output']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type CreateAssetInput = {
  content?: InputMaybe<Array<AssetItemInput>>;
  name: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
};

export type CreateAssetPayload = {
  __typename?: 'CreateAssetPayload';
  asset?: Maybe<Asset>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type CreateChannelGroupInput = {
  channelIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
};

export type CreateChannelGroupPayload = {
  __typename?: 'CreateChannelGroupPayload';
  channelGroup?: Maybe<ChannelGroup>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type CreateChannelInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  eventDeviceId?: InputMaybe<Scalars['ID']['input']>;
  eventEnd?: InputMaybe<Scalars['String']['input']>;
  eventRepeat?: InputMaybe<Scalars['JSONObject']['input']>;
  eventStart?: InputMaybe<Scalars['String']['input']>;
  layoutId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['String']['input'];
  provisionDeviceInput?: InputMaybe<ProvisionDeviceInput>;
  tag?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ChannelType>;
};

export type CreateChannelPayload = {
  __typename?: 'CreateChannelPayload';
  channel?: Maybe<Channel>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type CreateFolderInput = {
  folderType?: InputMaybe<FolderType>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parentFolderId?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['String']['input'];
};

export type CreateFolderPayload = {
  __typename?: 'CreateFolderPayload';
  folder?: Maybe<Folder>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type CreateLayoutInput = {
  channelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type CreateLayoutPayload = {
  __typename?: 'CreateLayoutPayload';
  isSuccessful: Scalars['Boolean']['output'];
  layout?: Maybe<Layout>;
};

export type CreateLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<LocationCoordinatesInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  streetAddress1?: InputMaybe<Scalars['String']['input']>;
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLocationPayload = {
  __typename?: 'CreateLocationPayload';
  isSuccessful: Scalars['Boolean']['output'];
  location?: Maybe<Location>;
};

export type CreateOrganizationInput = {
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateOrganizationPayload = {
  __typename?: 'CreateOrganizationPayload';
  isSuccessful: Scalars['Boolean']['output'];
  organization?: Maybe<Organization>;
};

export type CreatePlaylistInput = {
  channelGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelIds?: InputMaybe<Array<ChannelRegionInput>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
  saveOption: SaveOption;
  schedules?: InputMaybe<Array<ScheduleInput>>;
  source?: InputMaybe<PlaylistSource>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<PlaylistType>;
  zone?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePlaylistPayload = {
  __typename?: 'CreatePlaylistPayload';
  isSuccessful: Scalars['Boolean']['output'];
  playlist?: Maybe<Playlist>;
};

export type CreateProfileInput = {
  creatorRoleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  locationInput: CreateLocationInput;
  name: Scalars['String']['input'];
  organizationUid?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['ID']['input'];
  settings?: InputMaybe<ProfileSettingsInput>;
  userIds: Array<Scalars['ID']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProfilePayload = {
  __typename?: 'CreateProfilePayload';
  isSuccessful: Scalars['Boolean']['output'];
  profile?: Maybe<Profile>;
};

export type CreateResourceGroupInput = {
  name: Scalars['String']['input'];
  playlistIds?: InputMaybe<Array<Scalars['String']['input']>>;
  profileId: Scalars['String']['input'];
  users?: InputMaybe<Array<ResourceGroupUserInput>>;
};

export type CreateResourceGroupPayload = {
  __typename?: 'CreateResourceGroupPayload';
  isSuccessful: Scalars['Boolean']['output'];
  resourceGroup?: Maybe<ResourceGroup>;
};

export type CreateUserInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  email?: Maybe<Scalars['String']['output']>;
  isSuccessful: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
};

export type CurrentTime = {
  __typename?: 'CurrentTime';
  currentDate?: Maybe<Scalars['DateTime']['output']>;
  ntpServer?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['DateTime']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum CustomFeatures {
  AdvancedScheduler = 'ADVANCED_SCHEDULER',
  ChannelToUser = 'CHANNEL_TO_USER',
  EventChannels = 'EVENT_CHANNELS',
  LayoutRegions = 'LAYOUT_REGIONS',
  SpotPlaylists = 'SPOT_PLAYLISTS',
  UserMfa = 'USER_MFA'
}

export type DeactivateProfilePayload = {
  __typename?: 'DeactivateProfilePayload';
  isSuccessful: Scalars['Boolean']['output'];
  profile?: Maybe<Profile>;
};

export type DeactivateUserInput = {
  active: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type DeactivateUserPayload = {
  __typename?: 'DeactivateUserPayload';
  isSuccessful: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type DeleteAssetPayload = {
  __typename?: 'DeleteAssetPayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type DeleteChannelGroupPayload = {
  __typename?: 'DeleteChannelGroupPayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type DeleteChannelPayload = {
  __typename?: 'DeleteChannelPayload';
  isSuccessful: Scalars['Boolean']['output'];
  rowsAffected: Scalars['Int']['output'];
};

export type DeleteDeprovisionedDevicePayload = {
  __typename?: 'DeleteDeprovisionedDevicePayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type DeleteDevicePayload = {
  __typename?: 'DeleteDevicePayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type DeleteFolderPayload = {
  __typename?: 'DeleteFolderPayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type DeleteLayoutPayload = {
  __typename?: 'DeleteLayoutPayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type DeleteLocationInput = {
  id: Scalars['ID']['input'];
  newLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteLocationPayload = {
  __typename?: 'DeleteLocationPayload';
  isSuccessful: Scalars['Boolean']['output'];
  location?: Maybe<Location>;
};

export type DeleteMediaPayload = {
  __typename?: 'DeleteMediaPayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type DeleteOrganizationPayload = {
  __typename?: 'DeleteOrganizationPayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type DeletePlaylistPayload = {
  __typename?: 'DeletePlaylistPayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type DeletePlaylistsPayload = {
  __typename?: 'DeletePlaylistsPayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type DeleteProfilePayload = {
  __typename?: 'DeleteProfilePayload';
  isSuccessful: Scalars['Boolean']['output'];
  profile?: Maybe<Profile>;
};

export type DeleteResourceGroupPayload = {
  __typename?: 'DeleteResourceGroupPayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type Derived = {
  __typename?: 'Derived';
  bytes: Scalars['Int']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  secure_url?: Maybe<Scalars['String']['output']>;
  transformation: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Device = {
  __typename?: 'Device';
  advancedSettings?: Maybe<DeviceAdvancedSettings>;
  application?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Channel>;
  channelId?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Coordinates>;
  createdAt: Scalars['DateTime']['output'];
  deviceInfo?: Maybe<DeviceInfo>;
  events?: Maybe<Array<Channel>>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  latestPing?: Maybe<DevicePing>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  monitorHistory?: Maybe<Array<DeviceMonitorRecord>>;
  name: Scalars['String']['output'];
  pings: Array<DevicePing>;
  playlists: Array<Playlist>;
  profile?: Maybe<Profile>;
  resolution?: Maybe<Resolution>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  signageOSDevice?: Maybe<SignageOsDevice>;
  signageOSDeviceTiming?: Maybe<SignageOsDeviceTiming>;
  statusHistory?: Maybe<Array<DeviceStatusRecord>>;
  uid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};


export type DevicePlaylistsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  onlyParentPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus>>;
};

export type DeviceAdvancedSettings = {
  __typename?: 'DeviceAdvancedSettings';
  appletVersion?: Maybe<Scalars['String']['output']>;
  flipScreenshot?: Maybe<Scalars['Boolean']['output']>;
  kioskMode?: Maybe<Scalars['Boolean']['output']>;
  kioskModeGraceSecs?: Maybe<Scalars['Int']['output']>;
  manualSyncGroup?: Maybe<Scalars['Boolean']['output']>;
  masterSyncDelay?: Maybe<Scalars['Int']['output']>;
  ntpServer?: Maybe<Scalars['String']['output']>;
  orientation?: Maybe<DeviceOrientation>;
  rebootTime?: Maybe<Scalars['String']['output']>;
  scheduleBrightness?: Maybe<DualBrightnessConfig>;
  scheduleDailyReboot?: Maybe<Scalars['Boolean']['output']>;
  scheduleDisplay?: Maybe<Array<ScheduleDisplay>>;
  setBrightness2?: Maybe<Scalars['Boolean']['output']>;
  syncGroup?: Maybe<Scalars['String']['output']>;
  synchronize?: Maybe<Scalars['Boolean']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
};

export type DeviceAdvancedSettingsInput = {
  flipScreenshot?: InputMaybe<Scalars['Boolean']['input']>;
  kioskMode?: InputMaybe<Scalars['Boolean']['input']>;
  kioskModeGraceSecs?: InputMaybe<Scalars['Int']['input']>;
  manualSyncGroup?: InputMaybe<Scalars['Boolean']['input']>;
  masterSyncDelay?: InputMaybe<Scalars['Int']['input']>;
  rebootTime?: InputMaybe<Scalars['String']['input']>;
  scheduleBrightness?: InputMaybe<DualBrightnessConfigInput>;
  scheduleDailyReboot?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleDisplay?: InputMaybe<Array<ScheduleDisplayInput>>;
  setBrightness2?: InputMaybe<Scalars['Boolean']['input']>;
  syncGroup?: InputMaybe<Scalars['String']['input']>;
  synchronize?: InputMaybe<Scalars['Boolean']['input']>;
  volume?: InputMaybe<Scalars['Int']['input']>;
};

export enum DeviceBulkAction {
  DeviceAppletReload = 'DEVICE_APPLET_RELOAD',
  DeviceAppletUpdateVersion = 'DEVICE_APPLET_UPDATE_VERSION',
  DeviceClearCache = 'DEVICE_CLEAR_CACHE',
  DeviceDisplayOff = 'DEVICE_DISPLAY_OFF',
  DeviceDisplayOn = 'DEVICE_DISPLAY_ON',
  DeviceReboot = 'DEVICE_REBOOT'
}

export type DeviceDeletionNotificationContent = {
  __typename?: 'DeviceDeletionNotificationContent';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `__typename` instead. */
  type: NotificationContentType;
};

export type DeviceDetailNotificationContent = {
  __typename?: 'DeviceDetailNotificationContent';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `__typename` instead. */
  type: NotificationContentType;
};

export enum DeviceHealthStatus {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Outdated = 'OUTDATED'
}

export type DeviceInfo = {
  __typename?: 'DeviceInfo';
  appletVersion?: Maybe<Scalars['String']['output']>;
  applicationType?: Maybe<Scalars['String']['output']>;
  applicationVersion?: Maybe<Scalars['String']['output']>;
  batteryStatus?: Maybe<BatteryStatus>;
  cpu?: Maybe<Scalars['Float']['output']>;
  currentTime?: Maybe<CurrentTime>;
  deviceId?: Maybe<Scalars['String']['output']>;
  firmware?: Maybe<Scalars['String']['output']>;
  kioskMode?: Maybe<Scalars['Boolean']['output']>;
  kioskModeGraceSecs?: Maybe<Scalars['Int']['output']>;
  loadedPlaylists?: Maybe<Array<Scalars['String']['output']>>;
  model?: Maybe<Scalars['String']['output']>;
  networkAdapters?: Maybe<Array<Maybe<NetworkInterface>>>;
  networkInfo?: Maybe<NetworkInfo>;
  screen?: Maybe<ScreenInfo>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
};

export type DeviceMonitorRecord = {
  __typename?: 'DeviceMonitorRecord';
  cpu?: Maybe<Scalars['Float']['output']>;
  temp?: Maybe<Scalars['Float']['output']>;
  ts?: Maybe<Scalars['DateTime']['output']>;
};

export enum DeviceOrientation {
  Auto = 'Auto',
  Landscape = 'Landscape',
  LandscapeFlipped = 'LandscapeFlipped',
  Portrait = 'Portrait',
  PortraitFlipped = 'PortraitFlipped'
}

export type DevicePing = {
  __typename?: 'DevicePing';
  id?: Maybe<Scalars['ID']['output']>;
  playlistsInfo?: Maybe<Array<PlaylistInfo>>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export enum DevicePowerAction {
  AppRestart = 'AppRestart',
  AppletDisable = 'AppletDisable',
  AppletEnable = 'AppletEnable',
  AppletRefresh = 'AppletRefresh',
  AppletReload = 'AppletReload',
  DisplayPowerOff = 'DisplayPowerOff',
  DisplayPowerOn = 'DisplayPowerOn',
  SystemReboot = 'SystemReboot'
}

export enum DeviceResolution {
  FullHd = 'FullHD',
  HdReady = 'HDReady'
}

export type DeviceStatusNotificationContent = {
  __typename?: 'DeviceStatusNotificationContent';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `__typename` instead. */
  type: NotificationContentType;
};

export type DeviceStatusRecord = {
  __typename?: 'DeviceStatusRecord';
  online?: Maybe<Scalars['Boolean']['output']>;
  ts?: Maybe<Scalars['DateTime']['output']>;
};

export enum DeviceStatusType {
  Danger = 'DANGER',
  Ok = 'OK',
  Warning = 'WARNING'
}

export type DualBrightnessConfig = {
  __typename?: 'DualBrightnessConfig';
  brightness1?: Maybe<Scalars['Float']['output']>;
  brightness2?: Maybe<Scalars['Float']['output']>;
  time1?: Maybe<Scalars['String']['output']>;
  time2?: Maybe<Scalars['String']['output']>;
};

export type DualBrightnessConfigInput = {
  brightness1: Scalars['Float']['input'];
  brightness2: Scalars['Float']['input'];
  time1: Scalars['String']['input'];
  time2: Scalars['String']['input'];
};

export type DummySubscriptionPayload = {
  __typename?: 'DummySubscriptionPayload';
  dummy?: Maybe<Scalars['String']['output']>;
};

export type DuplicatePlaylistPayload = {
  __typename?: 'DuplicatePlaylistPayload';
  isSuccessful: Scalars['Boolean']['output'];
  playlistIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EventFilter = {
  __typename?: 'EventFilter';
  from?: Maybe<Scalars['DateTime']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  search?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type Feature = {
  __typename?: 'Feature';
  id: CustomFeatures;
};

export type FilterOptionsInput = {
  contentTypes?: InputMaybe<Array<NotificationContentType>>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Folder = {
  __typename?: 'Folder';
  createdBy: Scalars['String']['output'];
  folderType?: Maybe<FolderType>;
  fullPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  medias?: Maybe<Array<Media>>;
  name: Scalars['String']['output'];
  parentFolderId?: Maybe<Scalars['String']['output']>;
  profileId: Scalars['String']['output'];
};

export enum FolderGroupType {
  Profile = 'PROFILE',
  User = 'USER'
}

export enum FolderType {
  Trash = 'TRASH'
}

export type HtmlAsset = {
  __typename?: 'HtmlAsset';
  campaignEnd?: Maybe<Scalars['String']['output']>;
  campaignStart?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['ID']['output']>;
  days?: Maybe<ScheduleDays>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  htmlContent?: Maybe<Scalars['HTML']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  sequence?: Maybe<Scalars['Int']['output']>;
  simultaneous?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `__typename` instead. */
  type: AssetType;
};

export type IFrameAsset = {
  __typename?: 'IFrameAsset';
  campaignEnd?: Maybe<Scalars['String']['output']>;
  campaignStart?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['ID']['output']>;
  days?: Maybe<ScheduleDays>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  sequence?: Maybe<Scalars['Int']['output']>;
  simultaneous?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `__typename` instead. */
  type: AssetType;
  uri?: Maybe<Scalars['String']['output']>;
};

export type ImageAsset = {
  __typename?: 'ImageAsset';
  campaignEnd?: Maybe<Scalars['String']['output']>;
  campaignStart?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['ID']['output']>;
  days?: Maybe<ScheduleDays>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  interactiveLayoutSource?: Maybe<Scalars['String']['output']>;
  interactiveRegions?: Maybe<Array<Maybe<SmilRegion>>>;
  media?: Maybe<Media>;
  name: Scalars['String']['output'];
  publicId?: Maybe<Scalars['ID']['output']>;
  resizeCropMethod?: Maybe<ResizeCropMethod>;
  sequence?: Maybe<Scalars['Int']['output']>;
  simultaneous?: Maybe<Scalars['Boolean']['output']>;
  transitionEffect?: Maybe<TransitionEffect>;
  type: AssetType;
  uri?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type InitDeviceInput = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
};

export type InitDevicePayload = {
  __typename?: 'InitDevicePayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type InviteUserInput = {
  email: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
  roleIds: Array<Scalars['ID']['input']>;
};

export type InviteUserPayload = {
  __typename?: 'InviteUserPayload';
  isSuccessful: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Layout = {
  __typename?: 'Layout';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profile?: Maybe<Profile>;
  public?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<LayoutEditorSource>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LayoutEditorCanvas = {
  __typename?: 'LayoutEditorCanvas';
  height?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type LayoutEditorSource = {
  __typename?: 'LayoutEditorSource';
  canvas?: Maybe<LayoutEditorCanvas>;
  cloudinaryPublicId?: Maybe<Scalars['String']['output']>;
  regionBlocks?: Maybe<Array<Maybe<SmilRegion>>>;
  sceneUrl?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  channels?: Maybe<Array<Channel>>;
  city?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Coordinates>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  devices?: Maybe<Array<Device>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  playlists?: Maybe<Array<Playlist>>;
  profile?: Maybe<Profile>;
  region?: Maybe<Scalars['String']['output']>;
  streetAddress1?: Maybe<Scalars['String']['output']>;
  streetAddress2?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type LocationChannelsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type LocationDevicesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type LocationPlaylistsArgs = {
  groupById?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyParentPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus>>;
};

export type LocationCoordinatesInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type LocationDetailNotificationContent = {
  __typename?: 'LocationDetailNotificationContent';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  streetAddress1?: Maybe<Scalars['String']['output']>;
  streetAddress2?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `__typename` instead. */
  type: NotificationContentType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type LoginInput = {
  password: Scalars['String']['input'];
  usernameOrEmail: Scalars['String']['input'];
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Media = {
  __typename?: 'Media';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  folderId?: Maybe<Scalars['ID']['output']>;
  history?: Maybe<Array<Maybe<CloudinaryFile>>>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<MediaMetadata>;
  name: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['ID']['output']>;
  publicId: Scalars['String']['output'];
  secureUrl: Scalars['String']['output'];
  source?: Maybe<CloudinaryFile>;
  type: ResourceType;
  url: Scalars['String']['output'];
  visibility: MediaVisibilityType;
};

export enum MediaBulkAction {
  DeleteMedia = 'DELETE_MEDIA',
  MoveSelected = 'MOVE_SELECTED'
}

export type MediaCaptureInput = {
  height?: InputMaybe<Scalars['String']['input']>;
  rrule?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type MediaFiltersInput = {
  folderId?: InputMaybe<Scalars['String']['input']>;
  mediaVisibility?: InputMaybe<Array<MediaVisibilityType>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  resourceType?: InputMaybe<Array<ResourceType>>;
};

export type MediaMetadata = {
  __typename?: 'MediaMetadata';
  accessControl?: Maybe<Scalars['String']['output']>;
  accessMode?: Maybe<Scalars['String']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  backupBytes?: Maybe<Scalars['Int']['output']>;
  bytes?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  derived?: Maybe<Array<Derived>>;
  duration?: Maybe<Scalars['Float']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  folder?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  pages?: Maybe<Scalars['Int']['output']>;
  pixels?: Maybe<Scalars['Int']['output']>;
  publicId?: Maybe<Scalars['String']['output']>;
  resourceType?: Maybe<Scalars['String']['output']>;
  secureUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type MediaMetadataSearch = {
  __typename?: 'MediaMetadataSearch';
  rateLimitAllowed?: Maybe<Scalars['Int']['output']>;
  rateLimitRemaining?: Maybe<Scalars['Int']['output']>;
  ratelimitResetAt?: Maybe<Scalars['DateTime']['output']>;
  resources: Array<MediaMetadata>;
  time?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MediaOptionsInput = {
  orderBy?: InputMaybe<MediaOrderByInput>;
};

export type MediaOrderByInput = {
  column: Scalars['String']['input'];
  direction: OrderByQueryOptions;
};

export type MediaUploadFailedNotificationContent = {
  __typename?: 'MediaUploadFailedNotificationContent';
  filepath?: Maybe<Scalars['String']['output']>;
  folder?: Maybe<Scalars['String']['output']>;
  folderGroupType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  resourceType?: Maybe<Scalars['String']['output']>;
  tempFilename?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `__typename` instead. */
  type: NotificationContentType;
};

export type MediaUploadLargeNotificationContent = {
  __typename?: 'MediaUploadLargeNotificationContent';
  folder?: Maybe<Scalars['String']['output']>;
  folderGroupType?: Maybe<FolderGroupType>;
  name?: Maybe<Scalars['String']['output']>;
  publicId?: Maybe<Scalars['ID']['output']>;
  resourceType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `__typename` instead. */
  type: NotificationContentType;
};

export type MediaUploadNotificationContent = {
  __typename?: 'MediaUploadNotificationContent';
  folder?: Maybe<Scalars['String']['output']>;
  folderGroupType?: Maybe<FolderGroupType>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  resourceType?: Maybe<Scalars['String']['output']>;
  secureUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `__typename` instead. */
  type: NotificationContentType;
  url?: Maybe<Scalars['String']['output']>;
};

export enum MediaVisibilityType {
  Default = 'DEFAULT',
  Playlist = 'PLAYLIST',
  Template = 'TEMPLATE'
}

export type MetadataInput = {
  bytes?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type MoveFolderListToFolderPayload = {
  __typename?: 'MoveFolderListToFolderPayload';
  affectedRows?: Maybe<Scalars['Int']['output']>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type MoveMediaFolderInput = {
  folderId?: InputMaybe<Scalars['String']['input']>;
  mediaIds: Array<Scalars['String']['input']>;
};

export type MoveMediaFolderPayload = {
  __typename?: 'MoveMediaFolderPayload';
  isSuccessful: Scalars['Boolean']['output'];
  medias?: Maybe<Array<Maybe<Media>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** @deprecated No longer supported */
  _dummy?: Maybe<Scalars['String']['output']>;
  activateProfile: ActivateProfilePayload;
  activateUser: ActivateUserPayload;
  addDevicesToChannel: UpdateChannelPayload;
  addPlaylistsToChannels: UpdateChannelPayload;
  assignChannelPlaylistRegion: UpdatePlaylistRegionPayload;
  bulkActionDevices: BulkActionDevicePayload;
  bulkActionPlaylists: BulkActionPlaylistsPayload;
  changePassword: ChangePasswordPayload;
  changeUserMFA: ChangeUserMfaPayload;
  createAsset: CreateAssetPayload;
  createChannel: CreateChannelPayload;
  createChannelGroup: CreateChannelGroupPayload;
  createFolder?: Maybe<CreateFolderPayload>;
  createLayout: CreateLayoutPayload;
  createLocation: CreateLocationPayload;
  createOrganization: CreateOrganizationPayload;
  createPlaylist: CreatePlaylistPayload;
  createProfile: CreateProfilePayload;
  createResourceGroup: CreateResourceGroupPayload;
  createUser: CreateUserPayload;
  deactivateProfile: DeactivateProfilePayload;
  deactivateUser: DeactivateUserPayload;
  deleteAsset: DeleteAssetPayload;
  deleteChannel: DeleteChannelPayload;
  deleteChannelGroup: DeleteChannelGroupPayload;
  deleteDeprovisionedDevice: DeleteDeprovisionedDevicePayload;
  deleteDevice: DeleteDevicePayload;
  deleteFolder: DeleteFolderPayload;
  deleteFolderList: DeleteFolderPayload;
  deleteLayout: DeleteLayoutPayload;
  deleteLocation: DeleteLocationPayload;
  deleteMedia: DeleteMediaPayload;
  deleteMediaList: DeleteMediaPayload;
  deleteOrganization: DeleteOrganizationPayload;
  deletePlaylist: DeletePlaylistPayload;
  deletePlaylists: DeletePlaylistPayload;
  deleteProfile: DeleteProfilePayload;
  deleteResourceGroup: DeleteResourceGroupPayload;
  duplicatePlaylists: DuplicatePlaylistPayload;
  initDevice: InitDevicePayload;
  inviteUser: InviteUserPayload;
  login?: Maybe<LoginPayload>;
  moveFolderListToFolder?: Maybe<MoveFolderListToFolderPayload>;
  moveMediaFolder?: Maybe<MoveMediaFolderPayload>;
  powerAction: PowerActionPayload;
  provisionDevice: ProvisionDevicePayload;
  publishChannels?: Maybe<BaseMutationPayload>;
  register?: Maybe<RegisterPayload>;
  removeDevicesFromChannel: UpdateChannelPayload;
  removePlaylistsFromChannel: RemovePlaylistsFromChannelPayload;
  removeProfileUser: RemoveProfileUserPayload;
  resolutionAction: ResolutionActionPayload;
  saveMedia: SaveMediaPayload;
  saveNotification: SaveNotificationPayload;
  setActiveProfile?: Maybe<Profile>;
  setIsInitializingApp?: Maybe<Scalars['Boolean']['output']>;
  setSelectedAssets?: Maybe<Array<Asset>>;
  setSelectedChannel?: Maybe<Channel>;
  setSelectedDevice?: Maybe<Device>;
  updateAsset: UpdateAssetPayload;
  updateBulkNotificationStatus: UpdateBulkNotificationStatusPayload;
  updateChannel: UpdateChannelPayload;
  updateChannelGroup: UpdateChannelGroupPayload;
  updateChannelUsers: UpdateChannelUsersPayload;
  updateDevice: UpdateDevicePayload;
  updateDeviceCoordinates: UpdateDeviceCoordinatesPayload;
  updateFolder?: Maybe<UpdateFolderPayload>;
  updateLayout: UpdateLayoutPayload;
  updateLocation: UpdateLocationPayload;
  updateMedia: UpdateMediaPayload;
  updateNotificationStatus: SaveNotificationPayload;
  updateOrganization: UpdateOrganizationPayload;
  updatePlaylist: UpdatePlaylistPayload;
  updateProfile: UpdateProfilePayload;
  updateProfileUserRole: RemoveProfileUserPayload;
  updateResourceGroup: UpdateResourceGroupPayload;
  updateUser: UpdateUserPayload;
  updateUserChannels: UpdateUserChannelsPayload;
  verifyDevice: VerifyDevicePayload;
};


export type MutationActivateProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddDevicesToChannelArgs = {
  input: AddDevicesToChannelInput;
};


export type MutationAddPlaylistsToChannelsArgs = {
  input?: InputMaybe<AddPlaylistsToChannelsInput>;
};


export type MutationAssignChannelPlaylistRegionArgs = {
  input: UpdatePlaylistRegionInput;
};


export type MutationBulkActionDevicesArgs = {
  action: ChannelBulkAction;
  extra?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['String']['input']>;
};


export type MutationBulkActionPlaylistsArgs = {
  action: PlaylistBulkAction;
  ids: Array<Scalars['String']['input']>;
  input: BulkActionPlaylistInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChangeUserMfaArgs = {
  input: ChangeUserMfaInput;
};


export type MutationCreateAssetArgs = {
  input: CreateAssetInput;
};


export type MutationCreateChannelArgs = {
  input: CreateChannelInput;
};


export type MutationCreateChannelGroupArgs = {
  input: CreateChannelGroupInput;
};


export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};


export type MutationCreateLayoutArgs = {
  input: CreateLayoutInput;
};


export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreatePlaylistArgs = {
  input: CreatePlaylistInput;
};


export type MutationCreateProfileArgs = {
  input: CreateProfileInput;
};


export type MutationCreateResourceGroupArgs = {
  input: CreateResourceGroupInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeactivateProfileArgs = {
  deleteOn: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeactivateUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChannelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChannelGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDeprovisionedDeviceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDeviceArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};


export type MutationDeleteFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFolderListArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteLayoutArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLocationArgs = {
  input: DeleteLocationInput;
};


export type MutationDeleteMediaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMediaListArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlaylistArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlaylistsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResourceGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicatePlaylistsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationInitDeviceArgs = {
  input: InitDeviceInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMoveFolderListToFolderArgs = {
  destinationFolderId?: InputMaybe<Scalars['ID']['input']>;
  folderIds: Array<Scalars['ID']['input']>;
};


export type MutationMoveMediaFolderArgs = {
  input: MoveMediaFolderInput;
};


export type MutationPowerActionArgs = {
  devicePowerAction: DevicePowerAction;
  uid: Scalars['ID']['input'];
};


export type MutationProvisionDeviceArgs = {
  input: ProvisionDeviceInput;
};


export type MutationPublishChannelsArgs = {
  input?: InputMaybe<PublishChannelsInput>;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRemoveDevicesFromChannelArgs = {
  input: AddDevicesToChannelInput;
};


export type MutationRemovePlaylistsFromChannelArgs = {
  input: RemovePlaylistsFromChannelInput;
};


export type MutationRemoveProfileUserArgs = {
  input: RemoveProfileUserInput;
};


export type MutationResolutionActionArgs = {
  orientation: DeviceOrientation;
  resolution: DeviceResolution;
  uid: Scalars['ID']['input'];
};


export type MutationSaveMediaArgs = {
  input: SaveMediaInput;
};


export type MutationSaveNotificationArgs = {
  input: NotificationInput;
};


export type MutationSetActiveProfileArgs = {
  input?: InputMaybe<ActiveProfileInput>;
};


export type MutationSetIsInitializingAppArgs = {
  input?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetSelectedAssetsArgs = {
  input?: InputMaybe<Array<SelectedAssetInput>>;
};


export type MutationSetSelectedChannelArgs = {
  input?: InputMaybe<SelectedChannelInput>;
};


export type MutationSetSelectedDeviceArgs = {
  input?: InputMaybe<SelectedDeviceInput>;
};


export type MutationUpdateAssetArgs = {
  input: UpdateAssetInput;
};


export type MutationUpdateBulkNotificationStatusArgs = {
  input: BulkNotificationStatusInput;
};


export type MutationUpdateChannelArgs = {
  input: UpdateChannelInput;
};


export type MutationUpdateChannelGroupArgs = {
  input: UpdateChannelGroupInput;
};


export type MutationUpdateChannelUsersArgs = {
  input: UpdateChannelUsersInput;
};


export type MutationUpdateDeviceArgs = {
  input: UpdateDeviceInput;
};


export type MutationUpdateDeviceCoordinatesArgs = {
  input: UpdateDeviceCoordinatesInput;
};


export type MutationUpdateFolderArgs = {
  input: UpdateFolderInput;
};


export type MutationUpdateLayoutArgs = {
  input: UpdateLayoutInput;
};


export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
};


export type MutationUpdateMediaArgs = {
  input: UpdateMediaInput;
};


export type MutationUpdateNotificationStatusArgs = {
  input: NotificationStatusInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdatePlaylistArgs = {
  input: UpdatePlaylistInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateProfileUserRoleArgs = {
  input: UpdateProfileUserRoleInput;
};


export type MutationUpdateResourceGroupArgs = {
  input: UpdateResourceGroupInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserChannelsArgs = {
  input: UpdateUserChannelsInput;
};


export type MutationVerifyDeviceArgs = {
  input: VerifyDeviceInput;
};

export type NetworkInfo = {
  __typename?: 'NetworkInfo';
  activeInterface?: Maybe<Scalars['String']['output']>;
  dns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ethernetMacAddress?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<Scalars['String']['output']>;
  interfaceName?: Maybe<Scalars['String']['output']>;
  localAddress?: Maybe<Scalars['String']['output']>;
  netmask?: Maybe<Scalars['String']['output']>;
  wifiMacAddress?: Maybe<Scalars['String']['output']>;
};

export type NetworkInterface = {
  __typename?: 'NetworkInterface';
  disabled?: Maybe<Scalars['Boolean']['output']>;
  dns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  gateway?: Maybe<Scalars['String']['output']>;
  localAddress?: Maybe<Scalars['String']['output']>;
  macAddress: Scalars['String']['output'];
  name: Scalars['String']['output'];
  netmask?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  wifiSsid?: Maybe<Scalars['String']['output']>;
  wifiStrength?: Maybe<Scalars['Int']['output']>;
};

export type Node = {
  __typename?: 'Node';
  id: Scalars['ID']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  content: NotificationContent;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['ID']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type NotificationContent = ChannelDetailNotificationContent | DeviceDeletionNotificationContent | DeviceDetailNotificationContent | DeviceStatusNotificationContent | LocationDetailNotificationContent | MediaUploadFailedNotificationContent | MediaUploadLargeNotificationContent | MediaUploadNotificationContent;

export type NotificationContentInput = {
  filepath?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['String']['input']>;
  folderGroupType?: InputMaybe<FolderGroupType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  secureUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tempFilename?: InputMaybe<Scalars['String']['input']>;
  type: NotificationContentType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum NotificationContentType {
  ChannelDetailChanged = 'CHANNEL_DETAIL_CHANGED',
  DeviceCreated = 'DEVICE_CREATED',
  DeviceDeleted = 'DEVICE_DELETED',
  DeviceDetailChanged = 'DEVICE_DETAIL_CHANGED',
  DeviceStatusChanged = 'DEVICE_STATUS_CHANGED',
  LocationDetailChanged = 'LOCATION_DETAIL_CHANGED',
  MediaUploaded = 'MEDIA_UPLOADED',
  MediaUploadFailed = 'MEDIA_UPLOAD_FAILED',
  MediaUploadPending = 'MEDIA_UPLOAD_PENDING'
}

export type NotificationInput = {
  content: NotificationContentInput;
  message?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type NotificationStatusInput = {
  id: Scalars['ID']['input'];
  isRead: Scalars['Boolean']['input'];
};

export enum OrderByQueryOptions {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Organization = {
  __typename?: 'Organization';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  devices?: Maybe<Array<Device>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationUid?: Maybe<Scalars['String']['output']>;
  profiles?: Maybe<PaginatedProfiles>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type OrganizationDevicesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationProfilesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedAssets = {
  __typename?: 'PaginatedAssets';
  results: Array<Asset>;
  total: Scalars['Int']['output'];
};

export type PaginatedChannelGroup = {
  __typename?: 'PaginatedChannelGroup';
  results: Array<ChannelGroup>;
  total: Scalars['Int']['output'];
};

export type PaginatedChannels = {
  __typename?: 'PaginatedChannels';
  results: Array<Channel>;
  total: Scalars['Int']['output'];
};

export type PaginatedDevicePings = {
  __typename?: 'PaginatedDevicePings';
  results: Array<DevicePing>;
  total: Scalars['Int']['output'];
};

export type PaginatedDevices = {
  __typename?: 'PaginatedDevices';
  results: Array<Device>;
  total: Scalars['Int']['output'];
};

export type PaginatedFolders = {
  __typename?: 'PaginatedFolders';
  results: Array<Folder>;
  total: Scalars['Int']['output'];
};

export type PaginatedLocations = {
  __typename?: 'PaginatedLocations';
  results: Array<Location>;
  total: Scalars['Int']['output'];
};

export type PaginatedMedia = {
  __typename?: 'PaginatedMedia';
  results: Array<Media>;
  total: Scalars['Int']['output'];
};

export type PaginatedNotifications = {
  __typename?: 'PaginatedNotifications';
  results: Array<Notification>;
  total: Scalars['Int']['output'];
};

export type PaginatedOrganizations = {
  __typename?: 'PaginatedOrganizations';
  results: Array<Organization>;
  total: Scalars['Int']['output'];
};

export type PaginatedPlaylists = {
  __typename?: 'PaginatedPlaylists';
  results: Array<Playlist>;
  total: Scalars['Int']['output'];
};

export type PaginatedProfiles = {
  __typename?: 'PaginatedProfiles';
  results: Array<Profile>;
  total: Scalars['Int']['output'];
};

export type PaginatedResourceGroups = {
  __typename?: 'PaginatedResourceGroups';
  results: Array<ResourceGroup>;
  total: Scalars['Int']['output'];
};

export type PaginatedUsers = {
  __typename?: 'PaginatedUsers';
  results: Array<User>;
  total: Scalars['Int']['output'];
};

export type PendingNotificationStatusInput = {
  id: Scalars['ID']['input'];
  publicId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type PendingPlaylistScheduleInput = {
  endTime?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sequence: Scalars['Int']['input'];
  startTime?: InputMaybe<Scalars['Time']['input']>;
};

export type Permission = {
  __typename?: 'Permission';
  description?: Maybe<Scalars['String']['output']>;
  permission_name?: Maybe<Scalars['String']['output']>;
  resource_server_identifier?: Maybe<Scalars['String']['output']>;
  resource_server_name?: Maybe<Scalars['String']['output']>;
};

export type Playlist = {
  __typename?: 'Playlist';
  assets: Array<Asset>;
  channelGroups: Array<ChannelGroup>;
  channelRegions?: Maybe<Array<ChannelPlaylist>>;
  channels: Array<Channel>;
  childPlaylists?: Maybe<Array<Maybe<Playlist>>>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locations: Array<Location>;
  name: Scalars['String']['output'];
  parentPlaylist?: Maybe<Playlist>;
  previewContent?: Maybe<AssetItem>;
  profile?: Maybe<Profile>;
  publishedPlaylist?: Maybe<Playlist>;
  region?: Maybe<Scalars['String']['output']>;
  resourceGroupId?: Maybe<Scalars['ID']['output']>;
  source: PlaylistSource;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: PlaylistStatus;
  type: PlaylistType;
  updatedAt: Scalars['DateTime']['output'];
  user: Array<User>;
  zone: Scalars['Int']['output'];
};


export type PlaylistAssetsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type PlaylistChannelGroupsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type PlaylistChannelsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type PlaylistChildPlaylistsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus>>;
};


export type PlaylistLocationsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum PlaylistBulkAction {
  DeletePlaylists = 'DELETE_PLAYLISTS',
  DuplicateSelected = 'DUPLICATE_SELECTED',
  PublishSelected = 'PUBLISH_SELECTED'
}

export type PlaylistFormState = {
  __typename?: 'PlaylistFormState';
  channelIds?: Maybe<Array<ChannelRegionState>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  saveOption?: Maybe<SaveOption>;
  schedules?: Maybe<Array<Schedules>>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PlaylistInfo = {
  __typename?: 'PlaylistInfo';
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  playlistId?: Maybe<Scalars['ID']['output']>;
};

export enum PlaylistSource {
  Cms = 'CMS',
  Fabege = 'FABEGE'
}

export enum PlaylistStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deprecated = 'DEPRECATED',
  Draft = 'DRAFT',
  NotSaved = 'NOT_SAVED',
  Published = 'PUBLISHED',
  ReadyToPublish = 'READY_TO_PUBLISH'
}

export enum PlaylistType {
  Interactive = 'INTERACTIVE',
  Scheduled = 'SCHEDULED'
}

export type PowerActionInput = {
  devicePowerAction: DevicePowerAction;
  uid: Scalars['ID']['input'];
};

export type PowerActionPayload = {
  __typename?: 'PowerActionPayload';
  isSuccessful: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type Profile = {
  __typename?: 'Profile';
  active?: Maybe<Scalars['Boolean']['output']>;
  assets: Array<Asset>;
  assignableLayouts?: Maybe<Array<Layout>>;
  channelGroups: Array<ChannelGroup>;
  channels: Array<Channel>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultLocation?: Maybe<Location>;
  deleteOn?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  devices: Array<Device>;
  events: Array<Channel>;
  features?: Maybe<Array<Maybe<Feature>>>;
  folders: Array<Folder>;
  id: Scalars['ID']['output'];
  layouts?: Maybe<Array<Layout>>;
  locations: Array<Location>;
  media: PaginatedMedia;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationUid?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  playlists: Array<Playlist>;
  resourceGroups: Array<ResourceGroup>;
  settings?: Maybe<ProfileSettings>;
  template: PaginatedMedia;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<User>;
  website?: Maybe<Scalars['String']['output']>;
};


export type ProfileAssetsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ProfileChannelGroupsArgs = {
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  findExact?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ProfileChannelsArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ChannelType>;
};


export type ProfileDevicesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ProfileEventsArgs = {
  deviceId?: InputMaybe<Scalars['ID']['input']>;
};


export type ProfileFoldersArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ProfileLocationsArgs = {
  excludeId?: InputMaybe<Scalars['ID']['input']>;
  findExact?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ProfileMediaArgs = {
  filters?: InputMaybe<MediaFiltersInput>;
  options?: InputMaybe<MediaOptionsInput>;
};


export type ProfilePlaylistsArgs = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyParentPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus>>;
};


export type ProfileResourceGroupsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  resourceGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type ProfileTemplateArgs = {
  filters?: InputMaybe<MediaFiltersInput>;
  options?: InputMaybe<MediaOptionsInput>;
};


export type ProfileUsersArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProfileSettings = {
  __typename?: 'ProfileSettings';
  dateFormat?: Maybe<Scalars['String']['output']>;
  timeFormat?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type ProfileSettingsInput = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  timeFormat?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type ProvisionDeviceInput = {
  application?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  coordinates?: InputMaybe<LocationCoordinatesInput>;
  deviceUid?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationInput?: InputMaybe<CreateLocationInput>;
  name: Scalars['String']['input'];
  ntpServer?: InputMaybe<Scalars['String']['input']>;
  orientation: DeviceOrientation;
  profileId: Scalars['ID']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** If `deviceUid` is present, this field will be ignored. Otherwise, `deviceUid` will be acquired after a successful verification of the hash. */
  verificationHash?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ProvisionDevicePayload = {
  __typename?: 'ProvisionDevicePayload';
  device?: Maybe<Device>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type PublishChannelsInput = {
  channelIds: Array<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** @deprecated No longer supported */
  _dummy?: Maybe<Scalars['String']['output']>;
  activeProfile?: Maybe<Profile>;
  asset?: Maybe<Asset>;
  assets: PaginatedAssets;
  auth0Profile?: Maybe<Auth0Profile>;
  channel?: Maybe<Channel>;
  channelGroup?: Maybe<ChannelGroup>;
  channelGroups: PaginatedChannelGroup;
  channels: PaginatedChannels;
  device?: Maybe<Device>;
  devicePing?: Maybe<DevicePing>;
  devicePings?: Maybe<PaginatedDevicePings>;
  devices: PaginatedDevices;
  folder?: Maybe<Folder>;
  folders: PaginatedFolders;
  isInitializingApp?: Maybe<Scalars['Boolean']['output']>;
  layout: Layout;
  location?: Maybe<Location>;
  locations: PaginatedLocations;
  me?: Maybe<User>;
  media?: Maybe<Media>;
  mediaCloudinarySignature?: Maybe<CloudinarySignature>;
  node?: Maybe<Node>;
  notifications: PaginatedNotifications;
  organization?: Maybe<Organization>;
  organizations: PaginatedOrganizations;
  playlist?: Maybe<Playlist>;
  playlistFormState?: Maybe<PlaylistFormState>;
  playlists: PaginatedPlaylists;
  profile?: Maybe<Profile>;
  profiles: PaginatedProfiles;
  resourceGroup?: Maybe<ResourceGroup>;
  resourceGroups: PaginatedResourceGroups;
  roles: Array<Role>;
  selectedAssets?: Maybe<Array<Asset>>;
  selectedChannel?: Maybe<Channel>;
  selectedDevice?: Maybe<Device>;
  user?: Maybe<User>;
  userProfileChannels: PaginatedChannels;
  userResourceGroups: Array<UserResourceGroup>;
  users: PaginatedUsers;
  usersConnection: UserConnection;
};


export type QueryAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssetsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAuth0ProfileArgs = {
  sub: Scalars['String']['input'];
};


export type QueryChannelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChannelGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChannelGroupsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChannelsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDevicePingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDevicePingsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDevicesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFoldersArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLayoutArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMediaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMediaCloudinarySignatureArgs = {
  input?: InputMaybe<CloudinarySignableForm>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationsArgs = {
  filter?: InputMaybe<FilterOptionsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  findExact?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlaylistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlaylistsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  onlyParentPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parentPlaylistId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus>>;
};


export type QueryProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProfilesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResourceGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResourceGroupsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserProfileChannelsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserResourceGroupsArgs = {
  resourceGroupId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<UserSort>;
};

export type RegionAction = {
  __typename?: 'RegionAction';
  id: Scalars['ID']['output'];
  target?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RegisterInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type RegisterPayload = {
  __typename?: 'RegisterPayload';
  success: Scalars['Boolean']['output'];
};

export type RemovePlaylistsFromChannelInput = {
  id: Scalars['String']['input'];
  playlistIds: Array<Scalars['String']['input']>;
};

export type RemovePlaylistsFromChannelPayload = {
  __typename?: 'RemovePlaylistsFromChannelPayload';
  channel?: Maybe<Channel>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type RemoveProfileUserInput = {
  profileId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type RemoveProfileUserPayload = {
  __typename?: 'RemoveProfileUserPayload';
  isSuccessful: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type ResizeCropMethod = {
  __typename?: 'ResizeCropMethod';
  name?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type ResizeCropMethodInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type Resolution = {
  __typename?: 'Resolution';
  createdAt: Scalars['DateTime']['output'];
  deviceUid: Scalars['ID']['output'];
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  orientation: DeviceOrientation;
  resolution: DeviceResolution;
  succeededAt?: Maybe<Scalars['DateTime']['output']>;
  uid: Scalars['ID']['output'];
  videoOrientation?: Maybe<DeviceResolution>;
};

export type ResolutionActionInput = {
  orientation: DeviceOrientation;
  resolution: DeviceResolution;
  uid: Scalars['ID']['input'];
};

export type ResolutionActionPayload = {
  __typename?: 'ResolutionActionPayload';
  isSuccessful: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type ResourceGroup = {
  __typename?: 'ResourceGroup';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  playlists?: Maybe<Array<Playlist>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userResourceGroups: Array<UserResourceGroup>;
  /** @deprecated don't use this to retrieve the extra properties (eg. user.canWrite) to avoid apollo cache data normalization issues use the field `userResourceGroup` instead */
  users?: Maybe<Array<User>>;
};


export type ResourceGroupPlaylistsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ResourceGroupUserResourceGroupsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type ResourceGroupUsersArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ResourceGroupUserInput = {
  canWrite?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};

export enum ResourceType {
  Image = 'IMAGE',
  Raw = 'RAW',
  Video = 'VIDEO'
}

export type Role = {
  __typename?: 'Role';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SaveMediaInput = {
  dbFolderId?: InputMaybe<Scalars['String']['input']>;
  defaultMeta?: InputMaybe<MetadataInput>;
  folder: Scalars['String']['input'];
  folderGroupType: FolderGroupType;
  name: Scalars['String']['input'];
  publicId: Scalars['String']['input'];
  resourceType: ResourceType;
  secureUrl: Scalars['String']['input'];
  source?: InputMaybe<CloudinaryFileInput>;
  url: Scalars['String']['input'];
  visibility?: InputMaybe<MediaVisibilityType>;
};

export type SaveMediaPayload = {
  __typename?: 'SaveMediaPayload';
  isSuccessful: Scalars['Boolean']['output'];
  media?: Maybe<Media>;
  profileId?: Maybe<Scalars['String']['output']>;
};

export type SaveNotificationPayload = {
  __typename?: 'SaveNotificationPayload';
  isSuccessful: Scalars['Boolean']['output'];
  notification?: Maybe<Notification>;
  profileId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum SaveOption {
  Draft = 'DRAFT',
  Publish = 'PUBLISH',
  Update = 'UPDATE'
}

export type ScheduleDays = {
  __typename?: 'ScheduleDays';
  friday: Scalars['Boolean']['output'];
  monday: Scalars['Boolean']['output'];
  saturday: Scalars['Boolean']['output'];
  sunday: Scalars['Boolean']['output'];
  thursday: Scalars['Boolean']['output'];
  tuesday: Scalars['Boolean']['output'];
  wednesday: Scalars['Boolean']['output'];
};

export type ScheduleDaysInput = {
  friday: Scalars['Boolean']['input'];
  monday: Scalars['Boolean']['input'];
  saturday: Scalars['Boolean']['input'];
  sunday: Scalars['Boolean']['input'];
  thursday: Scalars['Boolean']['input'];
  tuesday: Scalars['Boolean']['input'];
  wednesday: Scalars['Boolean']['input'];
};

export type ScheduleDisplay = {
  __typename?: 'ScheduleDisplay';
  days: ScheduleDays;
  off: Scalars['String']['output'];
  on: Scalars['String']['output'];
};

export type ScheduleDisplayInput = {
  days: ScheduleDaysInput;
  off: Scalars['String']['input'];
  on: Scalars['String']['input'];
};

export type ScheduleInput = {
  actualEndTime?: InputMaybe<Scalars['String']['input']>;
  actualStartTime?: InputMaybe<Scalars['String']['input']>;
  asset: UpdateAssetInput;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  sequence: Scalars['Int']['input'];
  startTime?: InputMaybe<Scalars['Time']['input']>;
};

export type Schedules = {
  __typename?: 'Schedules';
  asset: Asset;
  endTime?: Maybe<Scalars['Time']['output']>;
  sequence: Scalars['Int']['output'];
  startTime?: Maybe<Scalars['Time']['output']>;
};

export type ScreenInfo = {
  __typename?: 'ScreenInfo';
  brightness?: Maybe<Brightness>;
  height?: Maybe<Scalars['Int']['output']>;
  isPoweredOn?: Maybe<Scalars['Boolean']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type Screenshot = {
  __typename?: 'Screenshot';
  deviceUid?: Maybe<Scalars['String']['output']>;
  takenAt?: Maybe<Scalars['DateTime']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type SelectedAsset = {
  __typename?: 'SelectedAsset';
  content: Array<AssetItem>;
  endTime?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sequence?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
};

export type SelectedAssetInput = {
  content?: InputMaybe<Array<AssetItemInput>>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type SelectedChannelInput = {
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
};

export type SelectedDeviceInput = {
  createdAt: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
};

export type SharedUser = {
  canWrite?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};

export type SignageOsDevice = {
  __typename?: 'SignageOSDevice';
  aliveAt?: Maybe<Scalars['DateTime']['output']>;
  applicationType?: Maybe<Scalars['String']['output']>;
  applicationVersion?: Maybe<Scalars['String']['output']>;
  batteryStatus?: Maybe<BatteryStatus>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentTime?: Maybe<CurrentTime>;
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  frontDisplayVersion?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pinCode?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
};

export type SignageOsDeviceTiming = {
  __typename?: 'SignageOSDeviceTiming';
  activeAppletVersion?: Maybe<Scalars['String']['output']>;
  appletVersion?: Maybe<Scalars['String']['output']>;
};

export type SmilRegion = {
  __typename?: 'SmilRegion';
  action?: Maybe<RegionAction>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  left?: Maybe<Scalars['Float']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  sync?: Maybe<Scalars['Boolean']['output']>;
  top?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  zIndex?: Maybe<Scalars['Int']['output']>;
};

export type SmilRegionInput = {
  action?: InputMaybe<Scalars['JSONObject']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  left?: InputMaybe<Scalars['Float']['input']>;
  regionName?: InputMaybe<Scalars['String']['input']>;
  sync?: InputMaybe<Scalars['Boolean']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  zIndex?: InputMaybe<Scalars['Int']['input']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** @deprecated No longer supported */
  _dummy?: Maybe<DummySubscriptionPayload>;
  newMedia: SaveMediaPayload;
  newNotification: SaveNotificationPayload;
  updateBulkNotification: UpdateBulkNotificationStatusPayload;
  updateDevice?: Maybe<UpdateDevicePayload>;
  updateMedia: SaveMediaPayload;
  updateNotification: SaveNotificationPayload;
};


export type SubscriptionNewMediaArgs = {
  profileId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionNewNotificationArgs = {
  contentTypes: Array<NotificationContentType>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type SubscriptionUpdateBulkNotificationArgs = {
  contentTypes?: InputMaybe<Array<NotificationContentType>>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type SubscriptionUpdateDeviceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionUpdateMediaArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionUpdateNotificationArgs = {
  profileId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type TransitionEffect = {
  __typename?: 'TransitionEffect';
  duration?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TransitionEffectInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssetInput = {
  content?: InputMaybe<Array<AssetItemInput>>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
};

export type UpdateAssetPayload = {
  __typename?: 'UpdateAssetPayload';
  asset?: Maybe<Asset>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type UpdateBulkNotificationStatusPayload = {
  __typename?: 'UpdateBulkNotificationStatusPayload';
  isSuccessful: Scalars['Boolean']['output'];
  notifications?: Maybe<Array<Notification>>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type UpdateChannelGroupInput = {
  channelIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
};

export type UpdateChannelGroupPayload = {
  __typename?: 'UpdateChannelGroupPayload';
  channelGroup?: Maybe<ChannelGroup>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type UpdateChannelInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  eventEnd?: InputMaybe<Scalars['String']['input']>;
  eventRepeat?: InputMaybe<Scalars['JSONObject']['input']>;
  eventStart?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  layoutId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChannelPayload = {
  __typename?: 'UpdateChannelPayload';
  channel?: Maybe<Channel>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type UpdateChannelUsersInput = {
  id: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type UpdateChannelUsersPayload = {
  __typename?: 'UpdateChannelUsersPayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type UpdateDeviceCoordinatesInput = {
  coordinates?: InputMaybe<LocationCoordinatesInput>;
  deviceId: Scalars['String']['input'];
};

export type UpdateDeviceCoordinatesPayload = {
  __typename?: 'UpdateDeviceCoordinatesPayload';
  device?: Maybe<Device>;
  isSuccessful: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateDeviceInput = {
  advancedSettings?: InputMaybe<DeviceAdvancedSettingsInput>;
  appletVersion?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  coordinates?: InputMaybe<LocationCoordinatesInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ntpServer?: InputMaybe<Scalars['String']['input']>;
  orientation?: InputMaybe<DeviceOrientation>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDevicePayload = {
  __typename?: 'UpdateDevicePayload';
  device?: Maybe<Device>;
  isSuccessful: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateFolderInput = {
  id: Scalars['ID']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  mediaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentFolderId?: InputMaybe<Scalars['String']['input']>;
  sharedUsers?: InputMaybe<Array<SharedUser>>;
};

export type UpdateFolderPayload = {
  __typename?: 'UpdateFolderPayload';
  folder?: Maybe<Folder>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type UpdateLayoutInput = {
  channelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  layoutId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  source?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type UpdateLayoutPayload = {
  __typename?: 'UpdateLayoutPayload';
  isSuccessful: Scalars['Boolean']['output'];
  layout?: Maybe<Layout>;
};

export type UpdateLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<LocationCoordinatesInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  streetAddress1?: InputMaybe<Scalars['String']['input']>;
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLocationPayload = {
  __typename?: 'UpdateLocationPayload';
  isSuccessful: Scalars['Boolean']['output'];
  location?: Maybe<Location>;
};

export type UpdateMediaInput = {
  captureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  captureInfo?: InputMaybe<MediaCaptureInput>;
  defaultMeta?: InputMaybe<MetadataInput>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  publicId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<CloudinaryFileInput>;
  type?: InputMaybe<ResourceType>;
  url?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<MediaVisibilityType>;
};

export type UpdateMediaPayload = {
  __typename?: 'UpdateMediaPayload';
  isSuccessful: Scalars['Boolean']['output'];
  media?: Maybe<Media>;
};

export type UpdateOrganizationInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  profileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
};

export type UpdateOrganizationPayload = {
  __typename?: 'UpdateOrganizationPayload';
  isSuccessful: Scalars['Boolean']['output'];
  organization?: Maybe<Organization>;
};

export type UpdatePlaylistInput = {
  channelGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelIds?: InputMaybe<Array<ChannelRegionInput>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
  saveOption: SaveOption;
  schedules?: InputMaybe<Array<ScheduleInput>>;
  source?: InputMaybe<PlaylistSource>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<PlaylistType>;
  zone?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePlaylistPayload = {
  __typename?: 'UpdatePlaylistPayload';
  isSuccessful: Scalars['Boolean']['output'];
  playlist?: Maybe<Playlist>;
};

export type UpdatePlaylistRegionInput = {
  channelId: Scalars['ID']['input'];
  playlistId: Scalars['ID']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlaylistRegionPayload = {
  __typename?: 'UpdatePlaylistRegionPayload';
  isSuccessful: Scalars['Boolean']['output'];
  playlistRegions: Array<ChannelPlaylist>;
};

export type UpdateProfileInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<InputMaybe<CustomFeatures>>>;
  id: Scalars['ID']['input'];
  locationInput?: InputMaybe<UpdateLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationUid?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  settings?: InputMaybe<ProfileSettingsInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfilePayload = {
  __typename?: 'UpdateProfilePayload';
  isSuccessful: Scalars['Boolean']['output'];
  profile?: Maybe<Profile>;
};

export type UpdateProfileUserRoleInput = {
  newRole: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateResourceGroupInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  playlistIds?: InputMaybe<Array<Scalars['String']['input']>>;
  users?: InputMaybe<Array<ResourceGroupUserInput>>;
};

export type UpdateResourceGroupPayload = {
  __typename?: 'UpdateResourceGroupPayload';
  isSuccessful: Scalars['Boolean']['output'];
  resourceGroup?: Maybe<ResourceGroup>;
};

export type UpdateUserChannelsInput = {
  channelIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateUserChannelsPayload = {
  __typename?: 'UpdateUserChannelsPayload';
  isSuccessful: Scalars['Boolean']['output'];
};

export type UpdateUserInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  newRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  oldRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  profilePictureId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  isSuccessful: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type UploadMediaPayload = {
  __typename?: 'UploadMediaPayload';
  isSuccessful: Scalars['Boolean']['output'];
  media?: Maybe<Media>;
};

export type User = {
  __typename?: 'User';
  active?: Maybe<Scalars['Boolean']['output']>;
  assets?: Maybe<Array<Asset>>;
  auth0Profile?: Maybe<Auth0Profile>;
  channels?: Maybe<Array<Channel>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<Array<Media>>;
  playlists?: Maybe<Array<Playlist>>;
  profilePicture?: Maybe<Media>;
  profilePictureId?: Maybe<Scalars['ID']['output']>;
  profiles?: Maybe<PaginatedProfiles>;
  resourceGroups?: Maybe<Array<ResourceGroup>>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UserAssetsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type UserChannelsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type UserMediaArgs = {
  filters?: InputMaybe<MediaFiltersInput>;
  options?: InputMaybe<MediaOptionsInput>;
};


export type UserPlaylistsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  onlyParentPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus>>;
};


export type UserProfilesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type UserResourceGroupsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  resourceGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  nodes?: Maybe<Array<Maybe<User>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<User>;
};

export type UserMeta = {
  __typename?: 'UserMeta';
  use_mfa?: Maybe<Scalars['Boolean']['output']>;
};

export type UserResourceGroup = {
  __typename?: 'UserResourceGroup';
  canWrite?: Maybe<Scalars['Boolean']['output']>;
  resourceGroup: ResourceGroup;
  user: User;
};

export type UserSort = {
  direction: SortDirection;
  field: UserSortField;
};

export enum UserSortField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type VerifyDeviceInput = {
  name: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
  verificationHash: Scalars['String']['input'];
};

export type VerifyDevicePayload = {
  __typename?: 'VerifyDevicePayload';
  deviceUid?: Maybe<Scalars['String']['output']>;
  isSuccessful: Scalars['Boolean']['output'];
};

export type VideoAsset = {
  __typename?: 'VideoAsset';
  campaignEnd?: Maybe<Scalars['String']['output']>;
  campaignStart?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['ID']['output']>;
  days?: Maybe<ScheduleDays>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  interactiveLayoutSource?: Maybe<Scalars['String']['output']>;
  interactiveRegions?: Maybe<Array<Maybe<SmilRegion>>>;
  media?: Maybe<Media>;
  name: Scalars['String']['output'];
  publicId?: Maybe<Scalars['ID']['output']>;
  resizeCropMethod?: Maybe<ResizeCropMethod>;
  sequence?: Maybe<Scalars['Int']['output']>;
  simultaneous?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `__typename` instead. */
  type: AssetType;
  uri?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type WidgetAsset = {
  __typename?: 'WidgetAsset';
  campaignEnd?: Maybe<Scalars['String']['output']>;
  campaignStart?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['ID']['output']>;
  days?: Maybe<ScheduleDays>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  sequence?: Maybe<Scalars['Int']['output']>;
  simultaneous?: Maybe<Scalars['Boolean']['output']>;
  type: AssetType;
  uri?: Maybe<Scalars['String']['output']>;
  widgetConfig?: Maybe<Scalars['JSONObject']['output']>;
};

export type GetProfilesForAssetFormQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfilesForAssetFormQuery = { __typename?: 'Query', profiles: { __typename?: 'PaginatedProfiles', total: number, results: Array<{ __typename?: 'Profile', id: string, name?: string | null | undefined }> } };

export type DeleteAssetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAssetMutation = { __typename?: 'Mutation', deleteAsset: { __typename?: 'DeleteAssetPayload', isSuccessful: boolean } };

export type UpdateAssetMutationVariables = Exact<{
  input: UpdateAssetInput;
}>;


export type UpdateAssetMutation = { __typename?: 'Mutation', updateAsset: { __typename?: 'UpdateAssetPayload', isSuccessful: boolean, asset?: { __typename?: 'Asset', id: string, name: string, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined } | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> } | null | undefined } };

export type GetPlaylistFormStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlaylistFormStateQuery = { __typename?: 'Query', playlistFormState?: { __typename?: 'PlaylistFormState', id?: string | null | undefined, name?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, saveOption?: SaveOption | null | undefined, channelIds?: Array<{ __typename?: 'ChannelRegionState', id: string, region?: string | null | undefined }> | null | undefined, schedules?: Array<{ __typename?: 'Schedules', startTime?: any | null | undefined, endTime?: any | null | undefined, sequence: number, asset: { __typename?: 'Asset', id: string, name: string } }> | null | undefined } | null | undefined };

export type GetIsInitializingAppQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIsInitializingAppQuery = { __typename?: 'Query', isInitializingApp?: boolean | null | undefined };

export type GetActiveProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveProfileQuery = { __typename?: 'Query', activeProfile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, active?: boolean | null | undefined, locations: Array<{ __typename?: 'Location', id: string, name: string }>, features?: Array<{ __typename?: 'Feature', id: CustomFeatures } | null | undefined> | null | undefined, settings?: { __typename?: 'ProfileSettings', dateFormat?: string | null | undefined, timeFormat?: string | null | undefined, timeZone?: string | null | undefined } | null | undefined } | null | undefined };

export type GetSelectedChannelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSelectedChannelQuery = { __typename?: 'Query', selectedChannel?: { __typename?: 'Channel', id: string, name: string, description?: string | null | undefined, createdAt: any, updatedAt: any } | null | undefined };

export type GetSelectedDeviceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSelectedDeviceQuery = { __typename?: 'Query', selectedDevice?: { __typename?: 'Device', id: string, name: string, createdAt: any, updatedAt: any } | null | undefined };

export type GetSelectedAssetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSelectedAssetsQuery = { __typename?: 'Query', selectedAssets?: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }> | null | undefined };

export type WriteIsInitializingAppToCacheMutationVariables = Exact<{
  input?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WriteIsInitializingAppToCacheMutation = { __typename?: 'Mutation', setIsInitializingApp?: boolean | null | undefined };

export type WriteActiveProfileToCacheMutationVariables = Exact<{
  input?: InputMaybe<ActiveProfileInput>;
}>;


export type WriteActiveProfileToCacheMutation = { __typename?: 'Mutation', setActiveProfile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, active?: boolean | null | undefined, locations: Array<{ __typename?: 'Location', id: string, name: string }>, features?: Array<{ __typename?: 'Feature', id: CustomFeatures } | null | undefined> | null | undefined, settings?: { __typename?: 'ProfileSettings', dateFormat?: string | null | undefined, timeFormat?: string | null | undefined, timeZone?: string | null | undefined } | null | undefined } | null | undefined };

export type WriteSelectedChannelToCacheMutationVariables = Exact<{
  input?: InputMaybe<SelectedChannelInput>;
}>;


export type WriteSelectedChannelToCacheMutation = { __typename?: 'Mutation', setSelectedChannel?: { __typename?: 'Channel', id: string, name: string, description?: string | null | undefined, createdAt: any, updatedAt: any } | null | undefined };

export type WriteSelectedDeviceToCacheMutationVariables = Exact<{
  input?: InputMaybe<SelectedDeviceInput>;
}>;


export type WriteSelectedDeviceToCacheMutation = { __typename?: 'Mutation', setSelectedDevice?: { __typename?: 'Device', id: string, name: string, createdAt: any, updatedAt: any } | null | undefined };

export type WriteSelectedAssetsToCacheMutationVariables = Exact<{
  input?: InputMaybe<Array<SelectedAssetInput> | SelectedAssetInput>;
}>;


export type WriteSelectedAssetsToCacheMutation = { __typename?: 'Mutation', setSelectedAssets?: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }> | null | undefined };

export type CreateChannelGroupMutationVariables = Exact<{
  input: CreateChannelGroupInput;
}>;


export type CreateChannelGroupMutation = { __typename?: 'Mutation', createChannelGroup: { __typename?: 'CreateChannelGroupPayload', isSuccessful: boolean, channelGroup?: { __typename?: 'ChannelGroup', id: string, name: string, createdAt: any, updatedAt: any, channels: Array<{ __typename?: 'Channel', id: string }> } | null | undefined } };

export type GetChannelGroupForManagePageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetChannelGroupForManagePageQuery = { __typename?: 'Query', channelGroup?: { __typename?: 'ChannelGroup', id: string, name: string, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string } | null | undefined, channels: Array<{ __typename?: 'Channel', id: string }> } | null | undefined };

export type UpdateChannelGroupMutationVariables = Exact<{
  input: UpdateChannelGroupInput;
}>;


export type UpdateChannelGroupMutation = { __typename?: 'Mutation', updateChannelGroup: { __typename?: 'UpdateChannelGroupPayload', isSuccessful: boolean, channelGroup?: { __typename?: 'ChannelGroup', id: string, name: string, createdAt: any, updatedAt: any, channels: Array<{ __typename?: 'Channel', id: string }>, profile?: { __typename?: 'Profile', id: string } | null | undefined } | null | undefined } };

export type DeleteChannelGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteChannelGroupMutation = { __typename?: 'Mutation', deleteChannelGroup: { __typename?: 'DeleteChannelGroupPayload', isSuccessful: boolean } };

export type GetProfileChannelGroupsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  findExact?: InputMaybe<Scalars['Boolean']['input']>;
  excludeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetProfileChannelGroupsQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, channelGroups: Array<{ __typename?: 'ChannelGroup', id: string, name: string, createdAt: any, updatedAt: any, channels: Array<{ __typename?: 'Channel', id: string }> }> } | null | undefined };

export type GetChannelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetChannelQuery = { __typename?: 'Query', channel?: { __typename?: 'Channel', eventStart?: string | null | undefined, eventEnd?: string | null | undefined, description?: string | null | undefined, createdAt: any, updatedAt: any, id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, playlistRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, playlistId: string, region?: string | null | undefined }> | null | undefined, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType }>, devices: Array<{ __typename?: 'Device', id: string, uid?: string | null | undefined, name: string, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetChannelForChannelDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetChannelForChannelDetailQuery = { __typename?: 'Query', channel?: { __typename?: 'Channel', id: string, name: string, description?: string | null | undefined, createdAt: any, updatedAt: any } | null | undefined };

export type GetProfileChannelsForChannelListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  type?: InputMaybe<ChannelType>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProfileChannelsForChannelListQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, channels: Array<{ __typename?: 'Channel', eventStart?: string | null | undefined, eventEnd?: string | null | undefined, description?: string | null | undefined, createdAt: any, updatedAt: any, id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, playlistRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, playlistId: string, region?: string | null | undefined }> | null | undefined, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType }>, devices: Array<{ __typename?: 'Device', id: string, uid?: string | null | undefined, name: string, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined }> }> } | null | undefined };

export type GetChannelsForChannelListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChannelsForChannelListQuery = { __typename?: 'Query', channels: { __typename?: 'PaginatedChannels', total: number, results: Array<{ __typename?: 'Channel', eventStart?: string | null | undefined, eventEnd?: string | null | undefined, description?: string | null | undefined, createdAt: any, updatedAt: any, id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, playlistRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, playlistId: string, region?: string | null | undefined }> | null | undefined, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType }>, devices: Array<{ __typename?: 'Device', id: string, uid?: string | null | undefined, name: string, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined }> }> } };

export type GetEventsListQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  deviceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetEventsListQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', events: Array<{ __typename?: 'Channel', eventStart?: string | null | undefined, eventEnd?: string | null | undefined, description?: string | null | undefined, createdAt: any, updatedAt: any, id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, playlistRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, playlistId: string, region?: string | null | undefined }> | null | undefined, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType }>, devices: Array<{ __typename?: 'Device', id: string, uid?: string | null | undefined, name: string, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined }> }> } | null | undefined };

export type GetChannelGroupChannelsForChannelListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChannelGroupChannelsForChannelListQuery = { __typename?: 'Query', channelGroup?: { __typename?: 'ChannelGroup', id: string, channels: Array<{ __typename?: 'Channel', eventStart?: string | null | undefined, eventEnd?: string | null | undefined, description?: string | null | undefined, createdAt: any, updatedAt: any, id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, playlistRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, playlistId: string, region?: string | null | undefined }> | null | undefined, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType }>, devices: Array<{ __typename?: 'Device', id: string, uid?: string | null | undefined, name: string, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined }> }> } | null | undefined };

export type GetLocationChannelsForChannelListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLocationChannelsForChannelListQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, channels?: Array<{ __typename?: 'Channel', eventStart?: string | null | undefined, eventEnd?: string | null | undefined, description?: string | null | undefined, createdAt: any, updatedAt: any, id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, playlistRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, playlistId: string, region?: string | null | undefined }> | null | undefined, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType }>, devices: Array<{ __typename?: 'Device', id: string, uid?: string | null | undefined, name: string, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined }> }> | null | undefined } | null | undefined };

export type GetProfileUserChannelsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetProfileUserChannelsQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, users: Array<{ __typename?: 'User', id: string, channels?: Array<{ __typename?: 'Channel', eventStart?: string | null | undefined, eventEnd?: string | null | undefined, description?: string | null | undefined, createdAt: any, updatedAt: any, id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, playlistRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, playlistId: string, region?: string | null | undefined }> | null | undefined, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType }>, devices: Array<{ __typename?: 'Device', id: string, uid?: string | null | undefined, name: string, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined }> }> | null | undefined }> } | null | undefined };

export type ChannelBonsaiFragment = { __typename?: 'Channel', id: string, name: string, type: ChannelType };

export type EventForListFragment = { __typename?: 'Channel', eventStart?: string | null | undefined, eventEnd?: string | null | undefined, description?: string | null | undefined, createdAt: any, updatedAt: any, id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, playlistRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, playlistId: string, region?: string | null | undefined }> | null | undefined, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType }>, devices: Array<{ __typename?: 'Device', id: string, uid?: string | null | undefined, name: string, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined }> };

export type ChannelsForChannelListFragment = { __typename?: 'Channel', eventStart?: string | null | undefined, eventEnd?: string | null | undefined, description?: string | null | undefined, createdAt: any, updatedAt: any, id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, playlistRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, playlistId: string, region?: string | null | undefined }> | null | undefined, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType }>, devices: Array<{ __typename?: 'Device', id: string, uid?: string | null | undefined, name: string, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined }> };

export type GetChannelPlaylistRegionsQueryVariables = Exact<{
  channelId: Scalars['ID']['input'];
}>;


export type GetChannelPlaylistRegionsQuery = { __typename?: 'Query', channel?: { __typename?: 'Channel', id: string, playlistRegions?: Array<{ __typename?: 'ChannelPlaylist', playlistId: string, region?: string | null | undefined }> | null | undefined } | null | undefined };

export type GetChannelForManagePageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetChannelForManagePageQuery = { __typename?: 'Query', channel?: { __typename?: 'Channel', id: string, name: string, description?: string | null | undefined, createdAt: any, updatedAt: any, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type GetProfileForChannelManagePageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProfileForChannelManagePageQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, locations: Array<{ __typename?: 'Location', id: string, name: string }> } | null | undefined };

export type UpdateChannelMutationVariables = Exact<{
  input: UpdateChannelInput;
}>;


export type UpdateChannelMutation = { __typename?: 'Mutation', updateChannel: { __typename?: 'UpdateChannelPayload', isSuccessful: boolean, channel?: { __typename?: 'Channel', id: string, name: string, description?: string | null | undefined, createdAt: any, updatedAt: any, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined } };

export type DeleteChannelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteChannelMutation = { __typename?: 'Mutation', deleteChannel: { __typename?: 'DeleteChannelPayload', isSuccessful: boolean, rowsAffected: number } };

export type AssignChannelPlaylistRegionMutationVariables = Exact<{
  input: UpdatePlaylistRegionInput;
}>;


export type AssignChannelPlaylistRegionMutation = { __typename?: 'Mutation', assignChannelPlaylistRegion: { __typename?: 'UpdatePlaylistRegionPayload', isSuccessful: boolean, playlistRegions: Array<{ __typename?: 'ChannelPlaylist', channelId: string, playlistId: string, region?: string | null | undefined }> } };

export type GetProfileDevicesResolutionQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
}>;


export type GetProfileDevicesResolutionQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, devices: Array<{ __typename?: 'Device', id: string, name: string, width?: number | null | undefined, height?: number | null | undefined }> } | null | undefined };

export type VerifyDeviceMutationVariables = Exact<{
  input: VerifyDeviceInput;
}>;


export type VerifyDeviceMutation = { __typename?: 'Mutation', verifyDevice: { __typename?: 'VerifyDevicePayload', isSuccessful: boolean, deviceUid?: string | null | undefined } };

export type GetDeviceForDeviceListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDeviceForDeviceListQuery = { __typename?: 'Query', devices: { __typename?: 'PaginatedDevices', total: number, results: Array<{ __typename?: 'Device', id: string, name: string, updatedAt: any, createdAt: any, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, channel?: { __typename?: 'Channel', id: string, name: string } | null | undefined }> } };

export type GetProfileDevicesForDeviceListQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  deviceName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProfileDevicesForDeviceListQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, devices: Array<{ __typename?: 'Device', id: string, name: string, updatedAt: any, createdAt: any, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, channel?: { __typename?: 'Channel', id: string, name: string } | null | undefined }> } | null | undefined };

export type GetChannelDevicesForDeviceListQueryVariables = Exact<{
  channelId: Scalars['ID']['input'];
  deviceName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChannelDevicesForDeviceListQuery = { __typename?: 'Query', channel?: { __typename?: 'Channel', id: string, name: string, devices: Array<{ __typename?: 'Device', id: string, name: string, updatedAt: any, createdAt: any, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, channel?: { __typename?: 'Channel', id: string, name: string } | null | undefined }> } | null | undefined };

export type AdvancedSettingsDetailedFragment = { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined };

export type DaysFragment = { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean };

export type ScheduleDisplayDetailedFragment = { __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } };

export type DevicesForDeviceListFragment = { __typename?: 'Device', id: string, name: string, updatedAt: any, createdAt: any, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, channel?: { __typename?: 'Channel', id: string, name: string } | null | undefined };

export type DeleteDeprovisionedDeviceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteDeprovisionedDeviceMutation = { __typename?: 'Mutation', deleteDeprovisionedDevice: { __typename?: 'DeleteDeprovisionedDevicePayload', isSuccessful: boolean } };

export type GetDeviceForManageDevicePageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDeviceForManageDevicePageQuery = { __typename?: 'Query', device?: { __typename?: 'Device', id: string, uid?: string | null | undefined, channelId?: string | null | undefined, name: string, width?: number | null | undefined, height?: number | null | undefined, serialNumber?: string | null | undefined, application?: string | null | undefined, updatedAt: any, createdAt: any, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, latestPing?: { __typename?: 'DevicePing', id?: string | null | undefined, timestamp?: any | null | undefined } | null | undefined, deviceInfo?: { __typename?: 'DeviceInfo', appletVersion?: string | null | undefined, applicationType?: string | null | undefined, applicationVersion?: string | null | undefined, firmware?: string | null | undefined, model?: string | null | undefined, serialNumber?: string | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, networkInfo?: { __typename?: 'NetworkInfo', localAddress?: string | null | undefined, ethernetMacAddress?: string | null | undefined, wifiMacAddress?: string | null | undefined, activeInterface?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, interfaceName?: string | null | undefined } | null | undefined, networkAdapters?: Array<{ __typename?: 'NetworkInterface', type: string, name: string, macAddress: string, localAddress?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, disabled?: boolean | null | undefined, wifiStrength?: number | null | undefined, wifiSsid?: string | null | undefined } | null | undefined> | null | undefined, batteryStatus?: { __typename?: 'BatteryStatus', chargeType?: string | null | undefined, isCharging?: boolean | null | undefined, lastChargingTime?: any | null | undefined, percentage?: number | null | undefined, updatedAt?: any | null | undefined } | null | undefined, currentTime?: { __typename?: 'CurrentTime', currentDate?: any | null | undefined, timezone?: string | null | undefined, updatedAt?: any | null | undefined, ntpServer?: string | null | undefined } | null | undefined, screen?: { __typename?: 'ScreenInfo', orientation?: string | null | undefined, isPoweredOn?: boolean | null | undefined, volume?: number | null | undefined, brightness?: { __typename?: 'Brightness', timeFrom1?: string | null | undefined, timeFrom2?: string | null | undefined, brightness1?: number | null | undefined, brightness2?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, profile?: { __typename?: 'Profile', id: string, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType }>, locations: Array<{ __typename?: 'Location', id: string, name: string }> } | null | undefined, channel?: { __typename?: 'Channel', id: string, name: string, description?: string | null | undefined } | null | undefined, resolution?: { __typename?: 'Resolution', resolution: DeviceResolution, orientation: DeviceOrientation } | null | undefined, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, region?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined } | null | undefined };

export type GetDeviceMonitorHistoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDeviceMonitorHistoryQuery = { __typename?: 'Query', device?: { __typename?: 'Device', monitorHistory?: Array<{ __typename?: 'DeviceMonitorRecord', ts?: any | null | undefined, cpu?: number | null | undefined, temp?: number | null | undefined }> | null | undefined, statusHistory?: Array<{ __typename?: 'DeviceStatusRecord', ts?: any | null | undefined, online?: boolean | null | undefined }> | null | undefined } | null | undefined };

export type UpdateDeviceSubscriptionSubscriptionVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateDeviceSubscriptionSubscription = { __typename?: 'Subscription', updateDevice?: { __typename?: 'UpdateDevicePayload', isSuccessful: boolean, device?: { __typename?: 'Device', id: string, uid?: string | null | undefined, channelId?: string | null | undefined, name: string, width?: number | null | undefined, height?: number | null | undefined, serialNumber?: string | null | undefined, application?: string | null | undefined, updatedAt: any, createdAt: any, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, latestPing?: { __typename?: 'DevicePing', id?: string | null | undefined, timestamp?: any | null | undefined } | null | undefined, deviceInfo?: { __typename?: 'DeviceInfo', appletVersion?: string | null | undefined, applicationType?: string | null | undefined, applicationVersion?: string | null | undefined, firmware?: string | null | undefined, model?: string | null | undefined, serialNumber?: string | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, networkInfo?: { __typename?: 'NetworkInfo', localAddress?: string | null | undefined, ethernetMacAddress?: string | null | undefined, wifiMacAddress?: string | null | undefined, activeInterface?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, interfaceName?: string | null | undefined } | null | undefined, networkAdapters?: Array<{ __typename?: 'NetworkInterface', type: string, name: string, macAddress: string, localAddress?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, disabled?: boolean | null | undefined, wifiStrength?: number | null | undefined, wifiSsid?: string | null | undefined } | null | undefined> | null | undefined, batteryStatus?: { __typename?: 'BatteryStatus', chargeType?: string | null | undefined, isCharging?: boolean | null | undefined, lastChargingTime?: any | null | undefined, percentage?: number | null | undefined, updatedAt?: any | null | undefined } | null | undefined, currentTime?: { __typename?: 'CurrentTime', currentDate?: any | null | undefined, timezone?: string | null | undefined, updatedAt?: any | null | undefined, ntpServer?: string | null | undefined } | null | undefined, screen?: { __typename?: 'ScreenInfo', orientation?: string | null | undefined, isPoweredOn?: boolean | null | undefined, volume?: number | null | undefined, brightness?: { __typename?: 'Brightness', timeFrom1?: string | null | undefined, timeFrom2?: string | null | undefined, brightness1?: number | null | undefined, brightness2?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, profile?: { __typename?: 'Profile', id: string, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType }>, locations: Array<{ __typename?: 'Location', id: string, name: string }> } | null | undefined, channel?: { __typename?: 'Channel', id: string, name: string, description?: string | null | undefined } | null | undefined, resolution?: { __typename?: 'Resolution', resolution: DeviceResolution, orientation: DeviceOrientation } | null | undefined, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, region?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type InitDeviceMutationVariables = Exact<{
  input: InitDeviceInput;
}>;


export type InitDeviceMutation = { __typename?: 'Mutation', initDevice: { __typename?: 'InitDevicePayload', isSuccessful: boolean } };

export type ProvisionDeviceMutationVariables = Exact<{
  input: ProvisionDeviceInput;
}>;


export type ProvisionDeviceMutation = { __typename?: 'Mutation', provisionDevice: { __typename?: 'ProvisionDevicePayload', isSuccessful: boolean, device?: { __typename?: 'Device', id: string, uid?: string | null | undefined, channelId?: string | null | undefined, name: string, width?: number | null | undefined, height?: number | null | undefined, serialNumber?: string | null | undefined, application?: string | null | undefined, updatedAt: any, createdAt: any, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, latestPing?: { __typename?: 'DevicePing', id?: string | null | undefined, timestamp?: any | null | undefined } | null | undefined, deviceInfo?: { __typename?: 'DeviceInfo', appletVersion?: string | null | undefined, applicationType?: string | null | undefined, applicationVersion?: string | null | undefined, firmware?: string | null | undefined, model?: string | null | undefined, serialNumber?: string | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, networkInfo?: { __typename?: 'NetworkInfo', localAddress?: string | null | undefined, ethernetMacAddress?: string | null | undefined, wifiMacAddress?: string | null | undefined, activeInterface?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, interfaceName?: string | null | undefined } | null | undefined, networkAdapters?: Array<{ __typename?: 'NetworkInterface', type: string, name: string, macAddress: string, localAddress?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, disabled?: boolean | null | undefined, wifiStrength?: number | null | undefined, wifiSsid?: string | null | undefined } | null | undefined> | null | undefined, batteryStatus?: { __typename?: 'BatteryStatus', chargeType?: string | null | undefined, isCharging?: boolean | null | undefined, lastChargingTime?: any | null | undefined, percentage?: number | null | undefined, updatedAt?: any | null | undefined } | null | undefined, currentTime?: { __typename?: 'CurrentTime', currentDate?: any | null | undefined, timezone?: string | null | undefined, updatedAt?: any | null | undefined, ntpServer?: string | null | undefined } | null | undefined, screen?: { __typename?: 'ScreenInfo', orientation?: string | null | undefined, isPoweredOn?: boolean | null | undefined, volume?: number | null | undefined, brightness?: { __typename?: 'Brightness', timeFrom1?: string | null | undefined, timeFrom2?: string | null | undefined, brightness1?: number | null | undefined, brightness2?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, profile?: { __typename?: 'Profile', id: string, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType }>, locations: Array<{ __typename?: 'Location', id: string, name: string }> } | null | undefined, channel?: { __typename?: 'Channel', id: string, name: string, description?: string | null | undefined } | null | undefined, resolution?: { __typename?: 'Resolution', resolution: DeviceResolution, orientation: DeviceOrientation } | null | undefined, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, region?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined } | null | undefined } };

export type DeviceInfoDetailedFragment = { __typename?: 'DeviceInfo', appletVersion?: string | null | undefined, applicationType?: string | null | undefined, applicationVersion?: string | null | undefined, firmware?: string | null | undefined, model?: string | null | undefined, serialNumber?: string | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, networkInfo?: { __typename?: 'NetworkInfo', localAddress?: string | null | undefined, ethernetMacAddress?: string | null | undefined, wifiMacAddress?: string | null | undefined, activeInterface?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, interfaceName?: string | null | undefined } | null | undefined, networkAdapters?: Array<{ __typename?: 'NetworkInterface', type: string, name: string, macAddress: string, localAddress?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, disabled?: boolean | null | undefined, wifiStrength?: number | null | undefined, wifiSsid?: string | null | undefined } | null | undefined> | null | undefined, batteryStatus?: { __typename?: 'BatteryStatus', chargeType?: string | null | undefined, isCharging?: boolean | null | undefined, lastChargingTime?: any | null | undefined, percentage?: number | null | undefined, updatedAt?: any | null | undefined } | null | undefined, currentTime?: { __typename?: 'CurrentTime', currentDate?: any | null | undefined, timezone?: string | null | undefined, updatedAt?: any | null | undefined, ntpServer?: string | null | undefined } | null | undefined, screen?: { __typename?: 'ScreenInfo', orientation?: string | null | undefined, isPoweredOn?: boolean | null | undefined, volume?: number | null | undefined, brightness?: { __typename?: 'Brightness', timeFrom1?: string | null | undefined, timeFrom2?: string | null | undefined, brightness1?: number | null | undefined, brightness2?: number | null | undefined } | null | undefined } | null | undefined };

export type MonitorRecordFragment = { __typename?: 'DeviceMonitorRecord', ts?: any | null | undefined, cpu?: number | null | undefined, temp?: number | null | undefined };

export type StatusRecordFragment = { __typename?: 'DeviceStatusRecord', ts?: any | null | undefined, online?: boolean | null | undefined };

export type DeviceBaseFragment = { __typename?: 'Device', id: string, uid?: string | null | undefined, channelId?: string | null | undefined, name: string, width?: number | null | undefined, height?: number | null | undefined, serialNumber?: string | null | undefined, updatedAt: any, createdAt: any, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, region?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, latestPing?: { __typename?: 'DevicePing', id?: string | null | undefined, timestamp?: any | null | undefined } | null | undefined, deviceInfo?: { __typename?: 'DeviceInfo', appletVersion?: string | null | undefined, applicationType?: string | null | undefined, applicationVersion?: string | null | undefined, firmware?: string | null | undefined, model?: string | null | undefined, serialNumber?: string | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, networkInfo?: { __typename?: 'NetworkInfo', localAddress?: string | null | undefined, ethernetMacAddress?: string | null | undefined, wifiMacAddress?: string | null | undefined, activeInterface?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, interfaceName?: string | null | undefined } | null | undefined, networkAdapters?: Array<{ __typename?: 'NetworkInterface', type: string, name: string, macAddress: string, localAddress?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, disabled?: boolean | null | undefined, wifiStrength?: number | null | undefined, wifiSsid?: string | null | undefined } | null | undefined> | null | undefined, batteryStatus?: { __typename?: 'BatteryStatus', chargeType?: string | null | undefined, isCharging?: boolean | null | undefined, lastChargingTime?: any | null | undefined, percentage?: number | null | undefined, updatedAt?: any | null | undefined } | null | undefined, currentTime?: { __typename?: 'CurrentTime', currentDate?: any | null | undefined, timezone?: string | null | undefined, updatedAt?: any | null | undefined, ntpServer?: string | null | undefined } | null | undefined, screen?: { __typename?: 'ScreenInfo', orientation?: string | null | undefined, isPoweredOn?: boolean | null | undefined, volume?: number | null | undefined, brightness?: { __typename?: 'Brightness', timeFrom1?: string | null | undefined, timeFrom2?: string | null | undefined, brightness1?: number | null | undefined, brightness2?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined, channel?: { __typename?: 'Channel', id: string, name: string } | null | undefined };

export type EventBonsaiFragment = { __typename?: 'Channel', id: string, name: string, eventStart?: string | null | undefined };

export type DeviceForManageFragment = { __typename?: 'Device', id: string, uid?: string | null | undefined, channelId?: string | null | undefined, name: string, width?: number | null | undefined, height?: number | null | undefined, serialNumber?: string | null | undefined, application?: string | null | undefined, updatedAt: any, createdAt: any, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, latestPing?: { __typename?: 'DevicePing', id?: string | null | undefined, timestamp?: any | null | undefined } | null | undefined, deviceInfo?: { __typename?: 'DeviceInfo', appletVersion?: string | null | undefined, applicationType?: string | null | undefined, applicationVersion?: string | null | undefined, firmware?: string | null | undefined, model?: string | null | undefined, serialNumber?: string | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, networkInfo?: { __typename?: 'NetworkInfo', localAddress?: string | null | undefined, ethernetMacAddress?: string | null | undefined, wifiMacAddress?: string | null | undefined, activeInterface?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, interfaceName?: string | null | undefined } | null | undefined, networkAdapters?: Array<{ __typename?: 'NetworkInterface', type: string, name: string, macAddress: string, localAddress?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, disabled?: boolean | null | undefined, wifiStrength?: number | null | undefined, wifiSsid?: string | null | undefined } | null | undefined> | null | undefined, batteryStatus?: { __typename?: 'BatteryStatus', chargeType?: string | null | undefined, isCharging?: boolean | null | undefined, lastChargingTime?: any | null | undefined, percentage?: number | null | undefined, updatedAt?: any | null | undefined } | null | undefined, currentTime?: { __typename?: 'CurrentTime', currentDate?: any | null | undefined, timezone?: string | null | undefined, updatedAt?: any | null | undefined, ntpServer?: string | null | undefined } | null | undefined, screen?: { __typename?: 'ScreenInfo', orientation?: string | null | undefined, isPoweredOn?: boolean | null | undefined, volume?: number | null | undefined, brightness?: { __typename?: 'Brightness', timeFrom1?: string | null | undefined, timeFrom2?: string | null | undefined, brightness1?: number | null | undefined, brightness2?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, profile?: { __typename?: 'Profile', id: string, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType }>, locations: Array<{ __typename?: 'Location', id: string, name: string }> } | null | undefined, channel?: { __typename?: 'Channel', id: string, name: string, description?: string | null | undefined } | null | undefined, resolution?: { __typename?: 'Resolution', resolution: DeviceResolution, orientation: DeviceOrientation } | null | undefined, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, region?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined };

export type GetProfileDevicesForMapQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProfileDevicesForMapQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, devices: Array<{ __typename?: 'Device', id: string, uid?: string | null | undefined, channelId?: string | null | undefined, name: string, width?: number | null | undefined, height?: number | null | undefined, serialNumber?: string | null | undefined, updatedAt: any, createdAt: any, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, region?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, latestPing?: { __typename?: 'DevicePing', id?: string | null | undefined, timestamp?: any | null | undefined } | null | undefined, deviceInfo?: { __typename?: 'DeviceInfo', appletVersion?: string | null | undefined, applicationType?: string | null | undefined, applicationVersion?: string | null | undefined, firmware?: string | null | undefined, model?: string | null | undefined, serialNumber?: string | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, networkInfo?: { __typename?: 'NetworkInfo', localAddress?: string | null | undefined, ethernetMacAddress?: string | null | undefined, wifiMacAddress?: string | null | undefined, activeInterface?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, interfaceName?: string | null | undefined } | null | undefined, networkAdapters?: Array<{ __typename?: 'NetworkInterface', type: string, name: string, macAddress: string, localAddress?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, disabled?: boolean | null | undefined, wifiStrength?: number | null | undefined, wifiSsid?: string | null | undefined } | null | undefined> | null | undefined, batteryStatus?: { __typename?: 'BatteryStatus', chargeType?: string | null | undefined, isCharging?: boolean | null | undefined, lastChargingTime?: any | null | undefined, percentage?: number | null | undefined, updatedAt?: any | null | undefined } | null | undefined, currentTime?: { __typename?: 'CurrentTime', currentDate?: any | null | undefined, timezone?: string | null | undefined, updatedAt?: any | null | undefined, ntpServer?: string | null | undefined } | null | undefined, screen?: { __typename?: 'ScreenInfo', orientation?: string | null | undefined, isPoweredOn?: boolean | null | undefined, volume?: number | null | undefined, brightness?: { __typename?: 'Brightness', timeFrom1?: string | null | undefined, timeFrom2?: string | null | undefined, brightness1?: number | null | undefined, brightness2?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined, channel?: { __typename?: 'Channel', id: string, name: string } | null | undefined }> } | null | undefined };

export type GetSingleDeviceForMapQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSingleDeviceForMapQuery = { __typename?: 'Query', device?: { __typename?: 'Device', id: string, uid?: string | null | undefined, channelId?: string | null | undefined, name: string, width?: number | null | undefined, height?: number | null | undefined, serialNumber?: string | null | undefined, updatedAt: any, createdAt: any, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, region?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, latestPing?: { __typename?: 'DevicePing', id?: string | null | undefined, timestamp?: any | null | undefined } | null | undefined, deviceInfo?: { __typename?: 'DeviceInfo', appletVersion?: string | null | undefined, applicationType?: string | null | undefined, applicationVersion?: string | null | undefined, firmware?: string | null | undefined, model?: string | null | undefined, serialNumber?: string | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, networkInfo?: { __typename?: 'NetworkInfo', localAddress?: string | null | undefined, ethernetMacAddress?: string | null | undefined, wifiMacAddress?: string | null | undefined, activeInterface?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, interfaceName?: string | null | undefined } | null | undefined, networkAdapters?: Array<{ __typename?: 'NetworkInterface', type: string, name: string, macAddress: string, localAddress?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, disabled?: boolean | null | undefined, wifiStrength?: number | null | undefined, wifiSsid?: string | null | undefined } | null | undefined> | null | undefined, batteryStatus?: { __typename?: 'BatteryStatus', chargeType?: string | null | undefined, isCharging?: boolean | null | undefined, lastChargingTime?: any | null | undefined, percentage?: number | null | undefined, updatedAt?: any | null | undefined } | null | undefined, currentTime?: { __typename?: 'CurrentTime', currentDate?: any | null | undefined, timezone?: string | null | undefined, updatedAt?: any | null | undefined, ntpServer?: string | null | undefined } | null | undefined, screen?: { __typename?: 'ScreenInfo', orientation?: string | null | undefined, isPoweredOn?: boolean | null | undefined, volume?: number | null | undefined, brightness?: { __typename?: 'Brightness', timeFrom1?: string | null | undefined, timeFrom2?: string | null | undefined, brightness1?: number | null | undefined, brightness2?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined, channel?: { __typename?: 'Channel', id: string, name: string } | null | undefined } | null | undefined };

export type ChannelLocationForMapFragment = { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, region?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined };

export type SetDevicePowerActionMutationVariables = Exact<{
  uid: Scalars['ID']['input'];
  devicePowerAction: DevicePowerAction;
}>;


export type SetDevicePowerActionMutation = { __typename?: 'Mutation', powerAction: { __typename?: 'PowerActionPayload', isSuccessful: boolean } };

export type UpdateDeviceAdvancedSettingsMutationVariables = Exact<{
  input: UpdateDeviceInput;
}>;


export type UpdateDeviceAdvancedSettingsMutation = { __typename?: 'Mutation', updateDevice: { __typename?: 'UpdateDevicePayload', isSuccessful: boolean, device?: { __typename?: 'Device', id: string, uid?: string | null | undefined, channelId?: string | null | undefined, name: string, width?: number | null | undefined, height?: number | null | undefined, serialNumber?: string | null | undefined, application?: string | null | undefined, updatedAt: any, createdAt: any, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, latestPing?: { __typename?: 'DevicePing', id?: string | null | undefined, timestamp?: any | null | undefined } | null | undefined, deviceInfo?: { __typename?: 'DeviceInfo', appletVersion?: string | null | undefined, applicationType?: string | null | undefined, applicationVersion?: string | null | undefined, firmware?: string | null | undefined, model?: string | null | undefined, serialNumber?: string | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, networkInfo?: { __typename?: 'NetworkInfo', localAddress?: string | null | undefined, ethernetMacAddress?: string | null | undefined, wifiMacAddress?: string | null | undefined, activeInterface?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, interfaceName?: string | null | undefined } | null | undefined, networkAdapters?: Array<{ __typename?: 'NetworkInterface', type: string, name: string, macAddress: string, localAddress?: string | null | undefined, gateway?: string | null | undefined, netmask?: string | null | undefined, dns?: Array<string | null | undefined> | null | undefined, disabled?: boolean | null | undefined, wifiStrength?: number | null | undefined, wifiSsid?: string | null | undefined } | null | undefined> | null | undefined, batteryStatus?: { __typename?: 'BatteryStatus', chargeType?: string | null | undefined, isCharging?: boolean | null | undefined, lastChargingTime?: any | null | undefined, percentage?: number | null | undefined, updatedAt?: any | null | undefined } | null | undefined, currentTime?: { __typename?: 'CurrentTime', currentDate?: any | null | undefined, timezone?: string | null | undefined, updatedAt?: any | null | undefined, ntpServer?: string | null | undefined } | null | undefined, screen?: { __typename?: 'ScreenInfo', orientation?: string | null | undefined, isPoweredOn?: boolean | null | undefined, volume?: number | null | undefined, brightness?: { __typename?: 'Brightness', timeFrom1?: string | null | undefined, timeFrom2?: string | null | undefined, brightness1?: number | null | undefined, brightness2?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, profile?: { __typename?: 'Profile', id: string, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType }>, locations: Array<{ __typename?: 'Location', id: string, name: string }> } | null | undefined, channel?: { __typename?: 'Channel', id: string, name: string, description?: string | null | undefined } | null | undefined, resolution?: { __typename?: 'Resolution', resolution: DeviceResolution, orientation: DeviceOrientation } | null | undefined, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, region?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined } | null | undefined } };

export type UpdateDeviceMutationVariables = Exact<{
  input: UpdateDeviceInput;
}>;


export type UpdateDeviceMutation = { __typename?: 'Mutation', updateDevice: { __typename?: 'UpdateDevicePayload', isSuccessful: boolean, device?: { __typename?: 'Device', id: string, name: string, updatedAt: any, width?: number | null | undefined, height?: number | null | undefined, locationId?: string | null | undefined, channel?: { __typename?: 'Channel', id: string, name: string, description?: string | null | undefined } | null | undefined, signageOSDevice?: { __typename?: 'SignageOSDevice', name?: string | null | undefined, createdAt?: any | null | undefined, aliveAt?: any | null | undefined, applicationType?: string | null | undefined, applicationVersion?: string | null | undefined, firmwareVersion?: string | null | undefined, frontDisplayVersion?: string | null | undefined, model?: string | null | undefined, serialNumber?: string | null | undefined, batteryStatus?: { __typename?: 'BatteryStatus', chargeType?: string | null | undefined, isCharging?: boolean | null | undefined, lastChargingTime?: any | null | undefined, percentage?: number | null | undefined, updatedAt?: any | null | undefined } | null | undefined, currentTime?: { __typename?: 'CurrentTime', time?: any | null | undefined, timezone?: string | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined, profile?: { __typename?: 'Profile', id: string, channels: Array<{ __typename?: 'Channel', id: string, name: string }>, locations: Array<{ __typename?: 'Location', id: string, name: string }> } | null | undefined, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined } };

export type UpdateDeviceCoordinatesMutationVariables = Exact<{
  input: UpdateDeviceCoordinatesInput;
}>;


export type UpdateDeviceCoordinatesMutation = { __typename?: 'Mutation', updateDeviceCoordinates: { __typename?: 'UpdateDeviceCoordinatesPayload', isSuccessful: boolean, device?: { __typename?: 'Device', id: string, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined } };

export type DeleteDeviceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteDeviceMutation = { __typename?: 'Mutation', deleteDevice: { __typename?: 'DeleteDevicePayload', isSuccessful: boolean } };

export type GetProfileForDeviceFormQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
}>;


export type GetProfileForDeviceFormQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, channels: Array<{ __typename?: 'Channel', id: string, name: string }>, locations: Array<{ __typename?: 'Location', id: string, name: string }> } | null | undefined };

export type DeviceVerificationChannelOptionFragment = { __typename?: 'Channel', id: string, name: string };

export type GetLocationForLocationManagePageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLocationForLocationManagePageQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, region?: string | null | undefined, city?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, channels?: Array<{ __typename?: 'Channel', id: string, name: string, description?: string | null | undefined }> | null | undefined } | null | undefined };

export type UpdateLocationMutationVariables = Exact<{
  input: UpdateLocationInput;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateLocation: { __typename?: 'UpdateLocationPayload', isSuccessful: boolean, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, region?: string | null | undefined, city?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, channels?: Array<{ __typename?: 'Channel', id: string, name: string, description?: string | null | undefined }> | null | undefined } | null | undefined } };

export type DeleteLocationMutationVariables = Exact<{
  input: DeleteLocationInput;
}>;


export type DeleteLocationMutation = { __typename?: 'Mutation', deleteLocation: { __typename?: 'DeleteLocationPayload', isSuccessful: boolean } };

export type CreateLocationMutationVariables = Exact<{
  input: CreateLocationInput;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation: { __typename?: 'CreateLocationPayload', isSuccessful: boolean, location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, region?: string | null | undefined, city?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, channels?: Array<{ __typename?: 'Channel', id: string, name: string, description?: string | null | undefined }> | null | undefined } | null | undefined } };

export type GetLocationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, region?: string | null | undefined, city?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, channels?: Array<{ __typename?: 'Channel', id: string, name: string, description?: string | null | undefined }> | null | undefined } | null | undefined };

export type GetProfileLocationsQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  findExact?: InputMaybe<Scalars['Boolean']['input']>;
  excludeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetProfileLocationsQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, locations: Array<{ __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, region?: string | null | undefined, city?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, channels?: Array<{ __typename?: 'Channel', id: string, name: string, description?: string | null | undefined }> | null | undefined }> } | null | undefined };

export type ProfileLocationsFragment = { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, region?: string | null | undefined, city?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined, channels?: Array<{ __typename?: 'Channel', id: string, name: string, description?: string | null | undefined }> | null | undefined };

export type UpdateNotificationStatusMutationVariables = Exact<{
  input: NotificationStatusInput;
}>;


export type UpdateNotificationStatusMutation = { __typename?: 'Mutation', updateNotificationStatus: { __typename?: 'SaveNotificationPayload', isSuccessful: boolean, notification?: { __typename?: 'Notification', id: string, title: string } | null | undefined } };

export type UpdateBulkNotificationStatusMutationVariables = Exact<{
  input: BulkNotificationStatusInput;
}>;


export type UpdateBulkNotificationStatusMutation = { __typename?: 'Mutation', updateBulkNotificationStatus: { __typename?: 'UpdateBulkNotificationStatusPayload', isSuccessful: boolean } };

export type GetNotificationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<FilterOptionsInput>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'PaginatedNotifications', total: number, results: Array<{ __typename?: 'Notification', id: string, createdAt: any, title: string, message?: string | null | undefined, referenceId?: string | null | undefined, content: { __typename?: 'ChannelDetailNotificationContent' } | { __typename?: 'DeviceDeletionNotificationContent' } | { __typename?: 'DeviceDetailNotificationContent' } | { __typename?: 'DeviceStatusNotificationContent', id?: string | null | undefined, name?: string | null | undefined, type: NotificationContentType, status?: string | null | undefined } | { __typename?: 'LocationDetailNotificationContent' } | { __typename?: 'MediaUploadFailedNotificationContent', name?: string | null | undefined, resourceType?: string | null | undefined, type: NotificationContentType, filepath?: string | null | undefined, folder?: string | null | undefined, folderGroupType?: string | null | undefined, tempFilename?: string | null | undefined } | { __typename?: 'MediaUploadLargeNotificationContent', name?: string | null | undefined, publicId?: string | null | undefined, resourceType?: string | null | undefined, status?: string | null | undefined, type: NotificationContentType } | { __typename?: 'MediaUploadNotificationContent', id?: string | null | undefined, name?: string | null | undefined, resourceType?: string | null | undefined, type: NotificationContentType, url?: string | null | undefined } }> } };

export type NewNotificationSubscriptionSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
  profileId?: InputMaybe<Scalars['ID']['input']>;
  contentTypes: Array<NotificationContentType> | NotificationContentType;
}>;


export type NewNotificationSubscriptionSubscription = { __typename?: 'Subscription', newNotification: { __typename?: 'SaveNotificationPayload', isSuccessful: boolean, notification?: { __typename?: 'Notification', id: string, createdAt: any, title: string, message?: string | null | undefined, referenceId?: string | null | undefined, content: { __typename?: 'ChannelDetailNotificationContent' } | { __typename?: 'DeviceDeletionNotificationContent' } | { __typename?: 'DeviceDetailNotificationContent' } | { __typename?: 'DeviceStatusNotificationContent', id?: string | null | undefined, name?: string | null | undefined, type: NotificationContentType, status?: string | null | undefined } | { __typename?: 'LocationDetailNotificationContent' } | { __typename?: 'MediaUploadFailedNotificationContent', name?: string | null | undefined, resourceType?: string | null | undefined, type: NotificationContentType, filepath?: string | null | undefined, folder?: string | null | undefined, folderGroupType?: string | null | undefined, tempFilename?: string | null | undefined } | { __typename?: 'MediaUploadLargeNotificationContent', name?: string | null | undefined, publicId?: string | null | undefined, resourceType?: string | null | undefined, status?: string | null | undefined, type: NotificationContentType } | { __typename?: 'MediaUploadNotificationContent', id?: string | null | undefined, name?: string | null | undefined, resourceType?: string | null | undefined, url?: string | null | undefined, type: NotificationContentType } } | null | undefined } };

export type UpdateNotificationSubscriptionSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
  profileId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateNotificationSubscriptionSubscription = { __typename?: 'Subscription', updateNotification: { __typename?: 'SaveNotificationPayload', isSuccessful: boolean, notification?: { __typename?: 'Notification', id: string, createdAt: any, title: string, message?: string | null | undefined, referenceId?: string | null | undefined, content: { __typename?: 'ChannelDetailNotificationContent' } | { __typename?: 'DeviceDeletionNotificationContent' } | { __typename?: 'DeviceDetailNotificationContent' } | { __typename?: 'DeviceStatusNotificationContent', id?: string | null | undefined, name?: string | null | undefined, type: NotificationContentType, status?: string | null | undefined } | { __typename?: 'LocationDetailNotificationContent' } | { __typename?: 'MediaUploadFailedNotificationContent' } | { __typename?: 'MediaUploadLargeNotificationContent', publicId?: string | null | undefined, resourceType?: string | null | undefined, status?: string | null | undefined, type: NotificationContentType } | { __typename?: 'MediaUploadNotificationContent', id?: string | null | undefined, name?: string | null | undefined, resourceType?: string | null | undefined, url?: string | null | undefined, type: NotificationContentType } } | null | undefined } };

export type UpdateBulkNotificationSubscriptionSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
  profileId?: InputMaybe<Scalars['ID']['input']>;
  contentTypes?: InputMaybe<Array<NotificationContentType> | NotificationContentType>;
}>;


export type UpdateBulkNotificationSubscriptionSubscription = { __typename?: 'Subscription', updateBulkNotification: { __typename?: 'UpdateBulkNotificationStatusPayload', isSuccessful: boolean, notifications?: Array<{ __typename?: 'Notification', id: string, createdAt: any, title: string, message?: string | null | undefined, referenceId?: string | null | undefined, content: { __typename?: 'ChannelDetailNotificationContent' } | { __typename?: 'DeviceDeletionNotificationContent' } | { __typename?: 'DeviceDetailNotificationContent' } | { __typename?: 'DeviceStatusNotificationContent', id?: string | null | undefined, name?: string | null | undefined, type: NotificationContentType, status?: string | null | undefined } | { __typename?: 'LocationDetailNotificationContent' } | { __typename?: 'MediaUploadFailedNotificationContent' } | { __typename?: 'MediaUploadLargeNotificationContent', publicId?: string | null | undefined, resourceType?: string | null | undefined, status?: string | null | undefined, type: NotificationContentType } | { __typename?: 'MediaUploadNotificationContent', id?: string | null | undefined, name?: string | null | undefined, resourceType?: string | null | undefined, url?: string | null | undefined, type: NotificationContentType } }> | null | undefined } };

export type NewMediaSubscriptionSubscriptionVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type NewMediaSubscriptionSubscription = { __typename?: 'Subscription', newMedia: { __typename?: 'SaveMediaPayload', isSuccessful: boolean, profileId?: string | null | undefined, media?: { __typename?: 'Media', id: string, ownerId?: string | null | undefined, publicId: string, name: string, url: string, type: ResourceType, secureUrl: string, createdAt?: any | null | undefined, folderId?: string | null | undefined, visibility: MediaVisibilityType, source?: { __typename?: 'CloudinaryFile', url?: string | null | undefined, publicId?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'MediaMetadata', duration?: number | null | undefined, format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, bytes?: number | null | undefined, resourceType?: string | null | undefined, publicId?: string | null | undefined, type?: string | null | undefined, createdAt?: any | null | undefined, url?: string | null | undefined, secureUrl?: string | null | undefined, derived?: Array<{ __typename?: 'Derived', bytes: number, extension?: string | null | undefined, format?: string | null | undefined, id: string, secure_url?: string | null | undefined, transformation: string, url: string }> | null | undefined } | null | undefined } | null | undefined } };

export type UpdateMediaSubscriptionSubscriptionVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateMediaSubscriptionSubscription = { __typename?: 'Subscription', updateMedia: { __typename?: 'SaveMediaPayload', isSuccessful: boolean, media?: { __typename?: 'Media', id: string, ownerId?: string | null | undefined, publicId: string, name: string, url: string, type: ResourceType, secureUrl: string, createdAt?: any | null | undefined, folderId?: string | null | undefined, visibility: MediaVisibilityType, source?: { __typename?: 'CloudinaryFile', url?: string | null | undefined, publicId?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'MediaMetadata', duration?: number | null | undefined, format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, bytes?: number | null | undefined, resourceType?: string | null | undefined, publicId?: string | null | undefined, type?: string | null | undefined, createdAt?: any | null | undefined, url?: string | null | undefined, secureUrl?: string | null | undefined, derived?: Array<{ __typename?: 'Derived', bytes: number, extension?: string | null | undefined, format?: string | null | undefined, id: string, secure_url?: string | null | undefined, transformation: string, url: string }> | null | undefined } | null | undefined } | null | undefined } };

export type CurrentUserFragment = { __typename?: 'User', id: string, displayName?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, active?: boolean | null | undefined, profilePicture?: { __typename?: 'Media', id: string, url: string } | null | undefined, auth0Profile?: { __typename?: 'Auth0Profile', family_name?: string | null | undefined, given_name?: string | null | undefined, locale?: string | null | undefined, name?: string | null | undefined, nickname?: string | null | undefined, picture?: string | null | undefined, sub?: string | null | undefined, updated_at?: any | null | undefined, created_at?: any | null | undefined, user_id: string, email?: string | null | undefined, email_verified?: boolean | null | undefined, multifactor?: Array<string | null | undefined> | null | undefined, permissions: Array<{ __typename?: 'Permission', permission_name?: string | null | undefined }>, roles: Array<{ __typename?: 'Role', name?: string | null | undefined }>, user_metadata?: { __typename?: 'UserMeta', use_mfa?: boolean | null | undefined } | null | undefined } | null | undefined };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, displayName?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, active?: boolean | null | undefined, profilePicture?: { __typename?: 'Media', id: string, url: string } | null | undefined, auth0Profile?: { __typename?: 'Auth0Profile', family_name?: string | null | undefined, given_name?: string | null | undefined, locale?: string | null | undefined, name?: string | null | undefined, nickname?: string | null | undefined, picture?: string | null | undefined, sub?: string | null | undefined, updated_at?: any | null | undefined, created_at?: any | null | undefined, user_id: string, email?: string | null | undefined, email_verified?: boolean | null | undefined, multifactor?: Array<string | null | undefined> | null | undefined, permissions: Array<{ __typename?: 'Permission', permission_name?: string | null | undefined }>, roles: Array<{ __typename?: 'Role', name?: string | null | undefined }>, user_metadata?: { __typename?: 'UserMeta', use_mfa?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type GetMeProfilesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMeProfilesQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, profiles?: { __typename?: 'PaginatedProfiles', total: number, results: Array<{ __typename?: 'Profile', id: string, name?: string | null | undefined, active?: boolean | null | undefined, settings?: { __typename?: 'ProfileSettings', dateFormat?: string | null | undefined, timeFormat?: string | null | undefined, timeZone?: string | null | undefined } | null | undefined, locations: Array<{ __typename?: 'Location', id: string, name: string }>, features?: Array<{ __typename?: 'Feature', id: CustomFeatures } | null | undefined> | null | undefined }> } | null | undefined } | null | undefined };

export type GetActiveProfileDetailsFromServerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetActiveProfileDetailsFromServerQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, active?: boolean | null | undefined, settings?: { __typename?: 'ProfileSettings', dateFormat?: string | null | undefined, timeFormat?: string | null | undefined, timeZone?: string | null | undefined } | null | undefined, locations: Array<{ __typename?: 'Location', id: string, name: string }>, features?: Array<{ __typename?: 'Feature', id: CustomFeatures } | null | undefined> | null | undefined } | null | undefined };

export type MeProfileFragment = { __typename?: 'Profile', id: string, name?: string | null | undefined, active?: boolean | null | undefined, settings?: { __typename?: 'ProfileSettings', dateFormat?: string | null | undefined, timeFormat?: string | null | undefined, timeZone?: string | null | undefined } | null | undefined, locations: Array<{ __typename?: 'Location', id: string, name: string }>, features?: Array<{ __typename?: 'Feature', id: CustomFeatures } | null | undefined> | null | undefined };

export type SaveMediaFromCloudMutationVariables = Exact<{
  input: SaveMediaInput;
}>;


export type SaveMediaFromCloudMutation = { __typename?: 'Mutation', saveMedia: { __typename?: 'SaveMediaPayload', isSuccessful: boolean, media?: { __typename?: 'Media', id: string, publicId: string, ownerId?: string | null | undefined, name: string, url: string, type: ResourceType, visibility: MediaVisibilityType, secureUrl: string, source?: { __typename?: 'CloudinaryFile', publicId?: string | null | undefined, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'MediaMetadata', width?: number | null | undefined, height?: number | null | undefined, bytes?: number | null | undefined, resourceType?: string | null | undefined, format?: string | null | undefined, uploadedAt?: any | null | undefined, duration?: number | null | undefined } | null | undefined } | null | undefined } };

export type DeleteMediaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMediaMutation = { __typename?: 'Mutation', deleteMedia: { __typename?: 'DeleteMediaPayload', isSuccessful: boolean } };

export type DeleteMediaListMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteMediaListMutation = { __typename?: 'Mutation', deleteMediaList: { __typename?: 'DeleteMediaPayload', isSuccessful: boolean } };

export type UpdateMediaMutationVariables = Exact<{
  input: UpdateMediaInput;
}>;


export type UpdateMediaMutation = { __typename?: 'Mutation', updateMedia: { __typename?: 'UpdateMediaPayload', isSuccessful: boolean, media?: { __typename?: 'Media', id: string, name: string, publicId: string, ownerId?: string | null | undefined, url: string, type: ResourceType, secureUrl: string, createdAt?: any | null | undefined, visibility: MediaVisibilityType, source?: { __typename?: 'CloudinaryFile', publicId?: string | null | undefined, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'MediaMetadata', width?: number | null | undefined, height?: number | null | undefined, bytes?: number | null | undefined, resourceType?: string | null | undefined, format?: string | null | undefined, uploadedAt?: any | null | undefined, duration?: number | null | undefined } | null | undefined } | null | undefined } };

export type MoveMediaFolderMutationVariables = Exact<{
  input: MoveMediaFolderInput;
}>;


export type MoveMediaFolderMutation = { __typename?: 'Mutation', moveMediaFolder?: { __typename?: 'MoveMediaFolderPayload', isSuccessful: boolean } | null | undefined };

export type GetMediaForMediaManagePageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMediaForMediaManagePageQuery = { __typename?: 'Query', media?: { __typename?: 'Media', id: string, publicId: string, ownerId?: string | null | undefined, name: string, url: string, type: ResourceType, visibility: MediaVisibilityType, secureUrl: string, folderId?: string | null | undefined, source?: { __typename?: 'CloudinaryFile', publicId?: string | null | undefined, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'MediaMetadata', width?: number | null | undefined, height?: number | null | undefined, bytes?: number | null | undefined, resourceType?: string | null | undefined, secureUrl?: string | null | undefined, version?: number | null | undefined, filename?: string | null | undefined, format?: string | null | undefined, createdAt?: any | null | undefined, uploadedAt?: any | null | undefined, status?: string | null | undefined, aspectRatio?: number | null | undefined, pixels?: number | null | undefined, duration?: number | null | undefined, etag?: string | null | undefined, accessMode?: string | null | undefined, accessControl?: string | null | undefined } | null | undefined } | null | undefined };

export type GetCloudinarySignatureQueryVariables = Exact<{
  uploadForm?: InputMaybe<CloudinarySignableForm>;
}>;


export type GetCloudinarySignatureQuery = { __typename?: 'Query', mediaCloudinarySignature?: { __typename?: 'CloudinarySignature', signature?: string | null | undefined } | null | undefined };

export type GetProfileMediaForMediaListQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  filters?: InputMaybe<MediaFiltersInput>;
  options?: InputMaybe<MediaOptionsInput>;
}>;


export type GetProfileMediaForMediaListQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, media: { __typename?: 'PaginatedMedia', total: number, results: Array<{ __typename?: 'Media', id: string, ownerId?: string | null | undefined, publicId: string, name: string, url: string, type: ResourceType, secureUrl: string, createdAt?: any | null | undefined, folderId?: string | null | undefined, visibility: MediaVisibilityType, source?: { __typename?: 'CloudinaryFile', url?: string | null | undefined, publicId?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'MediaMetadata', duration?: number | null | undefined, format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, bytes?: number | null | undefined, resourceType?: string | null | undefined, publicId?: string | null | undefined, type?: string | null | undefined, createdAt?: any | null | undefined, url?: string | null | undefined, secureUrl?: string | null | undefined, derived?: Array<{ __typename?: 'Derived', bytes: number, extension?: string | null | undefined, format?: string | null | undefined, id: string, secure_url?: string | null | undefined, transformation: string, url: string }> | null | undefined } | null | undefined }> } } | null | undefined };

export type GetProfileTemplatesQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  filters?: InputMaybe<MediaFiltersInput>;
  options?: InputMaybe<MediaOptionsInput>;
}>;


export type GetProfileTemplatesQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, template: { __typename?: 'PaginatedMedia', total: number, results: Array<{ __typename?: 'Media', id: string, ownerId?: string | null | undefined, publicId: string, name: string, url: string, type: ResourceType, secureUrl: string, createdAt?: any | null | undefined, folderId?: string | null | undefined, visibility: MediaVisibilityType, source?: { __typename?: 'CloudinaryFile', url?: string | null | undefined, publicId?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'MediaMetadata', duration?: number | null | undefined, format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, bytes?: number | null | undefined, resourceType?: string | null | undefined, publicId?: string | null | undefined, type?: string | null | undefined, createdAt?: any | null | undefined, url?: string | null | undefined, secureUrl?: string | null | undefined, derived?: Array<{ __typename?: 'Derived', bytes: number, extension?: string | null | undefined, format?: string | null | undefined, id: string, secure_url?: string | null | undefined, transformation: string, url: string }> | null | undefined } | null | undefined }> } } | null | undefined };

export type GetUserMediaForMediaListQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  filters?: InputMaybe<MediaFiltersInput>;
  options?: InputMaybe<MediaOptionsInput>;
}>;


export type GetUserMediaForMediaListQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, displayName?: string | null | undefined, media?: Array<{ __typename?: 'Media', id: string, ownerId?: string | null | undefined, publicId: string, name: string, url: string, type: ResourceType, secureUrl: string, createdAt?: any | null | undefined, folderId?: string | null | undefined, visibility: MediaVisibilityType, source?: { __typename?: 'CloudinaryFile', url?: string | null | undefined, publicId?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'MediaMetadata', duration?: number | null | undefined, format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, bytes?: number | null | undefined, resourceType?: string | null | undefined, publicId?: string | null | undefined, type?: string | null | undefined, createdAt?: any | null | undefined, url?: string | null | undefined, secureUrl?: string | null | undefined, derived?: Array<{ __typename?: 'Derived', bytes: number, extension?: string | null | undefined, format?: string | null | undefined, id: string, secure_url?: string | null | undefined, transformation: string, url: string }> | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type MediaDetailedFragment = { __typename?: 'Media', id: string, publicId: string, ownerId?: string | null | undefined, name: string, url: string, type: ResourceType, visibility: MediaVisibilityType, secureUrl: string, folderId?: string | null | undefined, source?: { __typename?: 'CloudinaryFile', publicId?: string | null | undefined, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'MediaMetadata', width?: number | null | undefined, height?: number | null | undefined, bytes?: number | null | undefined, resourceType?: string | null | undefined, secureUrl?: string | null | undefined, version?: number | null | undefined, filename?: string | null | undefined, format?: string | null | undefined, createdAt?: any | null | undefined, uploadedAt?: any | null | undefined, status?: string | null | undefined, aspectRatio?: number | null | undefined, pixels?: number | null | undefined, duration?: number | null | undefined, etag?: string | null | undefined, accessMode?: string | null | undefined, accessControl?: string | null | undefined } | null | undefined };

export type MediaForMediaListFragment = { __typename?: 'Media', id: string, ownerId?: string | null | undefined, publicId: string, name: string, url: string, type: ResourceType, secureUrl: string, createdAt?: any | null | undefined, folderId?: string | null | undefined, visibility: MediaVisibilityType, source?: { __typename?: 'CloudinaryFile', url?: string | null | undefined, publicId?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'MediaMetadata', duration?: number | null | undefined, format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, bytes?: number | null | undefined, resourceType?: string | null | undefined, publicId?: string | null | undefined, type?: string | null | undefined, createdAt?: any | null | undefined, url?: string | null | undefined, secureUrl?: string | null | undefined, derived?: Array<{ __typename?: 'Derived', bytes: number, extension?: string | null | undefined, format?: string | null | undefined, id: string, secure_url?: string | null | undefined, transformation: string, url: string }> | null | undefined } | null | undefined };

export type SaveNotificationMutationVariables = Exact<{
  input: NotificationInput;
}>;


export type SaveNotificationMutation = { __typename?: 'Mutation', saveNotification: { __typename?: 'SaveNotificationPayload', isSuccessful: boolean } };

export type GetOrganizationsForOrganizationListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  findExact?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrganizationsForOrganizationListQuery = { __typename?: 'Query', organizations: { __typename?: 'PaginatedOrganizations', total: number, results: Array<{ __typename?: 'Organization', id: string, name: string, organizationUid?: string | null | undefined, title: string, active?: boolean | null | undefined, createdAt: any, updatedAt: any, devices?: Array<{ __typename?: 'Device', id: string, name: string }> | null | undefined, profiles?: { __typename?: 'PaginatedProfiles', total: number, results: Array<{ __typename?: 'Profile', id: string, name?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, active?: boolean | null | undefined, organizationUid?: string | null | undefined }> } | null | undefined }> } };

export type GetAllOrganizationsForOrganizationSelectionQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllOrganizationsForOrganizationSelectionQuery = { __typename?: 'Query', organizations: { __typename?: 'PaginatedOrganizations', total: number, results: Array<{ __typename?: 'Organization', id: string, name: string, title: string, organizationUid?: string | null | undefined, createdAt: any, updatedAt: any }> } };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'CreateOrganizationPayload', isSuccessful: boolean, organization?: { __typename?: 'Organization', id: string, organizationUid?: string | null | undefined, name: string, active?: boolean | null | undefined, title: string, createdAt: any, updatedAt: any, devices?: Array<{ __typename?: 'Device', id: string, name: string }> | null | undefined, profiles?: { __typename?: 'PaginatedProfiles', results: Array<{ __typename?: 'Profile', id: string, name?: string | null | undefined }> } | null | undefined } | null | undefined } };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'UpdateOrganizationPayload', isSuccessful: boolean, organization?: { __typename?: 'Organization', active?: boolean | null | undefined, id: string, name: string, organizationUid?: string | null | undefined, title: string, createdAt: any, updatedAt: any } | null | undefined } };

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization: { __typename?: 'DeleteOrganizationPayload', isSuccessful: boolean } };

export type RemovePlaylistsFromChannelMutationVariables = Exact<{
  input: RemovePlaylistsFromChannelInput;
}>;


export type RemovePlaylistsFromChannelMutation = { __typename?: 'Mutation', removePlaylistsFromChannel: { __typename?: 'RemovePlaylistsFromChannelPayload', isSuccessful: boolean } };

export type GetDevicePingPlaylistsInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDevicePingPlaylistsInfoQuery = { __typename?: 'Query', devicePings?: { __typename?: 'PaginatedDevicePings', results: Array<{ __typename?: 'DevicePing', timestamp?: any | null | undefined, playlistsInfo?: Array<{ __typename?: 'PlaylistInfo', lastUpdated?: any | null | undefined, playlistId?: string | null | undefined }> | null | undefined }> } | null | undefined };

export type DeletePlaylistsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeletePlaylistsMutation = { __typename?: 'Mutation', deletePlaylists: { __typename?: 'DeletePlaylistPayload', isSuccessful: boolean } };

export type DuplicatePlaylistsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DuplicatePlaylistsMutation = { __typename?: 'Mutation', duplicatePlaylists: { __typename?: 'DuplicatePlaylistPayload', isSuccessful: boolean, playlistIds?: Array<string | null | undefined> | null | undefined } };

export type BulkActionPlaylistsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  action: PlaylistBulkAction;
  input: BulkActionPlaylistInput;
}>;


export type BulkActionPlaylistsMutation = { __typename?: 'Mutation', bulkActionPlaylists: { __typename?: 'BulkActionPlaylistsPayload', updateResults: Array<{ __typename?: 'BulkActionPlaylistUpdateResultPayload', isSuccessful: boolean, playlistId: string }> } };

export type GetPlaylistsForPlaylistListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus> | PlaylistStatus>;
  onlyParentPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPlaylistsForPlaylistListQuery = { __typename?: 'Query', playlists: { __typename?: 'PaginatedPlaylists', total: number, results: Array<{ __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, updatedAt: any, createdAt: any, startDate?: any | null | undefined, endDate?: any | null | undefined, previewContent?: { __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, duration?: number | null | undefined, uri?: string | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, uri?: string | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | null | undefined, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, status: PlaylistStatus, channels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null | undefined> | null | undefined }> } };

export type GetProfilePlaylistsQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  playlistId?: InputMaybe<Scalars['ID']['input']>;
  playlistName?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus> | PlaylistStatus>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  onlyParentPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProfilePlaylistsQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, updatedAt: any, createdAt: any, startDate?: any | null | undefined, endDate?: any | null | undefined, previewContent?: { __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, duration?: number | null | undefined, uri?: string | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, uri?: string | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | null | undefined, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, status: PlaylistStatus, channels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null | undefined> | null | undefined }> } | null | undefined };

export type GetDevicePlaylistsQueryVariables = Exact<{
  deviceId: Scalars['ID']['input'];
  playlistName?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus> | PlaylistStatus>;
  onlyParentPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDevicePlaylistsQuery = { __typename?: 'Query', device?: { __typename?: 'Device', id: string, name: string, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, updatedAt: any, createdAt: any, startDate?: any | null | undefined, endDate?: any | null | undefined, previewContent?: { __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, duration?: number | null | undefined, uri?: string | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, uri?: string | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | null | undefined, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, status: PlaylistStatus, channels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null | undefined> | null | undefined }> } | null | undefined };

export type GetChannelPlaylistsQueryVariables = Exact<{
  channelId: Scalars['ID']['input'];
  playlistName?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus> | PlaylistStatus>;
  onlyParentPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetChannelPlaylistsQuery = { __typename?: 'Query', channel?: { __typename?: 'Channel', id: string, name: string, playlistRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, playlistId: string, region?: string | null | undefined }> | null | undefined, playlists: Array<{ __typename?: 'Playlist', region?: string | null | undefined, createdAt: any, startDate?: any | null | undefined, endDate?: any | null | undefined, id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType, assets: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }>, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, status: PlaylistStatus, channels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null | undefined> | null | undefined, parentPlaylist?: { __typename?: 'Playlist', id: string } | null | undefined }> } | null | undefined };

export type GetLocationPlaylistsQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  playlistName?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus> | PlaylistStatus>;
  onlyParentPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetLocationPlaylistsQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, name: string, playlists?: Array<{ __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, updatedAt: any, createdAt: any, startDate?: any | null | undefined, endDate?: any | null | undefined, previewContent?: { __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, duration?: number | null | undefined, uri?: string | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, uri?: string | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | null | undefined, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, status: PlaylistStatus, channels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null | undefined> | null | undefined }> | null | undefined } | null | undefined };

export type GetChannelGroupPlaylistsQueryVariables = Exact<{
  channelGroupId: Scalars['ID']['input'];
  playlistName?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus> | PlaylistStatus>;
  onlyParentPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetChannelGroupPlaylistsQuery = { __typename?: 'Query', channelGroup?: { __typename?: 'ChannelGroup', id: string, name: string, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, updatedAt: any, createdAt: any, startDate?: any | null | undefined, endDate?: any | null | undefined, previewContent?: { __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, duration?: number | null | undefined, uri?: string | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, uri?: string | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | null | undefined, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, status: PlaylistStatus, channels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null | undefined> | null | undefined }> } | null | undefined };

export type GetProfileUserChannelPlaylistsQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  playlistName?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus> | PlaylistStatus>;
}>;


export type GetProfileUserChannelPlaylistsQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, users: Array<{ __typename?: 'User', id: string, playlists?: Array<{ __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, updatedAt: any, createdAt: any, startDate?: any | null | undefined, endDate?: any | null | undefined, previewContent?: { __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, duration?: number | null | undefined, uri?: string | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, uri?: string | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | null | undefined, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, status: PlaylistStatus, channels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null | undefined> | null | undefined }> | null | undefined, channels?: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, updatedAt: any, createdAt: any, startDate?: any | null | undefined, endDate?: any | null | undefined, previewContent?: { __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, duration?: number | null | undefined, uri?: string | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, uri?: string | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | null | undefined, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, status: PlaylistStatus, channels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null | undefined> | null | undefined }>, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> } | null | undefined };

export type GetDetailedPlaylistQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDetailedPlaylistQuery = { __typename?: 'Query', playlist?: { __typename?: 'Playlist', createdAt: any, startDate?: any | null | undefined, endDate?: any | null | undefined, id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType, assets: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }>, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, status: PlaylistStatus, channels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null | undefined> | null | undefined, parentPlaylist?: { __typename?: 'Playlist', id: string } | null | undefined } | null | undefined };

export type PlaylistForPlaylistListFragment = { __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, updatedAt: any, createdAt: any, startDate?: any | null | undefined, endDate?: any | null | undefined, previewContent?: { __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, duration?: number | null | undefined, uri?: string | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, uri?: string | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | null | undefined, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, status: PlaylistStatus, channels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null | undefined> | null | undefined };

export type DetailedPlaylistFragment = { __typename?: 'Playlist', createdAt: any, startDate?: any | null | undefined, endDate?: any | null | undefined, id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType, assets: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }>, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, status: PlaylistStatus, channels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null | undefined> | null | undefined, parentPlaylist?: { __typename?: 'Playlist', id: string } | null | undefined };

export type DetailedPlaylistForChannelFragment = { __typename?: 'Playlist', region?: string | null | undefined, createdAt: any, startDate?: any | null | undefined, endDate?: any | null | undefined, id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType, assets: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }>, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, status: PlaylistStatus, channels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null | undefined> | null | undefined, parentPlaylist?: { __typename?: 'Playlist', id: string } | null | undefined };

export type GetPlaylistDetailedQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPlaylistDetailedQuery = { __typename?: 'Query', playlist?: { __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, startDate?: any | null | undefined, endDate?: any | null | undefined, createdAt: any, updatedAt: any, publishedPlaylist?: { __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, startDate?: any | null | undefined, endDate?: any | null | undefined, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined } | null | undefined, channelRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, region?: string | null | undefined }> | null | undefined, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, assets: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }> } | null | undefined, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType } | null | undefined> | null | undefined, profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined } | null | undefined, channelRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, region?: string | null | undefined }> | null | undefined, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, assets: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }> } | null | undefined };

export type ChannelToPlaylistFragment = { __typename?: 'Channel', id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type PlaylistVersionDetailedFragment = { __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, startDate?: any | null | undefined, endDate?: any | null | undefined, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined } | null | undefined, channelRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, region?: string | null | undefined }> | null | undefined, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, assets: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }> };

export type PlaylistVersionBonsaiFragment = { __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType };

export type PlaylistDetailedFragment = { __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, startDate?: any | null | undefined, endDate?: any | null | undefined, createdAt: any, updatedAt: any, publishedPlaylist?: { __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, startDate?: any | null | undefined, endDate?: any | null | undefined, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined } | null | undefined, channelRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, region?: string | null | undefined }> | null | undefined, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, assets: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }> } | null | undefined, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType } | null | undefined> | null | undefined, profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined } | null | undefined, channelRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, region?: string | null | undefined }> | null | undefined, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, assets: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }> };

export type AssetWithScheduleForAssetManageFragment = { __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, content: Array<{ __typename: 'BrowserAsset' } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignStart?: string | null | undefined, campaignEnd?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignStart?: string | null | undefined, campaignEnd?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignStart?: string | null | undefined, campaignEnd?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, uri?: string | null | undefined, duration?: number | null | undefined, campaignStart?: string | null | undefined, campaignEnd?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset' }> };

export type AssetWithMediaForAssetManageFragment = { __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> };

export type DeletePlaylistMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePlaylistMutation = { __typename?: 'Mutation', deletePlaylist: { __typename?: 'DeletePlaylistPayload', isSuccessful: boolean } };

export type CreateAssetForSequenceMutationVariables = Exact<{
  input: CreateAssetInput;
}>;


export type CreateAssetForSequenceMutation = { __typename?: 'Mutation', createAsset: { __typename?: 'CreateAssetPayload', isSuccessful: boolean, asset?: { __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> } | null | undefined } };

export type CreatePlaylistMutationVariables = Exact<{
  input: CreatePlaylistInput;
}>;


export type CreatePlaylistMutation = { __typename?: 'Mutation', createPlaylist: { __typename?: 'CreatePlaylistPayload', isSuccessful: boolean, playlist?: { __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, startDate?: any | null | undefined, endDate?: any | null | undefined, createdAt: any, updatedAt: any, publishedPlaylist?: { __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, startDate?: any | null | undefined, endDate?: any | null | undefined, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined } | null | undefined, channelRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, region?: string | null | undefined }> | null | undefined, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, assets: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }> } | null | undefined, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType } | null | undefined> | null | undefined, profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined } | null | undefined, channelRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, region?: string | null | undefined }> | null | undefined, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, assets: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }> } | null | undefined } };

export type UpdatePlaylistMutationVariables = Exact<{
  input: UpdatePlaylistInput;
}>;


export type UpdatePlaylistMutation = { __typename?: 'Mutation', updatePlaylist: { __typename?: 'UpdatePlaylistPayload', isSuccessful: boolean, playlist?: { __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, startDate?: any | null | undefined, endDate?: any | null | undefined, createdAt: any, updatedAt: any, publishedPlaylist?: { __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, type: PlaylistType, startDate?: any | null | undefined, endDate?: any | null | undefined, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined } | null | undefined, channelRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, region?: string | null | undefined }> | null | undefined, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, assets: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }> } | null | undefined, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, name: string, updatedAt: any, status: PlaylistStatus, type: PlaylistType } | null | undefined> | null | undefined, profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined } | null | undefined, channelRegions?: Array<{ __typename?: 'ChannelPlaylist', channelId: string, region?: string | null | undefined }> | null | undefined, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, assets: Array<{ __typename?: 'Asset', id: string, name: string, sequence?: number | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, actualStartTime?: string | null | undefined, actualEndTime?: string | null | undefined, content: Array<{ __typename: 'BrowserAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, useNativeBrowser?: boolean | null | undefined, clearData?: boolean | null | undefined, headlessMode?: boolean | null | undefined, whiteListDomains?: string | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined } | { __typename: 'HtmlAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, htmlContent?: any | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'IFrameAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined } | { __typename: 'ImageAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, transitionEffect?: { __typename?: 'TransitionEffect', name?: string | null | undefined, duration?: number | null | undefined } | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'VideoAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, publicId?: string | null | undefined, name: string, sequence?: number | null | undefined, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, height?: number | null | undefined, width?: number | null | undefined, interactiveLayoutSource?: string | null | undefined, disabled?: boolean | null | undefined, resizeCropMethod?: { __typename?: 'ResizeCropMethod', name?: string | null | undefined, uri?: string | null | undefined } | null | undefined, media?: { __typename?: 'Media', id: string, metadata?: { __typename?: 'MediaMetadata', format?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined, days?: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null | undefined, interactiveRegions?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | { __typename: 'WidgetAsset', id?: string | null | undefined, contentId?: string | null | undefined, type: AssetType, name: string, duration?: number | null | undefined, uri?: string | null | undefined, campaignEnd?: string | null | undefined, campaignStart?: string | null | undefined, disabled?: boolean | null | undefined, widgetConfig?: any | null | undefined, days?: { __typename?: 'ScheduleDays', sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null | undefined }> }> } | null | undefined } };

export type ForcePublishDevicePlaylistMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  action: PlaylistBulkAction;
  input: BulkActionPlaylistInput;
}>;


export type ForcePublishDevicePlaylistMutation = { __typename?: 'Mutation', bulkActionPlaylists: { __typename?: 'BulkActionPlaylistsPayload', updateResults: Array<{ __typename?: 'BulkActionPlaylistUpdateResultPayload', isSuccessful: boolean, playlistId: string }> } };

export type PublishChannelsContentMutationVariables = Exact<{
  input: PublishChannelsInput;
}>;


export type PublishChannelsContentMutation = { __typename?: 'Mutation', publishChannels?: { __typename?: 'BaseMutationPayload', isSuccessful: boolean } | null | undefined };

export type GetPlaylistChildQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPlaylistChildQuery = { __typename?: 'Query', playlist?: { __typename?: 'Playlist', id: string, childPlaylists?: Array<{ __typename?: 'Playlist', id: string, name: string, status: PlaylistStatus, updatedAt: any, createdAt: any, startDate?: any | null | undefined, endDate?: any | null | undefined, comment?: string | null | undefined, channels: Array<{ __typename?: 'Channel', id: string, name: string, type: ChannelType, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined }> } | null | undefined> | null | undefined } | null | undefined };

export type GetProfileForSettingsPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProfileForSettingsPageQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, active?: boolean | null | undefined, deleteOn?: any | null | undefined, website?: string | null | undefined, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, owner?: { __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined } | null | undefined, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined }>, defaultLocation?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, organization?: { __typename?: 'Organization', id: string, name: string, active?: boolean | null | undefined, organizationUid?: string | null | undefined, title: string, createdAt: any, updatedAt: any } | null | undefined, settings?: { __typename?: 'ProfileSettings', dateFormat?: string | null | undefined, timeFormat?: string | null | undefined, timeZone?: string | null | undefined } | null | undefined, features?: Array<{ __typename?: 'Feature', id: CustomFeatures } | null | undefined> | null | undefined } | null | undefined };

export type ActivateProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActivateProfileMutation = { __typename?: 'Mutation', activateProfile: { __typename?: 'ActivateProfilePayload', isSuccessful: boolean, profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, active?: boolean | null | undefined, deleteOn?: any | null | undefined, website?: string | null | undefined, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, owner?: { __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined } | null | undefined, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined }>, defaultLocation?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, organization?: { __typename?: 'Organization', id: string, name: string, active?: boolean | null | undefined, organizationUid?: string | null | undefined, title: string, createdAt: any, updatedAt: any } | null | undefined, settings?: { __typename?: 'ProfileSettings', dateFormat?: string | null | undefined, timeFormat?: string | null | undefined, timeZone?: string | null | undefined } | null | undefined, features?: Array<{ __typename?: 'Feature', id: CustomFeatures } | null | undefined> | null | undefined } | null | undefined } };

export type ProfileDetailedFragment = { __typename?: 'Profile', id: string, name?: string | null | undefined, active?: boolean | null | undefined, deleteOn?: any | null | undefined, website?: string | null | undefined, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, owner?: { __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined } | null | undefined, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined }>, defaultLocation?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, organization?: { __typename?: 'Organization', id: string, name: string, active?: boolean | null | undefined, organizationUid?: string | null | undefined, title: string, createdAt: any, updatedAt: any } | null | undefined, settings?: { __typename?: 'ProfileSettings', dateFormat?: string | null | undefined, timeFormat?: string | null | undefined, timeZone?: string | null | undefined } | null | undefined, features?: Array<{ __typename?: 'Feature', id: CustomFeatures } | null | undefined> | null | undefined };

export type GetProfileForDetailPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProfileForDetailPageQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, active?: boolean | null | undefined, deleteOn?: any | null | undefined, website?: string | null | undefined, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, owner?: { __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined } | null | undefined, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined }>, defaultLocation?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, organization?: { __typename?: 'Organization', id: string, name: string, active?: boolean | null | undefined, organizationUid?: string | null | undefined, title: string, createdAt: any, updatedAt: any } | null | undefined, settings?: { __typename?: 'ProfileSettings', dateFormat?: string | null | undefined, timeFormat?: string | null | undefined, timeZone?: string | null | undefined } | null | undefined, features?: Array<{ __typename?: 'Feature', id: CustomFeatures } | null | undefined> | null | undefined } | null | undefined };

export type GetProfilesForProfileListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProfilesForProfileListQuery = { __typename?: 'Query', profiles: { __typename?: 'PaginatedProfiles', total: number, results: Array<{ __typename?: 'Profile', id: string, name?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, active?: boolean | null | undefined, owner?: { __typename?: 'User', id: string, displayName?: string | null | undefined } | null | undefined, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined }>, channels: Array<{ __typename?: 'Channel', id: string, name: string }> }> } };

export type GetUserProfilesForProfileListQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserProfilesForProfileListQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, profiles?: { __typename?: 'PaginatedProfiles', total: number, results: Array<{ __typename?: 'Profile', id: string, name?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, active?: boolean | null | undefined, owner?: { __typename?: 'User', id: string, displayName?: string | null | undefined } | null | undefined, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined }>, channels: Array<{ __typename?: 'Channel', id: string, name: string }> }> } | null | undefined } | null | undefined };

export type GetAllProfilesForProfileSelectionQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllProfilesForProfileSelectionQuery = { __typename?: 'Query', profiles: { __typename?: 'PaginatedProfiles', total: number, results: Array<{ __typename?: 'Profile', id: string, name?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, active?: boolean | null | undefined, organizationUid?: string | null | undefined }> } };

export type GetProfileForProfileUsersPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProfileForProfileUsersPageQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, active?: boolean | null | undefined, deleteOn?: any | null | undefined, website?: string | null | undefined, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, owner?: { __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined } | null | undefined, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined }>, defaultLocation?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, organization?: { __typename?: 'Organization', id: string, name: string, active?: boolean | null | undefined, organizationUid?: string | null | undefined, title: string, createdAt: any, updatedAt: any } | null | undefined, settings?: { __typename?: 'ProfileSettings', dateFormat?: string | null | undefined, timeFormat?: string | null | undefined, timeZone?: string | null | undefined } | null | undefined, features?: Array<{ __typename?: 'Feature', id: CustomFeatures } | null | undefined> | null | undefined } | null | undefined };

export type GetOrganizationProfilesForProfileListQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationProfilesForProfileListQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, profiles?: { __typename?: 'PaginatedProfiles', total: number, results: Array<{ __typename?: 'Profile', id: string, name?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, active?: boolean | null | undefined, owner?: { __typename?: 'User', id: string, displayName?: string | null | undefined } | null | undefined, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined }>, channels: Array<{ __typename?: 'Channel', id: string, name: string }> }> } | null | undefined } | null | undefined };

export type ProfilesForProfileListFragment = { __typename?: 'PaginatedProfiles', total: number, results: Array<{ __typename?: 'Profile', id: string, name?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, active?: boolean | null | undefined, owner?: { __typename?: 'User', id: string, displayName?: string | null | undefined } | null | undefined, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined }>, channels: Array<{ __typename?: 'Channel', id: string, name: string }> }> };

export type GetOrganizationsForProfileSettingsPageQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrganizationsForProfileSettingsPageQuery = { __typename?: 'Query', organizations: { __typename?: 'PaginatedOrganizations', total: number, results: Array<{ __typename?: 'Organization', id: string, name: string, title: string, organizationUid?: string | null | undefined }> } };

export type GetOrganizationsForProfileCreatePageQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrganizationsForProfileCreatePageQuery = { __typename?: 'Query', organizations: { __typename?: 'PaginatedOrganizations', total: number, results: Array<{ __typename?: 'Organization', id: string, name: string, title: string, organizationUid?: string | null | undefined }> } };

export type CreateProfileMutationVariables = Exact<{
  input: CreateProfileInput;
}>;


export type CreateProfileMutation = { __typename?: 'Mutation', createProfile: { __typename?: 'CreateProfilePayload', isSuccessful: boolean, profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, active?: boolean | null | undefined, locations: Array<{ __typename?: 'Location', id: string, name: string }>, channels: Array<{ __typename?: 'Channel', id: string, name: string }> } | null | undefined } };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'UpdateProfilePayload', isSuccessful: boolean, profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, active?: boolean | null | undefined, deleteOn?: any | null | undefined, website?: string | null | undefined, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, organization?: { __typename?: 'Organization', id: string, name: string, active?: boolean | null | undefined, organizationUid?: string | null | undefined, title: string, createdAt: any, updatedAt: any } | null | undefined, owner?: { __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined } | null | undefined, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined }>, defaultLocation?: { __typename?: 'Location', id: string, name: string, streetAddress1?: string | null | undefined, streetAddress2?: string | null | undefined, zip?: string | null | undefined, city?: string | null | undefined, phoneNumber?: string | null | undefined, country?: string | null | undefined, coordinates?: { __typename?: 'Coordinates', x?: number | null | undefined, y?: number | null | undefined } | null | undefined } | null | undefined, settings?: { __typename?: 'ProfileSettings', dateFormat?: string | null | undefined, timeFormat?: string | null | undefined, timeZone?: string | null | undefined } | null | undefined, features?: Array<{ __typename?: 'Feature', id: CustomFeatures } | null | undefined> | null | undefined } | null | undefined } };

export type DeactivateProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  deleteOn: Scalars['DateTime']['input'];
}>;


export type DeactivateProfileMutation = { __typename?: 'Mutation', deactivateProfile: { __typename?: 'DeactivateProfilePayload', isSuccessful: boolean, profile?: { __typename?: 'Profile', id: string, active?: boolean | null | undefined } | null | undefined } };

export type RemoveProfileUserMutationVariables = Exact<{
  input: RemoveProfileUserInput;
}>;


export type RemoveProfileUserMutation = { __typename?: 'Mutation', removeProfileUser: { __typename?: 'RemoveProfileUserPayload', isSuccessful: boolean, message?: string | null | undefined } };

export type UpdateProfileUserRoleMutationVariables = Exact<{
  input: UpdateProfileUserRoleInput;
}>;


export type UpdateProfileUserRoleMutation = { __typename?: 'Mutation', updateProfileUserRole: { __typename?: 'RemoveProfileUserPayload', isSuccessful: boolean, message?: string | null | undefined } };

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser: { __typename?: 'InviteUserPayload', isSuccessful: boolean, url?: string | null | undefined } };

export type CreateUserFromRegistrationMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserFromRegistrationMutation = { __typename?: 'Mutation', createUser: { __typename?: 'CreateUserPayload', isSuccessful: boolean, email?: string | null | undefined, profileName?: string | null | undefined, message?: string | null | undefined } };

export type ExistingUserForRegistrationQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ExistingUserForRegistrationQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, displayName?: string | null | undefined, auth0Profile?: { __typename?: 'Auth0Profile', user_id: string } | null | undefined } | null | undefined };

export type ProfileForRegistrationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProfileForRegistrationQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined }> } | null | undefined };

export type GetProfileChannelsLocationsChannelGroupsForChannelSelectionQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  channelName?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  channelGroupName?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PlaylistStatus> | PlaylistStatus>;
}>;


export type GetProfileChannelsLocationsChannelGroupsForChannelSelectionQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, users: Array<{ __typename?: 'User', id: string, channels?: Array<{ __typename?: 'Channel', id: string, name: string, description?: string | null | undefined, profile?: { __typename?: 'Profile', id: string } | null | undefined, playlists: Array<{ __typename?: 'Playlist', id: string, name: string }> }> | null | undefined }>, channels: Array<{ __typename?: 'Channel', id: string, name: string, description?: string | null | undefined, playlists: Array<{ __typename?: 'Playlist', id: string, name: string }> }>, locations: Array<{ __typename?: 'Location', id: string, name: string, playlists?: Array<{ __typename?: 'Playlist', id: string, name: string }> | null | undefined }>, channelGroups: Array<{ __typename?: 'ChannelGroup', id: string, name: string, playlists: Array<{ __typename?: 'Playlist', id: string, name: string }> }> } | null | undefined };

export type GetProfileChannelsForChannelGroupQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProfileChannelsForChannelGroupQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, channels: Array<{ __typename?: 'Channel', id: string, name: string, description?: string | null | undefined, createdAt: any }> } | null | undefined };

export type GetRolesForUserInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesForUserInvitesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id?: string | null | undefined, name?: string | null | undefined }> };

export type GetProfileMediaForMediaGalleryQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  filters?: InputMaybe<MediaFiltersInput>;
  options?: InputMaybe<MediaOptionsInput>;
}>;


export type GetProfileMediaForMediaGalleryQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, media: { __typename?: 'PaginatedMedia', total: number, results: Array<{ __typename: 'Media', id: string, ownerId?: string | null | undefined, publicId: string, name: string, url: string, type: ResourceType, secureUrl: string, visibility: MediaVisibilityType, createdAt?: any | null | undefined, metadata?: { __typename?: 'MediaMetadata', width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined }> } } | null | undefined };

export type GetMediaMetadataQueryVariables = Exact<{
  mediaId: Scalars['ID']['input'];
}>;


export type GetMediaMetadataQuery = { __typename?: 'Query', media?: { __typename?: 'Media', metadata?: { __typename?: 'MediaMetadata', duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined } | null | undefined };

export type MediaForMediaGalleryFragment = { __typename?: 'Media', id: string, ownerId?: string | null | undefined, publicId: string, name: string, url: string, type: ResourceType, secureUrl: string, visibility: MediaVisibilityType, createdAt?: any | null | undefined, metadata?: { __typename?: 'MediaMetadata', width?: number | null | undefined, height?: number | null | undefined, duration?: number | null | undefined, bytes?: number | null | undefined } | null | undefined };

export type ProfileUsersForProfileUserListQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileUsersForProfileUserListQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined, role?: { __typename?: 'Role', name?: string | null | undefined } | null | undefined, auth0Profile?: { __typename?: 'Auth0Profile', user_id: string, email?: string | null | undefined, email_verified?: boolean | null | undefined, multifactor?: Array<string | null | undefined> | null | undefined, user_metadata?: { __typename?: 'UserMeta', use_mfa?: boolean | null | undefined } | null | undefined } | null | undefined }> } | null | undefined };

export type UsersForUserListFragment = { __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined, role?: { __typename?: 'Role', name?: string | null | undefined } | null | undefined, auth0Profile?: { __typename?: 'Auth0Profile', user_id: string, email?: string | null | undefined, email_verified?: boolean | null | undefined, multifactor?: Array<string | null | undefined> | null | undefined, user_metadata?: { __typename?: 'UserMeta', use_mfa?: boolean | null | undefined } | null | undefined } | null | undefined };

export type Auth0ProfileBonsaiFragment = { __typename?: 'Auth0Profile', user_id: string, email?: string | null | undefined, email_verified?: boolean | null | undefined, multifactor?: Array<string | null | undefined> | null | undefined, user_metadata?: { __typename?: 'UserMeta', use_mfa?: boolean | null | undefined } | null | undefined };

export type Auth0ProfileDetailedFragment = { __typename?: 'Auth0Profile', family_name?: string | null | undefined, given_name?: string | null | undefined, locale?: string | null | undefined, name?: string | null | undefined, nickname?: string | null | undefined, picture?: string | null | undefined, sub?: string | null | undefined, updated_at?: any | null | undefined, created_at?: any | null | undefined, user_id: string, email?: string | null | undefined, email_verified?: boolean | null | undefined, multifactor?: Array<string | null | undefined> | null | undefined, permissions: Array<{ __typename?: 'Permission', permission_name?: string | null | undefined }>, roles: Array<{ __typename?: 'Role', name?: string | null | undefined }>, user_metadata?: { __typename?: 'UserMeta', use_mfa?: boolean | null | undefined } | null | undefined };

export type GetUserDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  profilesPage?: InputMaybe<Scalars['Int']['input']>;
  profilesPageSize?: InputMaybe<Scalars['Int']['input']>;
  activeProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  profileName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserDetailsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, displayName?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, active?: boolean | null | undefined, profiles?: { __typename?: 'PaginatedProfiles', results: Array<{ __typename?: 'Profile', id: string, owner?: { __typename?: 'User', id: string } | null | undefined }> } | null | undefined, media?: Array<{ __typename?: 'Media', id: string, publicId: string, url: string, type: ResourceType }> | null | undefined, auth0Profile?: { __typename?: 'Auth0Profile', family_name?: string | null | undefined, given_name?: string | null | undefined, locale?: string | null | undefined, name?: string | null | undefined, nickname?: string | null | undefined, picture?: string | null | undefined, sub?: string | null | undefined, updated_at?: any | null | undefined, created_at?: any | null | undefined, user_id: string, email?: string | null | undefined, email_verified?: boolean | null | undefined, multifactor?: Array<string | null | undefined> | null | undefined, permissions: Array<{ __typename?: 'Permission', permission_name?: string | null | undefined }>, roles: Array<{ __typename?: 'Role', name?: string | null | undefined }>, user_metadata?: { __typename?: 'UserMeta', use_mfa?: boolean | null | undefined } | null | undefined } | null | undefined, profilePicture?: { __typename?: 'Media', id: string, url: string } | null | undefined } | null | undefined };

export type RolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id?: string | null | undefined, name?: string | null | undefined }> };

export type ActivateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActivateUserMutation = { __typename?: 'Mutation', activateUser: { __typename?: 'ActivateUserPayload', isSuccessful: boolean } };

export type GetUsersForUserListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUsersForUserListQuery = { __typename?: 'Query', users: { __typename?: 'PaginatedUsers', total: number, results: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, active?: boolean | null | undefined }> } };

export type UpdateChannelUsersMutationVariables = Exact<{
  input: UpdateChannelUsersInput;
}>;


export type UpdateChannelUsersMutation = { __typename?: 'Mutation', updateChannelUsers: { __typename?: 'UpdateChannelUsersPayload', isSuccessful: boolean } };

export type GetProfileUsersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProfileUsersQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, name?: string | null | undefined, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined, active?: boolean | null | undefined, channels?: Array<{ __typename?: 'Channel', id: string, name: string }> | null | undefined }> } | null | undefined };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', isSuccessful: boolean, user?: { __typename?: 'User', id: string, displayName?: string | null | undefined, createdAt?: any | null | undefined, updatedAt?: any | null | undefined, active?: boolean | null | undefined, auth0Profile?: { __typename?: 'Auth0Profile', family_name?: string | null | undefined, given_name?: string | null | undefined, locale?: string | null | undefined, name?: string | null | undefined, nickname?: string | null | undefined, picture?: string | null | undefined, sub?: string | null | undefined, updated_at?: any | null | undefined, created_at?: any | null | undefined, user_id: string, email?: string | null | undefined, email_verified?: boolean | null | undefined, multifactor?: Array<string | null | undefined> | null | undefined, permissions: Array<{ __typename?: 'Permission', permission_name?: string | null | undefined }>, roles: Array<{ __typename?: 'Role', name?: string | null | undefined }>, user_metadata?: { __typename?: 'UserMeta', use_mfa?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined } };

export type DeactivateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateUser: { __typename?: 'DeactivateUserPayload', isSuccessful: boolean, user?: { __typename?: 'User', displayName?: string | null | undefined } | null | undefined } };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'ChangePasswordPayload', isSuccessful: boolean, message: string } };

export type ChangeUserMfaMutationVariables = Exact<{
  input: ChangeUserMfaInput;
}>;


export type ChangeUserMfaMutation = { __typename?: 'Mutation', changeUserMFA: { __typename?: 'ChangeUserMFAPayload', isSuccessful: boolean, auth0Profile?: { __typename?: 'Auth0Profile', family_name?: string | null | undefined, given_name?: string | null | undefined, locale?: string | null | undefined, name?: string | null | undefined, nickname?: string | null | undefined, picture?: string | null | undefined, sub?: string | null | undefined, updated_at?: any | null | undefined, created_at?: any | null | undefined, user_id: string, email?: string | null | undefined, email_verified?: boolean | null | undefined, multifactor?: Array<string | null | undefined> | null | undefined, permissions: Array<{ __typename?: 'Permission', permission_name?: string | null | undefined }>, roles: Array<{ __typename?: 'Role', name?: string | null | undefined }>, user_metadata?: { __typename?: 'UserMeta', use_mfa?: boolean | null | undefined } | null | undefined } | null | undefined } };

export type CreateChannelMutationVariables = Exact<{
  input: CreateChannelInput;
}>;


export type CreateChannelMutation = { __typename?: 'Mutation', createChannel: { __typename?: 'CreateChannelPayload', isSuccessful: boolean, channel?: { __typename?: 'Channel', id: string, name: string, description?: string | null | undefined, createdAt: any, updatedAt: any, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined } };

export type AddPlaylistsToChannelsMutationVariables = Exact<{
  input?: InputMaybe<AddPlaylistsToChannelsInput>;
}>;


export type AddPlaylistsToChannelsMutation = { __typename?: 'Mutation', addPlaylistsToChannels: { __typename?: 'UpdateChannelPayload', isSuccessful: boolean } };

export type AddDevicesToChannelMutationVariables = Exact<{
  input: AddDevicesToChannelInput;
}>;


export type AddDevicesToChannelMutation = { __typename?: 'Mutation', addDevicesToChannel: { __typename?: 'UpdateChannelPayload', isSuccessful: boolean, channel?: { __typename?: 'Channel', id: string, name: string, devices: Array<{ __typename?: 'Device', id: string, name: string }> } | null | undefined } };

export type RemoveDevicesFromChannelMutationVariables = Exact<{
  input: AddDevicesToChannelInput;
}>;


export type RemoveDevicesFromChannelMutation = { __typename?: 'Mutation', removeDevicesFromChannel: { __typename?: 'UpdateChannelPayload', isSuccessful: boolean, channel?: { __typename?: 'Channel', id: string, name: string, devices: Array<{ __typename?: 'Device', id: string, name: string }> } | null | undefined } };

export type BulkActionDevicesMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  action: ChannelBulkAction;
  extra?: InputMaybe<Scalars['String']['input']>;
}>;


export type BulkActionDevicesMutation = { __typename?: 'Mutation', bulkActionDevices: { __typename?: 'BulkActionDevicePayload', isSuccessful: boolean, devices: Array<{ __typename?: 'Device', id: string, advancedSettings?: { __typename?: 'DeviceAdvancedSettings', appletVersion?: string | null | undefined, orientation?: DeviceOrientation | null | undefined, ntpServer?: string | null | undefined, timeZone?: string | null | undefined, scheduleDailyReboot?: boolean | null | undefined, rebootTime?: string | null | undefined, synchronize?: boolean | null | undefined, manualSyncGroup?: boolean | null | undefined, syncGroup?: string | null | undefined, masterSyncDelay?: number | null | undefined, kioskMode?: boolean | null | undefined, kioskModeGraceSecs?: number | null | undefined, setBrightness2?: boolean | null | undefined, volume?: number | null | undefined, scheduleBrightness?: { __typename?: 'DualBrightnessConfig', brightness1?: number | null | undefined, brightness2?: number | null | undefined, time1?: string | null | undefined, time2?: string | null | undefined } | null | undefined, scheduleDisplay?: Array<{ __typename?: 'ScheduleDisplay', on: string, off: string, days: { __typename?: 'ScheduleDays', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } }> | null | undefined } | null | undefined, deviceInfo?: { __typename?: 'DeviceInfo', appletVersion?: string | null | undefined } | null | undefined, signageOSDeviceTiming?: { __typename?: 'SignageOSDeviceTiming', appletVersion?: string | null | undefined, activeAppletVersion?: string | null | undefined } | null | undefined }> } };

export type MinimalFolderFragment = { __typename?: 'Folder', id: string, profileId: string, name: string, isPublic: boolean, createdBy: string };

export type MinimalMediaFragment = { __typename?: 'Media', id: string, publicId: string, ownerId?: string | null | undefined, name: string, url: string, type: ResourceType, visibility: MediaVisibilityType, secureUrl: string };

export type FolderFragment = { __typename?: 'Folder', parentFolderId?: string | null | undefined, folderType?: FolderType | null | undefined, fullPath?: string | null | undefined, id: string, profileId: string, name: string, isPublic: boolean, createdBy: string };

export type FolderWithMediasFragment = { __typename?: 'Folder', parentFolderId?: string | null | undefined, folderType?: FolderType | null | undefined, fullPath?: string | null | undefined, id: string, profileId: string, name: string, isPublic: boolean, createdBy: string, medias?: Array<{ __typename?: 'Media', id: string, publicId: string, ownerId?: string | null | undefined, name: string, url: string, type: ResourceType, visibility: MediaVisibilityType, secureUrl: string }> | null | undefined };

export type CreateFolderMutationVariables = Exact<{
  input: CreateFolderInput;
}>;


export type CreateFolderMutation = { __typename?: 'Mutation', createFolder?: { __typename?: 'CreateFolderPayload', isSuccessful: boolean, folder?: { __typename?: 'Folder', parentFolderId?: string | null | undefined, folderType?: FolderType | null | undefined, fullPath?: string | null | undefined, id: string, profileId: string, name: string, isPublic: boolean, createdBy: string } | null | undefined } | null | undefined };

export type DeleteFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFolderMutation = { __typename?: 'Mutation', deleteFolder: { __typename?: 'DeleteFolderPayload', isSuccessful: boolean } };

export type DeleteFolderListMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteFolderListMutation = { __typename?: 'Mutation', deleteFolderList: { __typename?: 'DeleteFolderPayload', isSuccessful: boolean } };

export type UpdateFolderMutationVariables = Exact<{
  input: UpdateFolderInput;
}>;


export type UpdateFolderMutation = { __typename?: 'Mutation', updateFolder?: { __typename?: 'UpdateFolderPayload', isSuccessful: boolean, folder?: { __typename?: 'Folder', parentFolderId?: string | null | undefined, folderType?: FolderType | null | undefined, fullPath?: string | null | undefined, id: string, profileId: string, name: string, isPublic: boolean, createdBy: string } | null | undefined } | null | undefined };

export type MoveFolderListToFolderMutationVariables = Exact<{
  folderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  destinationFolderId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MoveFolderListToFolderMutation = { __typename?: 'Mutation', moveFolderListToFolder?: { __typename?: 'MoveFolderListToFolderPayload', isSuccessful: boolean } | null | undefined };

export type GetProfileFoldersQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
}>;


export type GetProfileFoldersQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', folders: Array<{ __typename?: 'Folder', parentFolderId?: string | null | undefined, folderType?: FolderType | null | undefined, fullPath?: string | null | undefined, id: string, profileId: string, name: string, isPublic: boolean, createdBy: string }> } | null | undefined };

export type GetProfileFoldersWithMediasQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
}>;


export type GetProfileFoldersWithMediasQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', folders: Array<{ __typename?: 'Folder', parentFolderId?: string | null | undefined, folderType?: FolderType | null | undefined, fullPath?: string | null | undefined, id: string, profileId: string, name: string, isPublic: boolean, createdBy: string, medias?: Array<{ __typename?: 'Media', id: string, publicId: string, ownerId?: string | null | undefined, name: string, url: string, type: ResourceType, visibility: MediaVisibilityType, secureUrl: string }> | null | undefined }> } | null | undefined };

export type GetFolderByIdQueryVariables = Exact<{
  folderId: Scalars['ID']['input'];
}>;


export type GetFolderByIdQuery = { __typename?: 'Query', folder?: { __typename?: 'Folder', parentFolderId?: string | null | undefined, folderType?: FolderType | null | undefined, fullPath?: string | null | undefined, id: string, profileId: string, name: string, isPublic: boolean, createdBy: string } | null | undefined };

export type GetProfileLayoutsQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
}>;


export type GetProfileLayoutsQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', layouts?: Array<{ __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type GetAssignableLayoutsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAssignableLayoutsQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, assignableLayouts?: Array<{ __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type GetLayoutByIdQueryVariables = Exact<{
  layoutId: Scalars['ID']['input'];
}>;


export type GetLayoutByIdQuery = { __typename?: 'Query', layout: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } };

export type CreateLayoutMutationVariables = Exact<{
  input: CreateLayoutInput;
}>;


export type CreateLayoutMutation = { __typename?: 'Mutation', createLayout: { __typename?: 'CreateLayoutPayload', isSuccessful: boolean, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined } };

export type UpdateLayoutMutationVariables = Exact<{
  input: UpdateLayoutInput;
}>;


export type UpdateLayoutMutation = { __typename?: 'Mutation', updateLayout: { __typename?: 'UpdateLayoutPayload', isSuccessful: boolean, layout?: { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined } };

export type DeleteLayoutMutationVariables = Exact<{
  layoutId: Scalars['ID']['input'];
}>;


export type DeleteLayoutMutation = { __typename?: 'Mutation', deleteLayout: { __typename?: 'DeleteLayoutPayload', isSuccessful: boolean } };

export type LayoutDetailedFragment = { __typename?: 'Layout', id: string, name: string, description?: string | null | undefined, updatedAt?: any | null | undefined, createdAt?: any | null | undefined, public?: boolean | null | undefined, source?: { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined } | null | undefined };

export type LayoutSourceFragmentFragment = { __typename?: 'LayoutEditorSource', sceneUrl?: string | null | undefined, cloudinaryPublicId?: string | null | undefined, regionBlocks?: Array<{ __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, canvas?: { __typename?: 'LayoutEditorCanvas', width?: number | null | undefined, height?: number | null | undefined } | null | undefined };

export type ScreenRegionFragment = { __typename?: 'SmilRegion', id: number, regionName?: string | null | undefined, left?: number | null | undefined, top?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, zIndex?: number | null | undefined, sync?: boolean | null | undefined, action?: { __typename?: 'RegionAction', id: string, type?: string | null | undefined, target?: string | null | undefined } | null | undefined };

export type ResourceGroupFragment = { __typename?: 'ResourceGroup', id: string, name: string, userResourceGroups: Array<{ __typename?: 'UserResourceGroup', canWrite?: boolean | null | undefined, user: { __typename?: 'User', id: string, displayName?: string | null | undefined } }>, playlists?: Array<{ __typename?: 'Playlist', id: string, name: string }> | null | undefined };

export type UserForResourceGroupFragment = { __typename?: 'UserResourceGroup', canWrite?: boolean | null | undefined, user: { __typename?: 'User', id: string, displayName?: string | null | undefined } };

export type UserForResourceGroupUserListFragment = { __typename?: 'User', id: string, displayName?: string | null | undefined };

export type PlaylistForResourceGroupFragment = { __typename?: 'Playlist', id: string, name: string };

export type PlaylistForResourceGroupPlaylistListFragment = { __typename?: 'Playlist', id: string, name: string, resourceGroupId?: string | null | undefined };

export type CreateResourceGroupMutationVariables = Exact<{
  input: CreateResourceGroupInput;
}>;


export type CreateResourceGroupMutation = { __typename?: 'Mutation', createResourceGroup: { __typename?: 'CreateResourceGroupPayload', isSuccessful: boolean, resourceGroup?: { __typename?: 'ResourceGroup', id: string, name: string, userResourceGroups: Array<{ __typename?: 'UserResourceGroup', canWrite?: boolean | null | undefined, user: { __typename?: 'User', id: string, displayName?: string | null | undefined } }>, playlists?: Array<{ __typename?: 'Playlist', id: string, name: string }> | null | undefined } | null | undefined } };

export type DeleteResourceGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteResourceGroupMutation = { __typename?: 'Mutation', deleteResourceGroup: { __typename?: 'DeleteResourceGroupPayload', isSuccessful: boolean } };

export type UpdateResourceGroupMutationVariables = Exact<{
  input: UpdateResourceGroupInput;
}>;


export type UpdateResourceGroupMutation = { __typename?: 'Mutation', updateResourceGroup: { __typename?: 'UpdateResourceGroupPayload', isSuccessful: boolean, resourceGroup?: { __typename?: 'ResourceGroup', id: string, name: string, userResourceGroups: Array<{ __typename?: 'UserResourceGroup', canWrite?: boolean | null | undefined, user: { __typename?: 'User', id: string, displayName?: string | null | undefined } }>, playlists?: Array<{ __typename?: 'Playlist', id: string, name: string }> | null | undefined } | null | undefined } };

export type GetResourceGroupsByProfileIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetResourceGroupsByProfileIdQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, resourceGroups: Array<{ __typename?: 'ResourceGroup', id: string, name: string, userResourceGroups: Array<{ __typename?: 'UserResourceGroup', canWrite?: boolean | null | undefined, user: { __typename?: 'User', id: string, displayName?: string | null | undefined } }>, playlists?: Array<{ __typename?: 'Playlist', id: string, name: string }> | null | undefined }> } | null | undefined };

export type GetResourcesByProfileIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetResourcesByProfileIdQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, users: Array<{ __typename?: 'User', id: string, displayName?: string | null | undefined }>, playlists: Array<{ __typename?: 'Playlist', id: string, name: string, resourceGroupId?: string | null | undefined }> } | null | undefined };

export const ChannelBonsaiFragmentDoc = gql`
    fragment channelBonsai on Channel {
  id
  name
  type
}
    `;
export const ScreenRegionFragmentDoc = gql`
    fragment screenRegion on SmilRegion {
  id
  regionName
  left
  top
  width
  height
  zIndex
  sync
  action {
    id
    type
    target
  }
}
    `;
export const LayoutSourceFragmentFragmentDoc = gql`
    fragment layoutSourceFragment on LayoutEditorSource {
  sceneUrl
  cloudinaryPublicId
  regionBlocks {
    ...screenRegion
  }
  canvas {
    width
    height
  }
}
    ${ScreenRegionFragmentDoc}`;
export const LayoutDetailedFragmentDoc = gql`
    fragment layoutDetailed on Layout {
  id
  name
  description
  updatedAt
  createdAt
  public
  source {
    ...layoutSourceFragment
  }
}
    ${LayoutSourceFragmentFragmentDoc}`;
export const PlaylistVersionBonsaiFragmentDoc = gql`
    fragment PlaylistVersionBonsai on Playlist {
  id
  name
  updatedAt
  status
  type
}
    `;
export const ChannelsForChannelListFragmentDoc = gql`
    fragment channelsForChannelList on Channel {
  ...channelBonsai
  eventStart
  eventEnd
  description
  createdAt
  updatedAt
  layout {
    ...layoutDetailed
  }
  playlistRegions {
    channelId
    playlistId
    region
  }
  playlists {
    ...PlaylistVersionBonsai
  }
  devices {
    id
    uid
    name
    location {
      id
      name
      streetAddress1
      streetAddress2
      zip
      city
      phoneNumber
      country
      coordinates {
        x
        y
      }
    }
    signageOSDeviceTiming {
      appletVersion
      activeAppletVersion
    }
  }
}
    ${ChannelBonsaiFragmentDoc}
${LayoutDetailedFragmentDoc}
${PlaylistVersionBonsaiFragmentDoc}`;
export const EventForListFragmentDoc = gql`
    fragment eventForList on Channel {
  ...channelsForChannelList
}
    ${ChannelsForChannelListFragmentDoc}`;
export const DaysFragmentDoc = gql`
    fragment Days on ScheduleDays {
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  sunday
}
    `;
export const ScheduleDisplayDetailedFragmentDoc = gql`
    fragment ScheduleDisplayDetailed on ScheduleDisplay {
  on
  off
  days {
    ...Days
  }
}
    ${DaysFragmentDoc}`;
export const AdvancedSettingsDetailedFragmentDoc = gql`
    fragment AdvancedSettingsDetailed on DeviceAdvancedSettings {
  appletVersion
  orientation
  ntpServer
  timeZone
  scheduleDailyReboot
  rebootTime
  synchronize
  manualSyncGroup
  syncGroup
  masterSyncDelay
  kioskMode
  kioskModeGraceSecs
  setBrightness2
  scheduleBrightness {
    brightness1
    brightness2
    time1
    time2
  }
  scheduleDisplay {
    ...ScheduleDisplayDetailed
  }
  volume
}
    ${ScheduleDisplayDetailedFragmentDoc}`;
export const DevicesForDeviceListFragmentDoc = gql`
    fragment DevicesForDeviceList on Device {
  id
  name
  updatedAt
  createdAt
  coordinates {
    x
    y
  }
  advancedSettings {
    ...AdvancedSettingsDetailed
  }
  location {
    id
    name
    streetAddress1
    streetAddress2
    zip
    city
    phoneNumber
    country
    coordinates {
      x
      y
    }
  }
  channel {
    id
    name
  }
}
    ${AdvancedSettingsDetailedFragmentDoc}`;
export const MonitorRecordFragmentDoc = gql`
    fragment MonitorRecord on DeviceMonitorRecord {
  ts
  cpu
  temp
}
    `;
export const StatusRecordFragmentDoc = gql`
    fragment StatusRecord on DeviceStatusRecord {
  ts
  online
}
    `;
export const ChannelLocationForMapFragmentDoc = gql`
    fragment channelLocationForMap on Location {
  id
  name
  streetAddress1
  streetAddress2
  zip
  city
  region
  country
  coordinates {
    x
    y
  }
}
    `;
export const DeviceInfoDetailedFragmentDoc = gql`
    fragment DeviceInfoDetailed on DeviceInfo {
  appletVersion
  applicationType
  applicationVersion
  firmware
  model
  serialNumber
  networkInfo {
    localAddress
    ethernetMacAddress
    wifiMacAddress
    activeInterface
    gateway
    netmask
    dns
    interfaceName
  }
  networkAdapters {
    type
    name
    macAddress
    localAddress
    gateway
    netmask
    dns
    disabled
    wifiStrength
    wifiSsid
  }
  batteryStatus {
    chargeType
    isCharging
    lastChargingTime
    percentage
    updatedAt
  }
  currentTime {
    currentDate
    timezone
    updatedAt
    ntpServer
  }
  screen {
    orientation
    isPoweredOn
    brightness {
      timeFrom1
      timeFrom2
      brightness1
      brightness2
    }
    volume
  }
  kioskMode
  kioskModeGraceSecs
}
    `;
export const DeviceBaseFragmentDoc = gql`
    fragment DeviceBase on Device {
  id
  uid
  channelId
  name
  width
  height
  serialNumber
  updatedAt
  createdAt
  coordinates {
    x
    y
  }
  location {
    ...channelLocationForMap
  }
  latestPing {
    id
    timestamp
  }
  deviceInfo {
    ...DeviceInfoDetailed
  }
  advancedSettings {
    ...AdvancedSettingsDetailed
  }
  signageOSDeviceTiming {
    appletVersion
    activeAppletVersion
  }
  channel {
    id
    name
  }
}
    ${ChannelLocationForMapFragmentDoc}
${DeviceInfoDetailedFragmentDoc}
${AdvancedSettingsDetailedFragmentDoc}`;
export const EventBonsaiFragmentDoc = gql`
    fragment eventBonsai on Channel {
  id
  name
  eventStart
}
    `;
export const DeviceForManageFragmentDoc = gql`
    fragment DeviceForManage on Device {
  id
  uid
  channelId
  name
  width
  height
  serialNumber
  application
  updatedAt
  createdAt
  coordinates {
    x
    y
  }
  latestPing {
    id
    timestamp
  }
  deviceInfo {
    ...DeviceInfoDetailed
  }
  profile {
    id
    channels {
      ...channelBonsai
    }
    locations {
      id
      name
    }
  }
  channel {
    id
    name
    description
  }
  resolution {
    resolution
    orientation
  }
  advancedSettings {
    ...AdvancedSettingsDetailed
  }
  location {
    ...channelLocationForMap
  }
  signageOSDeviceTiming {
    appletVersion
    activeAppletVersion
  }
}
    ${DeviceInfoDetailedFragmentDoc}
${ChannelBonsaiFragmentDoc}
${AdvancedSettingsDetailedFragmentDoc}
${ChannelLocationForMapFragmentDoc}`;
export const DeviceVerificationChannelOptionFragmentDoc = gql`
    fragment DeviceVerificationChannelOption on Channel {
  id
  name
}
    `;
export const ProfileLocationsFragmentDoc = gql`
    fragment ProfileLocations on Location {
  id
  name
  streetAddress1
  streetAddress2
  zip
  phoneNumber
  country
  region
  city
  updatedAt
  createdAt
  coordinates {
    x
    y
  }
  channels {
    id
    name
    description
  }
}
    `;
export const Auth0ProfileBonsaiFragmentDoc = gql`
    fragment Auth0ProfileBonsai on Auth0Profile {
  user_id
  email
  email_verified
  multifactor
  user_metadata {
    use_mfa
  }
}
    `;
export const Auth0ProfileDetailedFragmentDoc = gql`
    fragment Auth0ProfileDetailed on Auth0Profile {
  ...Auth0ProfileBonsai
  family_name
  given_name
  locale
  name
  nickname
  picture
  sub
  updated_at
  created_at
  permissions {
    permission_name
  }
  roles {
    name
  }
}
    ${Auth0ProfileBonsaiFragmentDoc}`;
export const CurrentUserFragmentDoc = gql`
    fragment CurrentUser on User {
  id
  displayName
  createdAt
  updatedAt
  active
  profilePicture {
    id
    url
  }
  auth0Profile {
    ...Auth0ProfileDetailed
  }
}
    ${Auth0ProfileDetailedFragmentDoc}`;
export const MeProfileFragmentDoc = gql`
    fragment MeProfile on Profile {
  id
  name
  active
  settings {
    dateFormat
    timeFormat
    timeZone
  }
  locations {
    id
    name
  }
  features {
    id
  }
}
    `;
export const MediaDetailedFragmentDoc = gql`
    fragment MediaDetailed on Media {
  id
  publicId
  ownerId
  name
  url
  type
  visibility
  secureUrl
  folderId
  source {
    publicId
    url
  }
  metadata {
    width
    height
    bytes
    resourceType
    secureUrl
    version
    filename
    format
    createdAt
    uploadedAt
    status
    aspectRatio
    pixels
    duration
    etag
    accessMode
    accessControl
  }
}
    `;
export const MediaForMediaListFragmentDoc = gql`
    fragment MediaForMediaList on Media {
  id
  ownerId
  publicId
  name
  url
  type
  secureUrl
  createdAt
  folderId
  source {
    url
    publicId
  }
  visibility
  metadata {
    duration
    format
    width
    height
    bytes
    resourceType
    publicId
    type
    createdAt
    url
    secureUrl
    derived {
      bytes
      extension
      format
      id
      secure_url
      transformation
      url
    }
  }
}
    `;
export const PlaylistForPlaylistListFragmentDoc = gql`
    fragment PlaylistForPlaylistList on Playlist {
  id
  name
  status
  type
  updatedAt
  createdAt
  startDate
  endDate
  previewContent {
    __typename
    ... on ImageAsset {
      id
      contentId
      type
      publicId
      name
      duration
      uri
    }
    ... on VideoAsset {
      id
      contentId
      type
      publicId
      name
      uri
    }
    ... on HtmlAsset {
      id
      contentId
      type
      name
      duration
      htmlContent
      campaignEnd
      campaignStart
    }
    ... on IFrameAsset {
      id
      contentId
      type
      name
      duration
      uri
      campaignEnd
      campaignStart
    }
    ... on WidgetAsset {
      id
      contentId
      type
      name
      duration
      uri
      campaignEnd
      campaignStart
      days {
        sunday
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
      }
      disabled
      widgetConfig
    }
    ... on BrowserAsset {
      id
      contentId
      type
      name
      duration
      uri
      campaignEnd
      campaignStart
      days {
        sunday
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
      }
      disabled
      useNativeBrowser
      clearData
      headlessMode
      whiteListDomains
    }
  }
  childPlaylists {
    id
    status
    channels {
      id
      name
    }
  }
}
    `;
export const AssetWithMediaForAssetManageFragmentDoc = gql`
    fragment AssetWithMediaForAssetManage on Asset {
  id
  name
  sequence
  startTime
  endTime
  actualStartTime
  actualEndTime
  content {
    __typename
    ... on ImageAsset {
      id
      contentId
      type
      publicId
      name
      sequence
      duration
      uri
      transitionEffect {
        name
        duration
      }
      resizeCropMethod {
        name
        uri
      }
      campaignEnd
      campaignStart
      days {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
      media {
        id
        metadata {
          format
          width
          height
        }
      }
      height
      width
      interactiveLayoutSource
      interactiveRegions {
        ...screenRegion
      }
      disabled
    }
    ... on VideoAsset {
      id
      contentId
      type
      publicId
      name
      sequence
      duration
      uri
      resizeCropMethod {
        name
        uri
      }
      media {
        id
        metadata {
          format
          width
          height
          duration
          bytes
        }
      }
      campaignEnd
      campaignStart
      days {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
      height
      width
      interactiveLayoutSource
      interactiveRegions {
        ...screenRegion
      }
      disabled
    }
    ... on HtmlAsset {
      id
      contentId
      type
      name
      sequence
      duration
      htmlContent
      campaignEnd
      campaignStart
      days {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
      disabled
    }
    ... on IFrameAsset {
      id
      contentId
      type
      name
      sequence
      duration
      uri
      campaignEnd
      campaignStart
      days {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
      disabled
    }
    ... on WidgetAsset {
      id
      contentId
      type
      name
      duration
      uri
      campaignEnd
      campaignStart
      days {
        sunday
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
      }
      disabled
      widgetConfig
    }
    ... on BrowserAsset {
      id
      contentId
      type
      name
      duration
      uri
      campaignEnd
      campaignStart
      days {
        sunday
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
      }
      disabled
      useNativeBrowser
      clearData
      headlessMode
      whiteListDomains
    }
  }
}
    ${ScreenRegionFragmentDoc}`;
export const DetailedPlaylistFragmentDoc = gql`
    fragment DetailedPlaylist on Playlist {
  ...PlaylistVersionBonsai
  createdAt
  startDate
  endDate
  assets {
    ...AssetWithMediaForAssetManage
  }
  childPlaylists {
    id
    status
    channels {
      id
      name
    }
  }
  parentPlaylist {
    id
  }
}
    ${PlaylistVersionBonsaiFragmentDoc}
${AssetWithMediaForAssetManageFragmentDoc}`;
export const DetailedPlaylistForChannelFragmentDoc = gql`
    fragment DetailedPlaylistForChannel on Playlist {
  ...DetailedPlaylist
  region
}
    ${DetailedPlaylistFragmentDoc}`;
export const ChannelToPlaylistFragmentDoc = gql`
    fragment ChannelToPlaylist on Channel {
  ...channelBonsai
  layout {
    ...layoutDetailed
  }
}
    ${ChannelBonsaiFragmentDoc}
${LayoutDetailedFragmentDoc}`;
export const PlaylistVersionDetailedFragmentDoc = gql`
    fragment PlaylistVersionDetailed on Playlist {
  id
  name
  status
  type
  startDate
  endDate
  createdAt
  updatedAt
  profile {
    id
    name
  }
  channelRegions {
    channelId
    region
  }
  channels {
    ...ChannelToPlaylist
  }
  assets {
    ...AssetWithMediaForAssetManage
  }
}
    ${ChannelToPlaylistFragmentDoc}
${AssetWithMediaForAssetManageFragmentDoc}`;
export const PlaylistDetailedFragmentDoc = gql`
    fragment PlaylistDetailed on Playlist {
  ...PlaylistVersionDetailed
  publishedPlaylist {
    ...PlaylistVersionDetailed
  }
  childPlaylists {
    ...PlaylistVersionBonsai
  }
}
    ${PlaylistVersionDetailedFragmentDoc}
${PlaylistVersionBonsaiFragmentDoc}`;
export const AssetWithScheduleForAssetManageFragmentDoc = gql`
    fragment AssetWithScheduleForAssetManage on Asset {
  id
  name
  sequence
  startTime
  endTime
  content {
    __typename
    ... on ImageAsset {
      id
      contentId
      type
      publicId
      name
      sequence
      duration
      uri
      transitionEffect {
        name
        duration
      }
      resizeCropMethod {
        name
        uri
      }
      days {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
      campaignStart
      campaignEnd
      height
      width
      interactiveLayoutSource
      interactiveRegions {
        ...screenRegion
      }
      disabled
    }
    ... on VideoAsset {
      id
      contentId
      type
      publicId
      name
      sequence
      uri
      resizeCropMethod {
        name
        uri
      }
      duration
      days {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
      campaignStart
      campaignEnd
      height
      width
      interactiveLayoutSource
      interactiveRegions {
        ...screenRegion
      }
      disabled
    }
    ... on HtmlAsset {
      id
      contentId
      type
      name
      sequence
      duration
      htmlContent
      days {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
      campaignStart
      campaignEnd
      disabled
    }
    ... on IFrameAsset {
      id
      contentId
      type
      name
      sequence
      duration
      uri
      days {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
      campaignStart
      campaignEnd
      disabled
    }
  }
}
    ${ScreenRegionFragmentDoc}`;
export const ProfileDetailedFragmentDoc = gql`
    fragment ProfileDetailed on Profile {
  id
  name
  active
  deleteOn
  website
  description
  updatedAt
  createdAt
  owner {
    id
    displayName
    active
  }
  users {
    id
    displayName
    active
  }
  defaultLocation {
    id
    name
    streetAddress1
    streetAddress2
    zip
    city
    phoneNumber
    country
    coordinates {
      x
      y
    }
  }
  organization {
    id
    name
    active
    organizationUid
    title
    createdAt
    updatedAt
  }
  settings {
    dateFormat
    timeFormat
    timeZone
  }
  features {
    id
  }
}
    `;
export const ProfilesForProfileListFragmentDoc = gql`
    fragment profilesForProfileList on PaginatedProfiles {
  total
  results {
    id
    name
    updatedAt
    createdAt
    active
    owner {
      id
      displayName
    }
    users {
      id
      displayName
    }
    channels {
      id
      name
    }
  }
}
    `;
export const MediaForMediaGalleryFragmentDoc = gql`
    fragment MediaForMediaGallery on Media {
  id
  ownerId
  publicId
  name
  url
  type
  secureUrl
  visibility
  createdAt
  metadata {
    width
    height
    duration
    bytes
  }
}
    `;
export const UsersForUserListFragmentDoc = gql`
    fragment UsersForUserList on User {
  id
  displayName
  active
  role {
    name
  }
  auth0Profile {
    ...Auth0ProfileBonsai
  }
}
    ${Auth0ProfileBonsaiFragmentDoc}`;
export const MinimalFolderFragmentDoc = gql`
    fragment minimalFolder on Folder {
  id
  profileId
  name
  isPublic
  createdBy
}
    `;
export const FolderFragmentDoc = gql`
    fragment folder on Folder {
  ...minimalFolder
  parentFolderId
  folderType
  fullPath
}
    ${MinimalFolderFragmentDoc}`;
export const MinimalMediaFragmentDoc = gql`
    fragment minimalMedia on Media {
  id
  publicId
  ownerId
  name
  url
  type
  visibility
  secureUrl
}
    `;
export const FolderWithMediasFragmentDoc = gql`
    fragment folderWithMedias on Folder {
  ...folder
  medias {
    ...minimalMedia
  }
}
    ${FolderFragmentDoc}
${MinimalMediaFragmentDoc}`;
export const UserForResourceGroupFragmentDoc = gql`
    fragment userForResourceGroup on UserResourceGroup {
  user {
    id
    displayName
  }
  canWrite
}
    `;
export const PlaylistForResourceGroupFragmentDoc = gql`
    fragment playlistForResourceGroup on Playlist {
  id
  name
}
    `;
export const ResourceGroupFragmentDoc = gql`
    fragment resourceGroup on ResourceGroup {
  id
  name
  userResourceGroups {
    ...userForResourceGroup
  }
  playlists {
    ...playlistForResourceGroup
  }
}
    ${UserForResourceGroupFragmentDoc}
${PlaylistForResourceGroupFragmentDoc}`;
export const UserForResourceGroupUserListFragmentDoc = gql`
    fragment userForResourceGroupUserList on User {
  id
  displayName
}
    `;
export const PlaylistForResourceGroupPlaylistListFragmentDoc = gql`
    fragment playlistForResourceGroupPlaylistList on Playlist {
  id
  name
  resourceGroupId
}
    `;
export const GetProfilesForAssetFormDocument = gql`
    query getProfilesForAssetForm {
  profiles {
    total
    results {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfilesForAssetFormGQL extends Apollo.Query<GetProfilesForAssetFormQuery, GetProfilesForAssetFormQueryVariables> {
    document = GetProfilesForAssetFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAssetDocument = gql`
    mutation deleteAsset($id: ID!) {
  deleteAsset(id: $id) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAssetGQL extends Apollo.Mutation<DeleteAssetMutation, DeleteAssetMutationVariables> {
    document = DeleteAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssetDocument = gql`
    mutation updateAsset($input: UpdateAssetInput!) {
  updateAsset(input: $input) {
    isSuccessful
    asset {
      id
      name
      createdAt
      updatedAt
      profile {
        id
        name
      }
      content {
        __typename
        ... on ImageAsset {
          id
          contentId
          type
          publicId
          name
          duration
          uri
          transitionEffect {
            name
            duration
          }
          resizeCropMethod {
            name
            uri
          }
          media {
            metadata {
              format
              width
              height
            }
          }
          campaignEnd
          campaignStart
          days {
            sunday
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
          }
          height
          width
          interactiveLayoutSource
          interactiveRegions {
            ...screenRegion
          }
          disabled
        }
        ... on VideoAsset {
          id
          contentId
          type
          publicId
          name
          uri
          resizeCropMethod {
            name
            uri
          }
          media {
            metadata {
              format
              width
              height
              duration
            }
          }
          campaignEnd
          campaignStart
          days {
            sunday
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
          }
          height
          width
          interactiveLayoutSource
          interactiveRegions {
            ...screenRegion
          }
          disabled
        }
        ... on HtmlAsset {
          id
          contentId
          type
          name
          duration
          htmlContent
          campaignEnd
          campaignStart
          days {
            sunday
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
          }
          disabled
        }
        ... on IFrameAsset {
          id
          contentId
          type
          name
          duration
          uri
          campaignEnd
          campaignStart
          days {
            sunday
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
          }
          disabled
        }
        ... on WidgetAsset {
          id
          contentId
          type
          name
          duration
          uri
          campaignEnd
          campaignStart
          days {
            sunday
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
          }
          disabled
          widgetConfig
        }
        ... on BrowserAsset {
          id
          contentId
          type
          name
          duration
          uri
          campaignEnd
          campaignStart
          days {
            sunday
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
          }
          disabled
          useNativeBrowser
          clearData
          headlessMode
          whiteListDomains
        }
      }
    }
  }
}
    ${ScreenRegionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssetGQL extends Apollo.Mutation<UpdateAssetMutation, UpdateAssetMutationVariables> {
    document = UpdateAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPlaylistFormStateDocument = gql`
    query getPlaylistFormState {
  playlistFormState @client {
    id
    name
    channelIds {
      id
      region
    }
    startDate
    endDate
    saveOption
    schedules {
      startTime
      endTime
      sequence
      asset {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlaylistFormStateGQL extends Apollo.Query<GetPlaylistFormStateQuery, GetPlaylistFormStateQueryVariables> {
    document = GetPlaylistFormStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetIsInitializingAppDocument = gql`
    query getIsInitializingApp {
  isInitializingApp @client
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetIsInitializingAppGQL extends Apollo.Query<GetIsInitializingAppQuery, GetIsInitializingAppQueryVariables> {
    document = GetIsInitializingAppDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActiveProfileDocument = gql`
    query getActiveProfile {
  activeProfile @client {
    id
    name
    active
    locations {
      id
      name
    }
    features {
      id
    }
    settings {
      dateFormat
      timeFormat
      timeZone
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActiveProfileGQL extends Apollo.Query<GetActiveProfileQuery, GetActiveProfileQueryVariables> {
    document = GetActiveProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSelectedChannelDocument = gql`
    query getSelectedChannel {
  selectedChannel @client {
    id
    name
    description
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSelectedChannelGQL extends Apollo.Query<GetSelectedChannelQuery, GetSelectedChannelQueryVariables> {
    document = GetSelectedChannelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSelectedDeviceDocument = gql`
    query getSelectedDevice {
  selectedDevice @client {
    id
    name
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSelectedDeviceGQL extends Apollo.Query<GetSelectedDeviceQuery, GetSelectedDeviceQueryVariables> {
    document = GetSelectedDeviceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSelectedAssetsDocument = gql`
    query getSelectedAssets {
  selectedAssets @client {
    ...AssetWithMediaForAssetManage
  }
}
    ${AssetWithMediaForAssetManageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSelectedAssetsGQL extends Apollo.Query<GetSelectedAssetsQuery, GetSelectedAssetsQueryVariables> {
    document = GetSelectedAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WriteIsInitializingAppToCacheDocument = gql`
    mutation writeIsInitializingAppToCache($input: Boolean) {
  setIsInitializingApp(input: $input) @client
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WriteIsInitializingAppToCacheGQL extends Apollo.Mutation<WriteIsInitializingAppToCacheMutation, WriteIsInitializingAppToCacheMutationVariables> {
    document = WriteIsInitializingAppToCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WriteActiveProfileToCacheDocument = gql`
    mutation writeActiveProfileToCache($input: ActiveProfileInput) {
  setActiveProfile(input: $input) @client {
    id
    name
    active
    locations {
      id
      name
    }
    features {
      id
    }
    settings {
      dateFormat
      timeFormat
      timeZone
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WriteActiveProfileToCacheGQL extends Apollo.Mutation<WriteActiveProfileToCacheMutation, WriteActiveProfileToCacheMutationVariables> {
    document = WriteActiveProfileToCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WriteSelectedChannelToCacheDocument = gql`
    mutation writeSelectedChannelToCache($input: SelectedChannelInput) {
  setSelectedChannel(input: $input) @client {
    id
    name
    description
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WriteSelectedChannelToCacheGQL extends Apollo.Mutation<WriteSelectedChannelToCacheMutation, WriteSelectedChannelToCacheMutationVariables> {
    document = WriteSelectedChannelToCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WriteSelectedDeviceToCacheDocument = gql`
    mutation writeSelectedDeviceToCache($input: SelectedDeviceInput) {
  setSelectedDevice(input: $input) @client {
    id
    name
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WriteSelectedDeviceToCacheGQL extends Apollo.Mutation<WriteSelectedDeviceToCacheMutation, WriteSelectedDeviceToCacheMutationVariables> {
    document = WriteSelectedDeviceToCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WriteSelectedAssetsToCacheDocument = gql`
    mutation writeSelectedAssetsToCache($input: [SelectedAssetInput!]) {
  setSelectedAssets(input: $input) @client {
    ...AssetWithMediaForAssetManage
  }
}
    ${AssetWithMediaForAssetManageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class WriteSelectedAssetsToCacheGQL extends Apollo.Mutation<WriteSelectedAssetsToCacheMutation, WriteSelectedAssetsToCacheMutationVariables> {
    document = WriteSelectedAssetsToCacheDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateChannelGroupDocument = gql`
    mutation createChannelGroup($input: CreateChannelGroupInput!) {
  createChannelGroup(input: $input) {
    isSuccessful
    channelGroup {
      id
      name
      createdAt
      updatedAt
      channels {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateChannelGroupGQL extends Apollo.Mutation<CreateChannelGroupMutation, CreateChannelGroupMutationVariables> {
    document = CreateChannelGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelGroupForManagePageDocument = gql`
    query getChannelGroupForManagePage($id: ID!) {
  channelGroup(id: $id) {
    id
    name
    createdAt
    updatedAt
    profile {
      id
    }
    channels {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelGroupForManagePageGQL extends Apollo.Query<GetChannelGroupForManagePageQuery, GetChannelGroupForManagePageQueryVariables> {
    document = GetChannelGroupForManagePageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateChannelGroupDocument = gql`
    mutation updateChannelGroup($input: UpdateChannelGroupInput!) {
  updateChannelGroup(input: $input) {
    isSuccessful
    channelGroup {
      id
      name
      createdAt
      updatedAt
      channels {
        id
      }
      profile {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateChannelGroupGQL extends Apollo.Mutation<UpdateChannelGroupMutation, UpdateChannelGroupMutationVariables> {
    document = UpdateChannelGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteChannelGroupDocument = gql`
    mutation deleteChannelGroup($id: ID!) {
  deleteChannelGroup(id: $id) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteChannelGroupGQL extends Apollo.Mutation<DeleteChannelGroupMutation, DeleteChannelGroupMutationVariables> {
    document = DeleteChannelGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileChannelGroupsDocument = gql`
    query getProfileChannelGroups($id: ID!, $name: String, $findExact: Boolean, $excludeId: ID) {
  profile(id: $id) {
    id
    channelGroups(name: $name, findExact: $findExact, excludeId: $excludeId) {
      id
      name
      createdAt
      updatedAt
      channels {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileChannelGroupsGQL extends Apollo.Query<GetProfileChannelGroupsQuery, GetProfileChannelGroupsQueryVariables> {
    document = GetProfileChannelGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelDocument = gql`
    query getChannel($id: ID!) {
  channel(id: $id) {
    ...channelsForChannelList
  }
}
    ${ChannelsForChannelListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelGQL extends Apollo.Query<GetChannelQuery, GetChannelQueryVariables> {
    document = GetChannelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelForChannelDetailDocument = gql`
    query getChannelForChannelDetail($id: ID!) {
  channel(id: $id) {
    id
    name
    description
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelForChannelDetailGQL extends Apollo.Query<GetChannelForChannelDetailQuery, GetChannelForChannelDetailQueryVariables> {
    document = GetChannelForChannelDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileChannelsForChannelListDocument = gql`
    query getProfileChannelsForChannelList($id: ID!, $type: ChannelType, $name: String) {
  profile(id: $id) {
    id
    channels(type: $type, name: $name) {
      ...channelsForChannelList
    }
  }
}
    ${ChannelsForChannelListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileChannelsForChannelListGQL extends Apollo.Query<GetProfileChannelsForChannelListQuery, GetProfileChannelsForChannelListQueryVariables> {
    document = GetProfileChannelsForChannelListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelsForChannelListDocument = gql`
    query getChannelsForChannelList($page: Int, $pageSize: Int, $name: String) {
  channels(page: $page, pageSize: $pageSize, name: $name) {
    total
    results {
      ...channelsForChannelList
    }
  }
}
    ${ChannelsForChannelListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelsForChannelListGQL extends Apollo.Query<GetChannelsForChannelListQuery, GetChannelsForChannelListQueryVariables> {
    document = GetChannelsForChannelListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventsListDocument = gql`
    query getEventsList($profileId: ID!, $deviceId: ID) {
  profile(id: $profileId) {
    events(deviceId: $deviceId) {
      ...eventForList
    }
  }
}
    ${EventForListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEventsListGQL extends Apollo.Query<GetEventsListQuery, GetEventsListQueryVariables> {
    document = GetEventsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelGroupChannelsForChannelListDocument = gql`
    query getChannelGroupChannelsForChannelList($id: ID!, $name: String) {
  channelGroup(id: $id) {
    id
    channels(name: $name) {
      ...channelsForChannelList
    }
  }
}
    ${ChannelsForChannelListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelGroupChannelsForChannelListGQL extends Apollo.Query<GetChannelGroupChannelsForChannelListQuery, GetChannelGroupChannelsForChannelListQueryVariables> {
    document = GetChannelGroupChannelsForChannelListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLocationChannelsForChannelListDocument = gql`
    query getLocationChannelsForChannelList($id: ID!, $name: String) {
  location(id: $id) {
    id
    channels(name: $name) {
      ...channelsForChannelList
    }
  }
}
    ${ChannelsForChannelListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLocationChannelsForChannelListGQL extends Apollo.Query<GetLocationChannelsForChannelListQuery, GetLocationChannelsForChannelListQueryVariables> {
    document = GetLocationChannelsForChannelListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileUserChannelsDocument = gql`
    query getProfileUserChannels($id: ID!, $name: String, $userId: ID) {
  profile(id: $id) {
    id
    users(userId: $userId) {
      id
      channels(name: $name) {
        ...channelsForChannelList
      }
    }
  }
}
    ${ChannelsForChannelListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileUserChannelsGQL extends Apollo.Query<GetProfileUserChannelsQuery, GetProfileUserChannelsQueryVariables> {
    document = GetProfileUserChannelsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelPlaylistRegionsDocument = gql`
    query getChannelPlaylistRegions($channelId: ID!) {
  channel(id: $channelId) {
    id
    playlistRegions {
      playlistId
      region
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelPlaylistRegionsGQL extends Apollo.Query<GetChannelPlaylistRegionsQuery, GetChannelPlaylistRegionsQueryVariables> {
    document = GetChannelPlaylistRegionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelForManagePageDocument = gql`
    query getChannelForManagePage($id: ID!) {
  channel(id: $id) {
    id
    name
    description
    createdAt
    updatedAt
    layout {
      ...layoutDetailed
    }
  }
}
    ${LayoutDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelForManagePageGQL extends Apollo.Query<GetChannelForManagePageQuery, GetChannelForManagePageQueryVariables> {
    document = GetChannelForManagePageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileForChannelManagePageDocument = gql`
    query getProfileForChannelManagePage($id: ID!) {
  profile(id: $id) {
    id
    name
    locations {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileForChannelManagePageGQL extends Apollo.Query<GetProfileForChannelManagePageQuery, GetProfileForChannelManagePageQueryVariables> {
    document = GetProfileForChannelManagePageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateChannelDocument = gql`
    mutation updateChannel($input: UpdateChannelInput!) {
  updateChannel(input: $input) {
    isSuccessful
    channel {
      id
      name
      description
      layout {
        ...layoutDetailed
      }
      createdAt
      updatedAt
    }
  }
}
    ${LayoutDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateChannelGQL extends Apollo.Mutation<UpdateChannelMutation, UpdateChannelMutationVariables> {
    document = UpdateChannelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteChannelDocument = gql`
    mutation deleteChannel($id: ID!) {
  deleteChannel(id: $id) {
    isSuccessful
    rowsAffected
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteChannelGQL extends Apollo.Mutation<DeleteChannelMutation, DeleteChannelMutationVariables> {
    document = DeleteChannelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignChannelPlaylistRegionDocument = gql`
    mutation assignChannelPlaylistRegion($input: UpdatePlaylistRegionInput!) {
  assignChannelPlaylistRegion(input: $input) {
    isSuccessful
    playlistRegions {
      channelId
      playlistId
      region
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignChannelPlaylistRegionGQL extends Apollo.Mutation<AssignChannelPlaylistRegionMutation, AssignChannelPlaylistRegionMutationVariables> {
    document = AssignChannelPlaylistRegionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileDevicesResolutionDocument = gql`
    query getProfileDevicesResolution($profileId: ID!) {
  profile(id: $profileId) {
    id
    devices {
      id
      name
      width
      height
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileDevicesResolutionGQL extends Apollo.Query<GetProfileDevicesResolutionQuery, GetProfileDevicesResolutionQueryVariables> {
    document = GetProfileDevicesResolutionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VerifyDeviceDocument = gql`
    mutation verifyDevice($input: VerifyDeviceInput!) {
  verifyDevice(input: $input) {
    isSuccessful
    deviceUid
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VerifyDeviceGQL extends Apollo.Mutation<VerifyDeviceMutation, VerifyDeviceMutationVariables> {
    document = VerifyDeviceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceForDeviceListDocument = gql`
    query getDeviceForDeviceList($page: Int, $pageSize: Int) {
  devices(page: $page, pageSize: $pageSize) {
    total
    results {
      ...DevicesForDeviceList
    }
  }
}
    ${DevicesForDeviceListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceForDeviceListGQL extends Apollo.Query<GetDeviceForDeviceListQuery, GetDeviceForDeviceListQueryVariables> {
    document = GetDeviceForDeviceListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileDevicesForDeviceListDocument = gql`
    query getProfileDevicesForDeviceList($profileId: ID!, $deviceName: String) {
  profile(id: $profileId) {
    id
    name
    devices(name: $deviceName) {
      ...DevicesForDeviceList
    }
  }
}
    ${DevicesForDeviceListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileDevicesForDeviceListGQL extends Apollo.Query<GetProfileDevicesForDeviceListQuery, GetProfileDevicesForDeviceListQueryVariables> {
    document = GetProfileDevicesForDeviceListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelDevicesForDeviceListDocument = gql`
    query getChannelDevicesForDeviceList($channelId: ID!, $deviceName: String) {
  channel(id: $channelId) {
    id
    name
    devices(name: $deviceName) {
      ...DevicesForDeviceList
    }
  }
}
    ${DevicesForDeviceListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelDevicesForDeviceListGQL extends Apollo.Query<GetChannelDevicesForDeviceListQuery, GetChannelDevicesForDeviceListQueryVariables> {
    document = GetChannelDevicesForDeviceListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDeprovisionedDeviceDocument = gql`
    mutation deleteDeprovisionedDevice($id: String!) {
  deleteDeprovisionedDevice(id: $id) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDeprovisionedDeviceGQL extends Apollo.Mutation<DeleteDeprovisionedDeviceMutation, DeleteDeprovisionedDeviceMutationVariables> {
    document = DeleteDeprovisionedDeviceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceForManageDevicePageDocument = gql`
    query getDeviceForManageDevicePage($id: ID!) {
  device(id: $id) {
    ...DeviceForManage
  }
}
    ${DeviceForManageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceForManageDevicePageGQL extends Apollo.Query<GetDeviceForManageDevicePageQuery, GetDeviceForManageDevicePageQueryVariables> {
    document = GetDeviceForManageDevicePageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceMonitorHistoryDocument = gql`
    query getDeviceMonitorHistory($id: ID!) {
  device(id: $id) {
    monitorHistory {
      ...MonitorRecord
    }
    statusHistory {
      ...StatusRecord
    }
  }
}
    ${MonitorRecordFragmentDoc}
${StatusRecordFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceMonitorHistoryGQL extends Apollo.Query<GetDeviceMonitorHistoryQuery, GetDeviceMonitorHistoryQueryVariables> {
    document = GetDeviceMonitorHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDeviceSubscriptionDocument = gql`
    subscription updateDeviceSubscription($id: ID) {
  updateDevice(id: $id) {
    isSuccessful
    device {
      ...DeviceForManage
    }
  }
}
    ${DeviceForManageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDeviceSubscriptionGQL extends Apollo.Subscription<UpdateDeviceSubscriptionSubscription, UpdateDeviceSubscriptionSubscriptionVariables> {
    document = UpdateDeviceSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InitDeviceDocument = gql`
    mutation initDevice($input: InitDeviceInput!) {
  initDevice(input: $input) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InitDeviceGQL extends Apollo.Mutation<InitDeviceMutation, InitDeviceMutationVariables> {
    document = InitDeviceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProvisionDeviceDocument = gql`
    mutation provisionDevice($input: ProvisionDeviceInput!) {
  provisionDevice(input: $input) {
    isSuccessful
    device {
      ...DeviceForManage
    }
  }
}
    ${DeviceForManageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProvisionDeviceGQL extends Apollo.Mutation<ProvisionDeviceMutation, ProvisionDeviceMutationVariables> {
    document = ProvisionDeviceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileDevicesForMapDocument = gql`
    query getProfileDevicesForMap($id: ID!) {
  profile(id: $id) {
    id
    devices {
      ...DeviceBase
    }
  }
}
    ${DeviceBaseFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileDevicesForMapGQL extends Apollo.Query<GetProfileDevicesForMapQuery, GetProfileDevicesForMapQueryVariables> {
    document = GetProfileDevicesForMapDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSingleDeviceForMapDocument = gql`
    query getSingleDeviceForMap($id: ID!) {
  device(id: $id) {
    ...DeviceBase
  }
}
    ${DeviceBaseFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSingleDeviceForMapGQL extends Apollo.Query<GetSingleDeviceForMapQuery, GetSingleDeviceForMapQueryVariables> {
    document = GetSingleDeviceForMapDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetDevicePowerActionDocument = gql`
    mutation setDevicePowerAction($uid: ID!, $devicePowerAction: DevicePowerAction!) {
  powerAction(uid: $uid, devicePowerAction: $devicePowerAction) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDevicePowerActionGQL extends Apollo.Mutation<SetDevicePowerActionMutation, SetDevicePowerActionMutationVariables> {
    document = SetDevicePowerActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDeviceAdvancedSettingsDocument = gql`
    mutation updateDeviceAdvancedSettings($input: UpdateDeviceInput!) {
  updateDevice(input: $input) {
    isSuccessful
    device {
      ...DeviceForManage
    }
  }
}
    ${DeviceForManageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDeviceAdvancedSettingsGQL extends Apollo.Mutation<UpdateDeviceAdvancedSettingsMutation, UpdateDeviceAdvancedSettingsMutationVariables> {
    document = UpdateDeviceAdvancedSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDeviceDocument = gql`
    mutation updateDevice($input: UpdateDeviceInput!) {
  updateDevice(input: $input) {
    isSuccessful
    device {
      id
      name
      updatedAt
      width
      height
      channel {
        id
        name
      }
      signageOSDevice {
        name
        createdAt
        aliveAt
        applicationType
        applicationVersion
        firmwareVersion
        frontDisplayVersion
        model
        serialNumber
        batteryStatus {
          chargeType
          isCharging
          lastChargingTime
          percentage
          updatedAt
        }
        currentTime {
          time
          timezone
          updatedAt
        }
      }
      profile {
        id
        channels {
          id
          name
        }
        locations {
          id
          name
        }
      }
      channel {
        id
        name
        description
      }
      advancedSettings {
        ...AdvancedSettingsDetailed
      }
      locationId
      location {
        id
        name
      }
      coordinates {
        x
        y
      }
    }
  }
}
    ${AdvancedSettingsDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDeviceGQL extends Apollo.Mutation<UpdateDeviceMutation, UpdateDeviceMutationVariables> {
    document = UpdateDeviceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDeviceCoordinatesDocument = gql`
    mutation updateDeviceCoordinates($input: UpdateDeviceCoordinatesInput!) {
  updateDeviceCoordinates(input: $input) {
    isSuccessful
    device {
      id
      coordinates {
        x
        y
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDeviceCoordinatesGQL extends Apollo.Mutation<UpdateDeviceCoordinatesMutation, UpdateDeviceCoordinatesMutationVariables> {
    document = UpdateDeviceCoordinatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDeviceDocument = gql`
    mutation deleteDevice($id: String!) {
  deleteDevice(id: $id) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDeviceGQL extends Apollo.Mutation<DeleteDeviceMutation, DeleteDeviceMutationVariables> {
    document = DeleteDeviceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileForDeviceFormDocument = gql`
    query getProfileForDeviceForm($profileId: ID!) {
  profile(id: $profileId) {
    id
    name
    channels {
      ...DeviceVerificationChannelOption
    }
    locations {
      id
      name
    }
  }
}
    ${DeviceVerificationChannelOptionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileForDeviceFormGQL extends Apollo.Query<GetProfileForDeviceFormQuery, GetProfileForDeviceFormQueryVariables> {
    document = GetProfileForDeviceFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLocationForLocationManagePageDocument = gql`
    query getLocationForLocationManagePage($id: ID!) {
  location(id: $id) {
    id
    name
    streetAddress1
    streetAddress2
    zip
    phoneNumber
    country
    region
    city
    updatedAt
    createdAt
    coordinates {
      x
      y
    }
    channels {
      id
      name
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLocationForLocationManagePageGQL extends Apollo.Query<GetLocationForLocationManagePageQuery, GetLocationForLocationManagePageQueryVariables> {
    document = GetLocationForLocationManagePageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLocationDocument = gql`
    mutation updateLocation($input: UpdateLocationInput!) {
  updateLocation(input: $input) {
    isSuccessful
    location {
      id
      name
      streetAddress1
      streetAddress2
      zip
      phoneNumber
      country
      region
      city
      updatedAt
      createdAt
      coordinates {
        x
        y
      }
      channels {
        id
        name
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLocationGQL extends Apollo.Mutation<UpdateLocationMutation, UpdateLocationMutationVariables> {
    document = UpdateLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLocationDocument = gql`
    mutation deleteLocation($input: DeleteLocationInput!) {
  deleteLocation(input: $input) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLocationGQL extends Apollo.Mutation<DeleteLocationMutation, DeleteLocationMutationVariables> {
    document = DeleteLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLocationDocument = gql`
    mutation createLocation($input: CreateLocationInput!) {
  createLocation(input: $input) {
    isSuccessful
    location {
      id
      name
      streetAddress1
      streetAddress2
      zip
      phoneNumber
      country
      region
      city
      updatedAt
      createdAt
      coordinates {
        x
        y
      }
      channels {
        id
        name
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLocationGQL extends Apollo.Mutation<CreateLocationMutation, CreateLocationMutationVariables> {
    document = CreateLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLocationDocument = gql`
    query getLocation($id: ID!) {
  location(id: $id) {
    ...ProfileLocations
  }
}
    ${ProfileLocationsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLocationGQL extends Apollo.Query<GetLocationQuery, GetLocationQueryVariables> {
    document = GetLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileLocationsDocument = gql`
    query getProfileLocations($profileId: ID!, $name: String, $findExact: Boolean, $excludeId: ID) {
  profile(id: $profileId) {
    id
    name
    locations(name: $name, findExact: $findExact, excludeId: $excludeId) {
      ...ProfileLocations
    }
  }
}
    ${ProfileLocationsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileLocationsGQL extends Apollo.Query<GetProfileLocationsQuery, GetProfileLocationsQueryVariables> {
    document = GetProfileLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNotificationStatusDocument = gql`
    mutation updateNotificationStatus($input: NotificationStatusInput!) {
  updateNotificationStatus(input: $input) {
    isSuccessful
    notification {
      id
      title
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNotificationStatusGQL extends Apollo.Mutation<UpdateNotificationStatusMutation, UpdateNotificationStatusMutationVariables> {
    document = UpdateNotificationStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBulkNotificationStatusDocument = gql`
    mutation updateBulkNotificationStatus($input: BulkNotificationStatusInput!) {
  updateBulkNotificationStatus(input: $input) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBulkNotificationStatusGQL extends Apollo.Mutation<UpdateBulkNotificationStatusMutation, UpdateBulkNotificationStatusMutationVariables> {
    document = UpdateBulkNotificationStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotificationsDocument = gql`
    query getNotifications($page: Int, $pageSize: Int, $filter: FilterOptionsInput) {
  notifications(page: $page, pageSize: $pageSize, filter: $filter) {
    total
    results {
      id
      createdAt
      title
      message
      referenceId
      content {
        ... on MediaUploadNotificationContent {
          id
          name
          resourceType
          type
          url
        }
        ... on MediaUploadLargeNotificationContent {
          name
          publicId
          resourceType
          status
          type
        }
        ... on MediaUploadFailedNotificationContent {
          name
          resourceType
          type
          filepath
          folder
          folderGroupType
          tempFilename
        }
        ... on DeviceStatusNotificationContent {
          id
          name
          type
          status
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotificationsGQL extends Apollo.Query<GetNotificationsQuery, GetNotificationsQueryVariables> {
    document = GetNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NewNotificationSubscriptionDocument = gql`
    subscription newNotificationSubscription($userId: ID!, $profileId: ID, $contentTypes: [NotificationContentType!]!) {
  newNotification(
    userId: $userId
    profileId: $profileId
    contentTypes: $contentTypes
  ) {
    isSuccessful
    notification {
      id
      createdAt
      title
      message
      referenceId
      content {
        ... on MediaUploadNotificationContent {
          id
          name
          resourceType
          url
          type
        }
        ... on MediaUploadLargeNotificationContent {
          name
          publicId
          resourceType
          status
          type
        }
        ... on MediaUploadFailedNotificationContent {
          name
          resourceType
          type
          filepath
          folder
          folderGroupType
          tempFilename
        }
        ... on DeviceStatusNotificationContent {
          id
          name
          type
          status
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NewNotificationSubscriptionGQL extends Apollo.Subscription<NewNotificationSubscriptionSubscription, NewNotificationSubscriptionSubscriptionVariables> {
    document = NewNotificationSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNotificationSubscriptionDocument = gql`
    subscription updateNotificationSubscription($userId: ID!, $profileId: ID) {
  updateNotification(userId: $userId, profileId: $profileId) {
    isSuccessful
    notification {
      id
      createdAt
      title
      message
      referenceId
      content {
        ... on MediaUploadNotificationContent {
          id
          name
          resourceType
          url
          type
        }
        ... on MediaUploadLargeNotificationContent {
          publicId
          resourceType
          status
          type
        }
        ... on DeviceStatusNotificationContent {
          id
          name
          type
          status
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNotificationSubscriptionGQL extends Apollo.Subscription<UpdateNotificationSubscriptionSubscription, UpdateNotificationSubscriptionSubscriptionVariables> {
    document = UpdateNotificationSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBulkNotificationSubscriptionDocument = gql`
    subscription updateBulkNotificationSubscription($userId: ID!, $profileId: ID, $contentTypes: [NotificationContentType!]) {
  updateBulkNotification(
    userId: $userId
    profileId: $profileId
    contentTypes: $contentTypes
  ) {
    isSuccessful
    notifications {
      id
      createdAt
      title
      message
      referenceId
      content {
        ... on MediaUploadNotificationContent {
          id
          name
          resourceType
          url
          type
        }
        ... on MediaUploadLargeNotificationContent {
          publicId
          resourceType
          status
          type
        }
        ... on DeviceStatusNotificationContent {
          id
          name
          type
          status
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBulkNotificationSubscriptionGQL extends Apollo.Subscription<UpdateBulkNotificationSubscriptionSubscription, UpdateBulkNotificationSubscriptionSubscriptionVariables> {
    document = UpdateBulkNotificationSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NewMediaSubscriptionDocument = gql`
    subscription newMediaSubscription($userId: ID, $profileId: ID) {
  newMedia(userId: $userId, profileId: $profileId) {
    isSuccessful
    media {
      ...MediaForMediaList
    }
    profileId
  }
}
    ${MediaForMediaListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class NewMediaSubscriptionGQL extends Apollo.Subscription<NewMediaSubscriptionSubscription, NewMediaSubscriptionSubscriptionVariables> {
    document = NewMediaSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMediaSubscriptionDocument = gql`
    subscription updateMediaSubscription($id: ID) {
  updateMedia(id: $id) {
    isSuccessful
    media {
      ...MediaForMediaList
    }
  }
}
    ${MediaForMediaListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMediaSubscriptionGQL extends Apollo.Subscription<UpdateMediaSubscriptionSubscription, UpdateMediaSubscriptionSubscriptionVariables> {
    document = UpdateMediaSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeDocument = gql`
    query me {
  me {
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGQL extends Apollo.Query<MeQuery, MeQueryVariables> {
    document = MeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMeProfilesDocument = gql`
    query getMeProfiles($page: Int, $pageSize: Int, $active: Boolean) {
  me {
    id
    profiles(page: $page, pageSize: $pageSize, active: $active) {
      total
      results {
        ...MeProfile
      }
    }
  }
}
    ${MeProfileFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMeProfilesGQL extends Apollo.Query<GetMeProfilesQuery, GetMeProfilesQueryVariables> {
    document = GetMeProfilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActiveProfileDetailsFromServerDocument = gql`
    query getActiveProfileDetailsFromServer($id: ID!) {
  profile(id: $id) {
    ...MeProfile
  }
}
    ${MeProfileFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActiveProfileDetailsFromServerGQL extends Apollo.Query<GetActiveProfileDetailsFromServerQuery, GetActiveProfileDetailsFromServerQueryVariables> {
    document = GetActiveProfileDetailsFromServerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveMediaFromCloudDocument = gql`
    mutation saveMediaFromCloud($input: SaveMediaInput!) {
  saveMedia(input: $input) {
    isSuccessful
    media {
      id
      publicId
      ownerId
      name
      url
      type
      visibility
      secureUrl
      source {
        publicId
        url
      }
      metadata {
        width
        height
        bytes
        resourceType
        format
        uploadedAt
        duration
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveMediaFromCloudGQL extends Apollo.Mutation<SaveMediaFromCloudMutation, SaveMediaFromCloudMutationVariables> {
    document = SaveMediaFromCloudDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMediaDocument = gql`
    mutation deleteMedia($id: ID!) {
  deleteMedia(id: $id) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMediaGQL extends Apollo.Mutation<DeleteMediaMutation, DeleteMediaMutationVariables> {
    document = DeleteMediaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMediaListDocument = gql`
    mutation deleteMediaList($ids: [ID!]!) {
  deleteMediaList(ids: $ids) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMediaListGQL extends Apollo.Mutation<DeleteMediaListMutation, DeleteMediaListMutationVariables> {
    document = DeleteMediaListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMediaDocument = gql`
    mutation updateMedia($input: UpdateMediaInput!) {
  updateMedia(input: $input) {
    isSuccessful
    media {
      id
      name
      publicId
      ownerId
      url
      type
      secureUrl
      createdAt
      type
      visibility
      source {
        publicId
        url
      }
      metadata {
        width
        height
        bytes
        resourceType
        format
        uploadedAt
        duration
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMediaGQL extends Apollo.Mutation<UpdateMediaMutation, UpdateMediaMutationVariables> {
    document = UpdateMediaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveMediaFolderDocument = gql`
    mutation moveMediaFolder($input: MoveMediaFolderInput!) {
  moveMediaFolder(input: $input) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveMediaFolderGQL extends Apollo.Mutation<MoveMediaFolderMutation, MoveMediaFolderMutationVariables> {
    document = MoveMediaFolderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMediaForMediaManagePageDocument = gql`
    query getMediaForMediaManagePage($id: ID!) {
  media(id: $id) {
    ...MediaDetailed
  }
}
    ${MediaDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMediaForMediaManagePageGQL extends Apollo.Query<GetMediaForMediaManagePageQuery, GetMediaForMediaManagePageQueryVariables> {
    document = GetMediaForMediaManagePageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCloudinarySignatureDocument = gql`
    query getCloudinarySignature($uploadForm: CloudinarySignableForm) {
  mediaCloudinarySignature(input: $uploadForm) {
    signature
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCloudinarySignatureGQL extends Apollo.Query<GetCloudinarySignatureQuery, GetCloudinarySignatureQueryVariables> {
    document = GetCloudinarySignatureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileMediaForMediaListDocument = gql`
    query getProfileMediaForMediaList($profileId: ID!, $filters: MediaFiltersInput, $options: MediaOptionsInput) {
  profile(id: $profileId) {
    id
    name
    media(filters: $filters, options: $options) {
      total
      results {
        ...MediaForMediaList
      }
    }
  }
}
    ${MediaForMediaListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileMediaForMediaListGQL extends Apollo.Query<GetProfileMediaForMediaListQuery, GetProfileMediaForMediaListQueryVariables> {
    document = GetProfileMediaForMediaListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileTemplatesDocument = gql`
    query getProfileTemplates($profileId: ID!, $filters: MediaFiltersInput, $options: MediaOptionsInput) {
  profile(id: $profileId) {
    id
    name
    template(filters: $filters, options: $options) {
      total
      results {
        ...MediaForMediaList
      }
    }
  }
}
    ${MediaForMediaListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileTemplatesGQL extends Apollo.Query<GetProfileTemplatesQuery, GetProfileTemplatesQueryVariables> {
    document = GetProfileTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserMediaForMediaListDocument = gql`
    query getUserMediaForMediaList($userId: ID!, $filters: MediaFiltersInput, $options: MediaOptionsInput) {
  user(id: $userId) {
    id
    displayName
    media(filters: $filters, options: $options) {
      ...MediaForMediaList
    }
  }
}
    ${MediaForMediaListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserMediaForMediaListGQL extends Apollo.Query<GetUserMediaForMediaListQuery, GetUserMediaForMediaListQueryVariables> {
    document = GetUserMediaForMediaListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveNotificationDocument = gql`
    mutation saveNotification($input: NotificationInput!) {
  saveNotification(input: $input) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveNotificationGQL extends Apollo.Mutation<SaveNotificationMutation, SaveNotificationMutationVariables> {
    document = SaveNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrganizationsForOrganizationListDocument = gql`
    query getOrganizationsForOrganizationList($page: Int, $pageSize: Int, $name: String, $active: Boolean, $title: String, $findExact: Boolean) {
  organizations(
    page: $page
    pageSize: $pageSize
    name: $name
    active: $active
    findExact: $findExact
    title: $title
  ) {
    total
    results {
      id
      name
      organizationUid
      title
      active
      createdAt
      updatedAt
      devices {
        id
        name
      }
      profiles(active: $active, name: $name) {
        total
        results {
          id
          name
          updatedAt
          createdAt
          active
          organizationUid
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrganizationsForOrganizationListGQL extends Apollo.Query<GetOrganizationsForOrganizationListQuery, GetOrganizationsForOrganizationListQueryVariables> {
    document = GetOrganizationsForOrganizationListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllOrganizationsForOrganizationSelectionDocument = gql`
    query getAllOrganizationsForOrganizationSelection($name: String, $active: Boolean, $title: String) {
  organizations(name: $name, active: $active, title: $title) {
    total
    results {
      id
      name
      title
      organizationUid
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllOrganizationsForOrganizationSelectionGQL extends Apollo.Query<GetAllOrganizationsForOrganizationSelectionQuery, GetAllOrganizationsForOrganizationSelectionQueryVariables> {
    document = GetAllOrganizationsForOrganizationSelectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrganizationDocument = gql`
    mutation createOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    isSuccessful
    organization {
      id
      organizationUid
      name
      active
      title
      createdAt
      updatedAt
      devices {
        id
        name
      }
      profiles {
        results {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrganizationGQL extends Apollo.Mutation<CreateOrganizationMutation, CreateOrganizationMutationVariables> {
    document = CreateOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    isSuccessful
    organization {
      active
      id
      name
      organizationUid
      title
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrganizationGQL extends Apollo.Mutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables> {
    document = UpdateOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteOrganizationDocument = gql`
    mutation deleteOrganization($id: ID!) {
  deleteOrganization(id: $id) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteOrganizationGQL extends Apollo.Mutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables> {
    document = DeleteOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemovePlaylistsFromChannelDocument = gql`
    mutation removePlaylistsFromChannel($input: RemovePlaylistsFromChannelInput!) {
  removePlaylistsFromChannel(input: $input) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemovePlaylistsFromChannelGQL extends Apollo.Mutation<RemovePlaylistsFromChannelMutation, RemovePlaylistsFromChannelMutationVariables> {
    document = RemovePlaylistsFromChannelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDevicePingPlaylistsInfoDocument = gql`
    query getDevicePingPlaylistsInfo($id: ID!) {
  devicePings(id: $id) {
    results {
      timestamp
      playlistsInfo {
        lastUpdated
        playlistId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDevicePingPlaylistsInfoGQL extends Apollo.Query<GetDevicePingPlaylistsInfoQuery, GetDevicePingPlaylistsInfoQueryVariables> {
    document = GetDevicePingPlaylistsInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePlaylistsDocument = gql`
    mutation deletePlaylists($ids: [ID!]!) {
  deletePlaylists(ids: $ids) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePlaylistsGQL extends Apollo.Mutation<DeletePlaylistsMutation, DeletePlaylistsMutationVariables> {
    document = DeletePlaylistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicatePlaylistsDocument = gql`
    mutation duplicatePlaylists($ids: [ID!]!) {
  duplicatePlaylists(ids: $ids) {
    isSuccessful
    playlistIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicatePlaylistsGQL extends Apollo.Mutation<DuplicatePlaylistsMutation, DuplicatePlaylistsMutationVariables> {
    document = DuplicatePlaylistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkActionPlaylistsDocument = gql`
    mutation bulkActionPlaylists($ids: [String!]!, $action: PlaylistBulkAction!, $input: BulkActionPlaylistInput!) {
  bulkActionPlaylists(ids: $ids, action: $action, input: $input) {
    updateResults {
      isSuccessful
      playlistId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkActionPlaylistsGQL extends Apollo.Mutation<BulkActionPlaylistsMutation, BulkActionPlaylistsMutationVariables> {
    document = BulkActionPlaylistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPlaylistsForPlaylistListDocument = gql`
    query getPlaylistsForPlaylistList($page: Int, $pageSize: Int, $name: String, $statuses: [PlaylistStatus!], $onlyParentPlaylist: Boolean) {
  playlists(
    page: $page
    pageSize: $pageSize
    name: $name
    statuses: $statuses
    onlyParentPlaylist: $onlyParentPlaylist
  ) {
    total
    results {
      ...PlaylistForPlaylistList
    }
  }
}
    ${PlaylistForPlaylistListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlaylistsForPlaylistListGQL extends Apollo.Query<GetPlaylistsForPlaylistListQuery, GetPlaylistsForPlaylistListQueryVariables> {
    document = GetPlaylistsForPlaylistListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfilePlaylistsDocument = gql`
    query getProfilePlaylists($profileId: ID!, $playlistId: ID, $playlistName: String, $statuses: [PlaylistStatus!], $contentId: String, $onlyParentPlaylist: Boolean) {
  profile(id: $profileId) {
    id
    name
    playlists(
      id: $playlistId
      name: $playlistName
      statuses: $statuses
      contentId: $contentId
      onlyParentPlaylist: $onlyParentPlaylist
    ) {
      ...PlaylistForPlaylistList
    }
  }
}
    ${PlaylistForPlaylistListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfilePlaylistsGQL extends Apollo.Query<GetProfilePlaylistsQuery, GetProfilePlaylistsQueryVariables> {
    document = GetProfilePlaylistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDevicePlaylistsDocument = gql`
    query getDevicePlaylists($deviceId: ID!, $playlistName: String, $statuses: [PlaylistStatus!], $onlyParentPlaylist: Boolean) {
  device(id: $deviceId) {
    id
    name
    playlists(
      name: $playlistName
      statuses: $statuses
      onlyParentPlaylist: $onlyParentPlaylist
    ) {
      ...PlaylistForPlaylistList
    }
  }
}
    ${PlaylistForPlaylistListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDevicePlaylistsGQL extends Apollo.Query<GetDevicePlaylistsQuery, GetDevicePlaylistsQueryVariables> {
    document = GetDevicePlaylistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelPlaylistsDocument = gql`
    query getChannelPlaylists($channelId: ID!, $playlistName: String, $statuses: [PlaylistStatus!], $onlyParentPlaylist: Boolean) {
  channel(id: $channelId) {
    id
    name
    playlistRegions {
      channelId
      playlistId
      region
    }
    playlists(
      name: $playlistName
      statuses: $statuses
      onlyParentPlaylist: $onlyParentPlaylist
    ) {
      ...DetailedPlaylistForChannel
    }
  }
}
    ${DetailedPlaylistForChannelFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelPlaylistsGQL extends Apollo.Query<GetChannelPlaylistsQuery, GetChannelPlaylistsQueryVariables> {
    document = GetChannelPlaylistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLocationPlaylistsDocument = gql`
    query getLocationPlaylists($locationId: ID!, $playlistName: String, $statuses: [PlaylistStatus!], $onlyParentPlaylist: Boolean) {
  location(id: $locationId) {
    id
    name
    playlists(
      name: $playlistName
      statuses: $statuses
      onlyParentPlaylist: $onlyParentPlaylist
    ) {
      ...PlaylistForPlaylistList
    }
  }
}
    ${PlaylistForPlaylistListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLocationPlaylistsGQL extends Apollo.Query<GetLocationPlaylistsQuery, GetLocationPlaylistsQueryVariables> {
    document = GetLocationPlaylistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelGroupPlaylistsDocument = gql`
    query getChannelGroupPlaylists($channelGroupId: ID!, $playlistName: String, $statuses: [PlaylistStatus!], $onlyParentPlaylist: Boolean) {
  channelGroup(id: $channelGroupId) {
    id
    name
    playlists(
      name: $playlistName
      statuses: $statuses
      onlyParentPlaylist: $onlyParentPlaylist
    ) {
      ...PlaylistForPlaylistList
    }
  }
}
    ${PlaylistForPlaylistListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelGroupPlaylistsGQL extends Apollo.Query<GetChannelGroupPlaylistsQuery, GetChannelGroupPlaylistsQueryVariables> {
    document = GetChannelGroupPlaylistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileUserChannelPlaylistsDocument = gql`
    query getProfileUserChannelPlaylists($profileId: ID!, $userId: ID!, $playlistName: String, $statuses: [PlaylistStatus!]) {
  profile(id: $profileId) {
    id
    users(userId: $userId) {
      id
      playlists(name: $playlistName, statuses: $statuses) {
        id
        ...PlaylistForPlaylistList
      }
      channels {
        ...ChannelToPlaylist
        playlists(name: $playlistName, statuses: $statuses) {
          ...PlaylistForPlaylistList
        }
      }
    }
  }
}
    ${PlaylistForPlaylistListFragmentDoc}
${ChannelToPlaylistFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileUserChannelPlaylistsGQL extends Apollo.Query<GetProfileUserChannelPlaylistsQuery, GetProfileUserChannelPlaylistsQueryVariables> {
    document = GetProfileUserChannelPlaylistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDetailedPlaylistDocument = gql`
    query getDetailedPlaylist($id: ID!) {
  playlist(id: $id) {
    ...DetailedPlaylist
  }
}
    ${DetailedPlaylistFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDetailedPlaylistGQL extends Apollo.Query<GetDetailedPlaylistQuery, GetDetailedPlaylistQueryVariables> {
    document = GetDetailedPlaylistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPlaylistDetailedDocument = gql`
    query GetPlaylistDetailed($id: ID!) {
  playlist(id: $id) {
    ...PlaylistDetailed
  }
}
    ${PlaylistDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlaylistDetailedGQL extends Apollo.Query<GetPlaylistDetailedQuery, GetPlaylistDetailedQueryVariables> {
    document = GetPlaylistDetailedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePlaylistDocument = gql`
    mutation deletePlaylist($id: ID!) {
  deletePlaylist(id: $id) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePlaylistGQL extends Apollo.Mutation<DeletePlaylistMutation, DeletePlaylistMutationVariables> {
    document = DeletePlaylistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAssetForSequenceDocument = gql`
    mutation createAssetForSequence($input: CreateAssetInput!) {
  createAsset(input: $input) {
    isSuccessful
    asset {
      ...AssetWithMediaForAssetManage
    }
  }
}
    ${AssetWithMediaForAssetManageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAssetForSequenceGQL extends Apollo.Mutation<CreateAssetForSequenceMutation, CreateAssetForSequenceMutationVariables> {
    document = CreateAssetForSequenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePlaylistDocument = gql`
    mutation createPlaylist($input: CreatePlaylistInput!) {
  createPlaylist(input: $input) {
    isSuccessful
    playlist {
      ...PlaylistDetailed
    }
  }
}
    ${PlaylistDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePlaylistGQL extends Apollo.Mutation<CreatePlaylistMutation, CreatePlaylistMutationVariables> {
    document = CreatePlaylistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePlaylistDocument = gql`
    mutation updatePlaylist($input: UpdatePlaylistInput!) {
  updatePlaylist(input: $input) {
    isSuccessful
    playlist {
      ...PlaylistDetailed
    }
  }
}
    ${PlaylistDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePlaylistGQL extends Apollo.Mutation<UpdatePlaylistMutation, UpdatePlaylistMutationVariables> {
    document = UpdatePlaylistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForcePublishDevicePlaylistDocument = gql`
    mutation forcePublishDevicePlaylist($ids: [String!]!, $action: PlaylistBulkAction!, $input: BulkActionPlaylistInput!) {
  bulkActionPlaylists(ids: $ids, action: $action, input: $input) {
    updateResults {
      isSuccessful
      playlistId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForcePublishDevicePlaylistGQL extends Apollo.Mutation<ForcePublishDevicePlaylistMutation, ForcePublishDevicePlaylistMutationVariables> {
    document = ForcePublishDevicePlaylistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublishChannelsContentDocument = gql`
    mutation publishChannelsContent($input: PublishChannelsInput!) {
  publishChannels(input: $input) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublishChannelsContentGQL extends Apollo.Mutation<PublishChannelsContentMutation, PublishChannelsContentMutationVariables> {
    document = PublishChannelsContentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPlaylistChildDocument = gql`
    query getPlaylistChild($id: ID!) {
  playlist(id: $id) {
    id
    childPlaylists {
      id
      name
      status
      updatedAt
      createdAt
      startDate
      endDate
      comment
      channels {
        ...ChannelToPlaylist
      }
    }
  }
}
    ${ChannelToPlaylistFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlaylistChildGQL extends Apollo.Query<GetPlaylistChildQuery, GetPlaylistChildQueryVariables> {
    document = GetPlaylistChildDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileForSettingsPageDocument = gql`
    query getProfileForSettingsPage($id: ID!) {
  profile(id: $id) {
    ...ProfileDetailed
  }
}
    ${ProfileDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileForSettingsPageGQL extends Apollo.Query<GetProfileForSettingsPageQuery, GetProfileForSettingsPageQueryVariables> {
    document = GetProfileForSettingsPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActivateProfileDocument = gql`
    mutation activateProfile($id: ID!) {
  activateProfile(id: $id) {
    isSuccessful
    profile {
      ...ProfileDetailed
    }
  }
}
    ${ProfileDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ActivateProfileGQL extends Apollo.Mutation<ActivateProfileMutation, ActivateProfileMutationVariables> {
    document = ActivateProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileForDetailPageDocument = gql`
    query getProfileForDetailPage($id: ID!) {
  profile(id: $id) {
    ...ProfileDetailed
  }
}
    ${ProfileDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileForDetailPageGQL extends Apollo.Query<GetProfileForDetailPageQuery, GetProfileForDetailPageQueryVariables> {
    document = GetProfileForDetailPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfilesForProfileListDocument = gql`
    query getProfilesForProfileList($page: Int, $pageSize: Int, $active: Boolean, $name: String) {
  profiles(page: $page, pageSize: $pageSize, active: $active, name: $name) {
    ...profilesForProfileList
  }
}
    ${ProfilesForProfileListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfilesForProfileListGQL extends Apollo.Query<GetProfilesForProfileListQuery, GetProfilesForProfileListQueryVariables> {
    document = GetProfilesForProfileListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserProfilesForProfileListDocument = gql`
    query getUserProfilesForProfileList($userId: ID!, $page: Int, $pageSize: Int, $active: Boolean, $name: String) {
  user(id: $userId) {
    id
    profiles(page: $page, pageSize: $pageSize, active: $active, name: $name) {
      ...profilesForProfileList
    }
  }
}
    ${ProfilesForProfileListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserProfilesForProfileListGQL extends Apollo.Query<GetUserProfilesForProfileListQuery, GetUserProfilesForProfileListQueryVariables> {
    document = GetUserProfilesForProfileListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllProfilesForProfileSelectionDocument = gql`
    query getAllProfilesForProfileSelection($active: Boolean, $name: String) {
  profiles(active: $active, name: $name) {
    total
    results {
      id
      name
      updatedAt
      createdAt
      active
      organizationUid
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllProfilesForProfileSelectionGQL extends Apollo.Query<GetAllProfilesForProfileSelectionQuery, GetAllProfilesForProfileSelectionQueryVariables> {
    document = GetAllProfilesForProfileSelectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileForProfileUsersPageDocument = gql`
    query getProfileForProfileUsersPage($id: ID!) {
  profile(id: $id) {
    ...ProfileDetailed
  }
}
    ${ProfileDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileForProfileUsersPageGQL extends Apollo.Query<GetProfileForProfileUsersPageQuery, GetProfileForProfileUsersPageQueryVariables> {
    document = GetProfileForProfileUsersPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrganizationProfilesForProfileListDocument = gql`
    query getOrganizationProfilesForProfileList($organizationId: ID!, $page: Int, $pageSize: Int, $active: Boolean, $name: String) {
  organization(id: $organizationId) {
    id
    profiles(page: $page, pageSize: $pageSize, active: $active, name: $name) {
      ...profilesForProfileList
    }
  }
}
    ${ProfilesForProfileListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrganizationProfilesForProfileListGQL extends Apollo.Query<GetOrganizationProfilesForProfileListQuery, GetOrganizationProfilesForProfileListQueryVariables> {
    document = GetOrganizationProfilesForProfileListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrganizationsForProfileSettingsPageDocument = gql`
    query getOrganizationsForProfileSettingsPage($name: String, $active: Boolean) {
  organizations(name: $name, active: $active) {
    total
    results {
      id
      name
      title
      organizationUid
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrganizationsForProfileSettingsPageGQL extends Apollo.Query<GetOrganizationsForProfileSettingsPageQuery, GetOrganizationsForProfileSettingsPageQueryVariables> {
    document = GetOrganizationsForProfileSettingsPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrganizationsForProfileCreatePageDocument = gql`
    query getOrganizationsForProfileCreatePage($name: String, $active: Boolean) {
  organizations(name: $name, active: $active) {
    total
    results {
      id
      name
      title
      organizationUid
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrganizationsForProfileCreatePageGQL extends Apollo.Query<GetOrganizationsForProfileCreatePageQuery, GetOrganizationsForProfileCreatePageQueryVariables> {
    document = GetOrganizationsForProfileCreatePageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProfileDocument = gql`
    mutation createProfile($input: CreateProfileInput!) {
  createProfile(input: $input) {
    isSuccessful
    profile {
      id
      name
      locations {
        id
        name
      }
      channels {
        id
        name
      }
      active
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProfileGQL extends Apollo.Mutation<CreateProfileMutation, CreateProfileMutationVariables> {
    document = CreateProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProfileDocument = gql`
    mutation updateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    isSuccessful
    profile {
      ...ProfileDetailed
      organization {
        id
        name
        active
        organizationUid
        title
        createdAt
        updatedAt
      }
    }
  }
}
    ${ProfileDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProfileGQL extends Apollo.Mutation<UpdateProfileMutation, UpdateProfileMutationVariables> {
    document = UpdateProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeactivateProfileDocument = gql`
    mutation deactivateProfile($id: ID!, $deleteOn: DateTime!) {
  deactivateProfile(id: $id, deleteOn: $deleteOn) {
    isSuccessful
    profile {
      id
      active
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeactivateProfileGQL extends Apollo.Mutation<DeactivateProfileMutation, DeactivateProfileMutationVariables> {
    document = DeactivateProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveProfileUserDocument = gql`
    mutation removeProfileUser($input: RemoveProfileUserInput!) {
  removeProfileUser(input: $input) {
    isSuccessful
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveProfileUserGQL extends Apollo.Mutation<RemoveProfileUserMutation, RemoveProfileUserMutationVariables> {
    document = RemoveProfileUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProfileUserRoleDocument = gql`
    mutation updateProfileUserRole($input: UpdateProfileUserRoleInput!) {
  updateProfileUserRole(input: $input) {
    isSuccessful
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProfileUserRoleGQL extends Apollo.Mutation<UpdateProfileUserRoleMutation, UpdateProfileUserRoleMutationVariables> {
    document = UpdateProfileUserRoleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InviteUserDocument = gql`
    mutation inviteUser($input: InviteUserInput!) {
  inviteUser(input: $input) {
    isSuccessful
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InviteUserGQL extends Apollo.Mutation<InviteUserMutation, InviteUserMutationVariables> {
    document = InviteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserFromRegistrationDocument = gql`
    mutation createUserFromRegistration($input: CreateUserInput!) {
  createUser(input: $input) {
    isSuccessful
    email
    profileName
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserFromRegistrationGQL extends Apollo.Mutation<CreateUserFromRegistrationMutation, CreateUserFromRegistrationMutationVariables> {
    document = CreateUserFromRegistrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExistingUserForRegistrationDocument = gql`
    query existingUserForRegistration($email: String!) {
  user(email: $email) {
    id
    displayName
    auth0Profile {
      user_id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExistingUserForRegistrationGQL extends Apollo.Query<ExistingUserForRegistrationQuery, ExistingUserForRegistrationQueryVariables> {
    document = ExistingUserForRegistrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProfileForRegistrationDocument = gql`
    query profileForRegistration($id: ID!) {
  profile(id: $id) {
    id
    name
    users {
      id
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProfileForRegistrationGQL extends Apollo.Query<ProfileForRegistrationQuery, ProfileForRegistrationQueryVariables> {
    document = ProfileForRegistrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileChannelsLocationsChannelGroupsForChannelSelectionDocument = gql`
    query getProfileChannelsLocationsChannelGroupsForChannelSelection($profileId: ID!, $userId: ID!, $channelName: String, $locationName: String, $channelGroupName: String, $locationId: String, $statuses: [PlaylistStatus!]) {
  profile(id: $profileId) {
    id
    users(userId: $userId) {
      id
      channels(name: $channelName) {
        id
        profile {
          id
        }
        name
        description
        playlists(statuses: $statuses) {
          id
          name
        }
      }
    }
    channels(name: $channelName, locationId: $locationId) {
      id
      name
      description
      playlists(statuses: $statuses) {
        id
        name
      }
    }
    locations(name: $locationName) {
      id
      name
      playlists(statuses: $statuses) {
        id
        name
      }
    }
    channelGroups(name: $channelGroupName) {
      id
      name
      playlists(statuses: $statuses) {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileChannelsLocationsChannelGroupsForChannelSelectionGQL extends Apollo.Query<GetProfileChannelsLocationsChannelGroupsForChannelSelectionQuery, GetProfileChannelsLocationsChannelGroupsForChannelSelectionQueryVariables> {
    document = GetProfileChannelsLocationsChannelGroupsForChannelSelectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileChannelsForChannelGroupDocument = gql`
    query getProfileChannelsForChannelGroup($profileId: ID!, $name: String) {
  profile(id: $profileId) {
    id
    channels(name: $name) {
      id
      name
      description
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileChannelsForChannelGroupGQL extends Apollo.Query<GetProfileChannelsForChannelGroupQuery, GetProfileChannelsForChannelGroupQueryVariables> {
    document = GetProfileChannelsForChannelGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRolesForUserInvitesDocument = gql`
    query getRolesForUserInvites {
  roles {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRolesForUserInvitesGQL extends Apollo.Query<GetRolesForUserInvitesQuery, GetRolesForUserInvitesQueryVariables> {
    document = GetRolesForUserInvitesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileMediaForMediaGalleryDocument = gql`
    query getProfileMediaForMediaGallery($profileId: ID!, $filters: MediaFiltersInput, $options: MediaOptionsInput) {
  profile(id: $profileId) {
    id
    name
    media(filters: $filters, options: $options) {
      total
      results {
        __typename
        ...MediaForMediaGallery
      }
    }
  }
}
    ${MediaForMediaGalleryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileMediaForMediaGalleryGQL extends Apollo.Query<GetProfileMediaForMediaGalleryQuery, GetProfileMediaForMediaGalleryQueryVariables> {
    document = GetProfileMediaForMediaGalleryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMediaMetadataDocument = gql`
    query getMediaMetadata($mediaId: ID!) {
  media(id: $mediaId) {
    metadata {
      duration
      bytes
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMediaMetadataGQL extends Apollo.Query<GetMediaMetadataQuery, GetMediaMetadataQueryVariables> {
    document = GetMediaMetadataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProfileUsersForProfileUserListDocument = gql`
    query profileUsersForProfileUserList($profileId: ID!, $name: String) {
  profile(id: $profileId) {
    id
    name
    users(name: $name) {
      ...UsersForUserList
    }
  }
}
    ${UsersForUserListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProfileUsersForProfileUserListGQL extends Apollo.Query<ProfileUsersForProfileUserListQuery, ProfileUsersForProfileUserListQueryVariables> {
    document = ProfileUsersForProfileUserListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserDetailsDocument = gql`
    query getUserDetails($id: ID!, $profilesPage: Int, $profilesPageSize: Int, $activeProfiles: Boolean, $profileName: String) {
  user(id: $id) {
    id
    displayName
    createdAt
    updatedAt
    active
    profiles(
      page: $profilesPage
      pageSize: $profilesPageSize
      active: $activeProfiles
      name: $profileName
    ) {
      results {
        id
        owner {
          id
        }
      }
    }
    media {
      id
      publicId
      url
      type
    }
    auth0Profile {
      ...Auth0ProfileDetailed
    }
    profilePicture {
      id
      url
    }
  }
}
    ${Auth0ProfileDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserDetailsGQL extends Apollo.Query<GetUserDetailsQuery, GetUserDetailsQueryVariables> {
    document = GetUserDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RolesDocument = gql`
    query roles {
  roles {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RolesGQL extends Apollo.Query<RolesQuery, RolesQueryVariables> {
    document = RolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActivateUserDocument = gql`
    mutation activateUser($id: ID!) {
  activateUser(id: $id) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActivateUserGQL extends Apollo.Mutation<ActivateUserMutation, ActivateUserMutationVariables> {
    document = ActivateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsersForUserListDocument = gql`
    query getUsersForUserList($page: Int, $pageSize: Int, $active: Boolean, $name: String) {
  users(page: $page, pageSize: $pageSize, active: $active, name: $name) {
    total
    results {
      id
      displayName
      createdAt
      updatedAt
      active
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsersForUserListGQL extends Apollo.Query<GetUsersForUserListQuery, GetUsersForUserListQueryVariables> {
    document = GetUsersForUserListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateChannelUsersDocument = gql`
    mutation updateChannelUsers($input: UpdateChannelUsersInput!) {
  updateChannelUsers(input: $input) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateChannelUsersGQL extends Apollo.Mutation<UpdateChannelUsersMutation, UpdateChannelUsersMutationVariables> {
    document = UpdateChannelUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileUsersDocument = gql`
    query getProfileUsers($id: ID!) {
  profile(id: $id) {
    id
    name
    users {
      id
      displayName
      active
      channels {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileUsersGQL extends Apollo.Query<GetProfileUsersQuery, GetProfileUsersQueryVariables> {
    document = GetProfileUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    isSuccessful
    user {
      id
      displayName
      createdAt
      updatedAt
      active
      auth0Profile {
        ...Auth0ProfileDetailed
      }
    }
  }
}
    ${Auth0ProfileDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeactivateUserDocument = gql`
    mutation deactivateUser($id: ID!) {
  deactivateUser(id: $id) {
    isSuccessful
    user {
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeactivateUserGQL extends Apollo.Mutation<DeactivateUserMutation, DeactivateUserMutationVariables> {
    document = DeactivateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangePasswordDocument = gql`
    mutation changePassword($input: ChangePasswordInput!) {
  changePassword(input: $input) {
    isSuccessful
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePasswordGQL extends Apollo.Mutation<ChangePasswordMutation, ChangePasswordMutationVariables> {
    document = ChangePasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeUserMfaDocument = gql`
    mutation changeUserMFA($input: ChangeUserMFAInput!) {
  changeUserMFA(input: $input) {
    isSuccessful
    auth0Profile {
      ...Auth0ProfileDetailed
    }
  }
}
    ${Auth0ProfileDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeUserMfaGQL extends Apollo.Mutation<ChangeUserMfaMutation, ChangeUserMfaMutationVariables> {
    document = ChangeUserMfaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateChannelDocument = gql`
    mutation createChannel($input: CreateChannelInput!) {
  createChannel(input: $input) {
    isSuccessful
    channel {
      id
      name
      description
      layout {
        ...layoutDetailed
      }
      createdAt
      updatedAt
    }
  }
}
    ${LayoutDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateChannelGQL extends Apollo.Mutation<CreateChannelMutation, CreateChannelMutationVariables> {
    document = CreateChannelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddPlaylistsToChannelsDocument = gql`
    mutation addPlaylistsToChannels($input: AddPlaylistsToChannelsInput) {
  addPlaylistsToChannels(input: $input) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddPlaylistsToChannelsGQL extends Apollo.Mutation<AddPlaylistsToChannelsMutation, AddPlaylistsToChannelsMutationVariables> {
    document = AddPlaylistsToChannelsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddDevicesToChannelDocument = gql`
    mutation addDevicesToChannel($input: AddDevicesToChannelInput!) {
  addDevicesToChannel(input: $input) {
    isSuccessful
    channel {
      id
      name
      devices {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddDevicesToChannelGQL extends Apollo.Mutation<AddDevicesToChannelMutation, AddDevicesToChannelMutationVariables> {
    document = AddDevicesToChannelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveDevicesFromChannelDocument = gql`
    mutation removeDevicesFromChannel($input: AddDevicesToChannelInput!) {
  removeDevicesFromChannel(input: $input) {
    isSuccessful
    channel {
      id
      name
      devices {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDevicesFromChannelGQL extends Apollo.Mutation<RemoveDevicesFromChannelMutation, RemoveDevicesFromChannelMutationVariables> {
    document = RemoveDevicesFromChannelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkActionDevicesDocument = gql`
    mutation bulkActionDevices($ids: [String!]!, $action: ChannelBulkAction!, $extra: String) {
  bulkActionDevices(ids: $ids, action: $action, extra: $extra) {
    isSuccessful
    devices {
      id
      advancedSettings {
        ...AdvancedSettingsDetailed
      }
      deviceInfo {
        appletVersion
      }
      signageOSDeviceTiming {
        appletVersion
        activeAppletVersion
      }
    }
  }
}
    ${AdvancedSettingsDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkActionDevicesGQL extends Apollo.Mutation<BulkActionDevicesMutation, BulkActionDevicesMutationVariables> {
    document = BulkActionDevicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFolderDocument = gql`
    mutation createFolder($input: CreateFolderInput!) {
  createFolder(input: $input) {
    isSuccessful
    folder {
      ...folder
    }
  }
}
    ${FolderFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFolderGQL extends Apollo.Mutation<CreateFolderMutation, CreateFolderMutationVariables> {
    document = CreateFolderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFolderDocument = gql`
    mutation deleteFolder($id: ID!) {
  deleteFolder(id: $id) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFolderGQL extends Apollo.Mutation<DeleteFolderMutation, DeleteFolderMutationVariables> {
    document = DeleteFolderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFolderListDocument = gql`
    mutation deleteFolderList($ids: [ID!]!) {
  deleteFolderList(ids: $ids) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFolderListGQL extends Apollo.Mutation<DeleteFolderListMutation, DeleteFolderListMutationVariables> {
    document = DeleteFolderListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFolderDocument = gql`
    mutation updateFolder($input: UpdateFolderInput!) {
  updateFolder(input: $input) {
    isSuccessful
    folder {
      ...folder
    }
  }
}
    ${FolderFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFolderGQL extends Apollo.Mutation<UpdateFolderMutation, UpdateFolderMutationVariables> {
    document = UpdateFolderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveFolderListToFolderDocument = gql`
    mutation moveFolderListToFolder($folderIds: [ID!]!, $destinationFolderId: ID) {
  moveFolderListToFolder(
    folderIds: $folderIds
    destinationFolderId: $destinationFolderId
  ) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveFolderListToFolderGQL extends Apollo.Mutation<MoveFolderListToFolderMutation, MoveFolderListToFolderMutationVariables> {
    document = MoveFolderListToFolderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileFoldersDocument = gql`
    query getProfileFolders($profileId: ID!) {
  profile(id: $profileId) {
    folders {
      ...folder
    }
  }
}
    ${FolderFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileFoldersGQL extends Apollo.Query<GetProfileFoldersQuery, GetProfileFoldersQueryVariables> {
    document = GetProfileFoldersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileFoldersWithMediasDocument = gql`
    query getProfileFoldersWithMedias($profileId: ID!) {
  profile(id: $profileId) {
    folders {
      ...folderWithMedias
    }
  }
}
    ${FolderWithMediasFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileFoldersWithMediasGQL extends Apollo.Query<GetProfileFoldersWithMediasQuery, GetProfileFoldersWithMediasQueryVariables> {
    document = GetProfileFoldersWithMediasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFolderByIdDocument = gql`
    query getFolderById($folderId: ID!) {
  folder(id: $folderId) {
    ...folder
  }
}
    ${FolderFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFolderByIdGQL extends Apollo.Query<GetFolderByIdQuery, GetFolderByIdQueryVariables> {
    document = GetFolderByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileLayoutsDocument = gql`
    query getProfileLayouts($profileId: ID!) {
  profile(id: $profileId) {
    layouts {
      ...layoutDetailed
    }
  }
}
    ${LayoutDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileLayoutsGQL extends Apollo.Query<GetProfileLayoutsQuery, GetProfileLayoutsQueryVariables> {
    document = GetProfileLayoutsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssignableLayoutsDocument = gql`
    query getAssignableLayouts($id: ID!) {
  profile(id: $id) {
    id
    assignableLayouts {
      ...layoutDetailed
    }
  }
}
    ${LayoutDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssignableLayoutsGQL extends Apollo.Query<GetAssignableLayoutsQuery, GetAssignableLayoutsQueryVariables> {
    document = GetAssignableLayoutsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLayoutByIdDocument = gql`
    query getLayoutById($layoutId: ID!) {
  layout(id: $layoutId) {
    ...layoutDetailed
  }
}
    ${LayoutDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLayoutByIdGQL extends Apollo.Query<GetLayoutByIdQuery, GetLayoutByIdQueryVariables> {
    document = GetLayoutByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLayoutDocument = gql`
    mutation createLayout($input: CreateLayoutInput!) {
  createLayout(input: $input) {
    isSuccessful
    layout {
      ...layoutDetailed
    }
  }
}
    ${LayoutDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLayoutGQL extends Apollo.Mutation<CreateLayoutMutation, CreateLayoutMutationVariables> {
    document = CreateLayoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLayoutDocument = gql`
    mutation updateLayout($input: UpdateLayoutInput!) {
  updateLayout(input: $input) {
    isSuccessful
    layout {
      ...layoutDetailed
    }
  }
}
    ${LayoutDetailedFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLayoutGQL extends Apollo.Mutation<UpdateLayoutMutation, UpdateLayoutMutationVariables> {
    document = UpdateLayoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLayoutDocument = gql`
    mutation deleteLayout($layoutId: ID!) {
  deleteLayout(id: $layoutId) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLayoutGQL extends Apollo.Mutation<DeleteLayoutMutation, DeleteLayoutMutationVariables> {
    document = DeleteLayoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateResourceGroupDocument = gql`
    mutation createResourceGroup($input: CreateResourceGroupInput!) {
  createResourceGroup(input: $input) {
    isSuccessful
    resourceGroup {
      ...resourceGroup
    }
  }
}
    ${ResourceGroupFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateResourceGroupGQL extends Apollo.Mutation<CreateResourceGroupMutation, CreateResourceGroupMutationVariables> {
    document = CreateResourceGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteResourceGroupDocument = gql`
    mutation deleteResourceGroup($id: ID!) {
  deleteResourceGroup(id: $id) {
    isSuccessful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteResourceGroupGQL extends Apollo.Mutation<DeleteResourceGroupMutation, DeleteResourceGroupMutationVariables> {
    document = DeleteResourceGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateResourceGroupDocument = gql`
    mutation updateResourceGroup($input: UpdateResourceGroupInput!) {
  updateResourceGroup(input: $input) {
    isSuccessful
    resourceGroup {
      ...resourceGroup
    }
  }
}
    ${ResourceGroupFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateResourceGroupGQL extends Apollo.Mutation<UpdateResourceGroupMutation, UpdateResourceGroupMutationVariables> {
    document = UpdateResourceGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetResourceGroupsByProfileIdDocument = gql`
    query getResourceGroupsByProfileId($id: ID!) {
  profile(id: $id) {
    id
    resourceGroups {
      ...resourceGroup
    }
  }
}
    ${ResourceGroupFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetResourceGroupsByProfileIdGQL extends Apollo.Query<GetResourceGroupsByProfileIdQuery, GetResourceGroupsByProfileIdQueryVariables> {
    document = GetResourceGroupsByProfileIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetResourcesByProfileIdDocument = gql`
    query getResourcesByProfileId($id: ID!) {
  profile(id: $id) {
    id
    users {
      ...userForResourceGroupUserList
    }
    playlists(onlyParentPlaylist: true) {
      ...playlistForResourceGroupPlaylistList
    }
  }
}
    ${UserForResourceGroupUserListFragmentDoc}
${PlaylistForResourceGroupPlaylistListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetResourcesByProfileIdGQL extends Apollo.Query<GetResourcesByProfileIdQuery, GetResourcesByProfileIdQueryVariables> {
    document = GetResourcesByProfileIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AssetItem": [
      "BrowserAsset",
      "HtmlAsset",
      "IFrameAsset",
      "ImageAsset",
      "VideoAsset",
      "WidgetAsset"
    ],
    "NotificationContent": [
      "ChannelDetailNotificationContent",
      "DeviceDeletionNotificationContent",
      "DeviceDetailNotificationContent",
      "DeviceStatusNotificationContent",
      "LocationDetailNotificationContent",
      "MediaUploadFailedNotificationContent",
      "MediaUploadLargeNotificationContent",
      "MediaUploadNotificationContent"
    ]
  }
};
      export default result;
    